(function() {
    'use strict';

    angular
    .module('app.pages.eventos.lancamentoestoque', ['md.data.table'])
    .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {

        $stateProvider
            .state('eventos.lancamentoestoque', {
               url: '/lancamentoestoque',
               templateUrl: 'app/main/pages/eventos/lancamentoestoque/index.html',
               controller: 'EventosLancamentoEstoqueController as lancamentoestoque' 
            });

        //Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/eventos/lancamentoestoque');

        msNavigationServiceProvider.saveItem('eventos.lancamentoestoque', {
            title: ' Lançamento de Estoque',
            icon: 'icon-barcode',
            state: ['eventos.lancamentoestoque'],
            translate: 'EVENTOS.LANCAMENTOESTOQUE.NAV'
        });


    }
})();
angular
  .module('app.pages.eventos.lancamentoestoque')
  .controller("ModalController", function ($scope, $mdDialog, produto, tipoOperacaoList) {
    $scope.produto = produto;
    $scope.tipoOperacaoList = tipoOperacaoList;

    $scope.confirmarModal = function () {
      var resultado = {
        regProduto: $scope.produto.regProduto,
        nrQuantidade: $scope.quantidade,
        tipoOperacao: $scope.tipoOperacao
      };
      $mdDialog.hide(resultado);
    };

    $scope.habilitaConfirma = function() {
      return $scope.quantidade > 0 && $scope.tipoOperacao != null;
    }

    $scope.fecharModal = function () {
      $mdDialog.cancel();
    };
  });

(function () {
    'use strict';

    angular
        .module('app.pages.cadastros.evento', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {

        $stateProvider
            .state('cadastros.evento', {
                url    : '/evento',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/pages/cadastros/evento/listagem/index.html',
                        controller : 'EventosListagemController as ctrl'
                    }
                }
            })
            .state('cadastros.evento.novo', {
                url    : '/novo',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/pages/cadastros/evento/edicao/index.html',
                        controller : 'EventosEdicaoController as ctrl'
                    }
                }
            })
            .state('cadastros.evento.editar', {
                url    : '/editar/:id',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/pages/cadastros/evento/edicao/index.html',
                        controller : 'EventosEdicaoController as ctrl'
                    }
                }
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/cadastros/evento');

        //---

        msNavigationServiceProvider.saveItem('cadastros.evento', {
            title    : 'Cadastro de evento',
            icon     : 'icon-bowling',
            state    : ['cadastros.evento'],
            translate: 'CADASTROS.EVENTO.NAV'
        });
    }
})();
(function () {
    'use strict';

    angular
        .module('app.pages.cadastros.evento')
        .controller('PosModalController', PosModalController);

    PosModalController.$inject = [
        'ServoTicketPOSResource',
        'Util',
        '$mdDialog',
        'pos',
        'regLocatario'
    ];

    function PosModalController( Resource, Util, mdDialog, pos, regLocatario ) {
        var vm = this;

        vm.pos = [];
        vm.filtro = '';
        vm.regLocatario = regLocatario;
        vm.eventoPos = pos;
        vm.exibirTodos = false;
        vm.marcarTodos = false;

        vm.salvar = salvarFn;
        vm.cancelar = cancelarFn;
        vm.selecionarTodos = selecionarTodosFn;
        vm.pesquisar = pesquisarFn;
        vm.keyUp = keyUpFn;
        vm.exibirTodosChanged = exibirTodosChangedFn;

        function pesquisarFn() {
            Resource.findByLocatario(vm.regLocatario.id, vm.filtro).then(function(result) {
                vm.pos = result.data;
                
                vm.pos.forEach(function(pos) {
                    var oldPos = findPos(pos);
                    if (oldPos) {
                        pos.selected = true;
                    }
                });

            }, function(error){ 
                Util.showToastMessage('Falha ao carregar lista de POS.');
                vm.pos = [];
            });

            vm.marcarTodos = false;
        }

        function salvarFn($event) {
            vm.pos.forEach(function(pos) {
                var oldPos = findPos(pos);
                if (pos.selected && !oldPos) {
                    delete pos.selected;
                    vm.eventoPos.push(pos);
                } else if (!pos.selected && oldPos) {
                    var idx = vm.eventoPos.indexOf(oldPos);
                    if (idx > -1) {
                        vm.eventoPos.splice(idx, 1);
                    }
                }
            });

            mdDialog.hide();
            var dialogoSubstituiLancamento = mdDialog
                .alert()
                .title("Para efetivar a inclusão de POS no evento, favor confirmar a operação no botão (+) no canto direito inferior da tela.")
                .ok("Entendido");
            mdDialog.show(dialogoSubstituiLancamento);
        }

        function findPos(pos){ 
            return vm.eventoPos.find(function(oldPos){ 
                if (pos.id === oldPos.id) {
                    return oldPos;
                }
            });
        }

        function cancelarFn(){ 
            mdDialog.hide();
        }

        function selecionarTodosFn() {
            vm.pos.forEach(function(pos) {
                pos.selected = vm.marcarTodos;
            });
        }

        function keyUpFn($event) {
            if ($event.keyCode == 13) {
                vm.exibirTodos = false;
                vm.pesquisar();
            }
        }

        function exibirTodosChangedFn() {
            vm.filtro = '';
            vm.pos = [];
            
            if (vm.exibirTodos) {
                pesquisarFn();
            }
        }

    }

})();

(function () {
    'use strict';

    angular
        .module('app.pages.sistema.arquivoupload', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {

        $stateProvider
            .state('sistema.arquivoupload', {
                url : '/arquivoupload',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/pages/sistema/arquivoupload/listagem/index.html',
                        controller : 'ArquivoUploadController as controller'
                    }
                }
            });

        $stateProvider
            .state('sistema.arquivoupload.detalhes', {
                url : '/arquivoupload/:id',
                params: {
                    data: undefined
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/pages/sistema/arquivoupload/detalhes/index.html',
                        controller : 'ArquivoUploadDetalhesController as controller'
                    }
                }
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/sistema/arquivoupload');

        //---

        msNavigationServiceProvider.saveItem('sistema.arquivoupload', {
            title    : 'Arquivos enviados',
            icon     : 'icon-file',
            state    : ['sistema.arquivoupload'],
            translate: 'SISTEMA.ARQUIVOUPLOAD.NAV',
            hidden: checkProfile
        });
    }

    function checkProfile() {
        var perfilamento = localStorage.getItem('perfilamento');
        
        if (perfilamento) {
            perfilamento = JSON.parse(perfilamento);
            if (perfilamento.tpPerfil) {
                return perfilamento.tpPerfil.toUpperCase().indexOf('ADMIN') < 0;
            }
        }

        return true;
    }

})();
(function () {
    'use strict';

    angular
        .module('app.pages.sistema.arquivoupload')
        .controller('ArquivoUploadController', ArquivoUploadController);

    ArquivoUploadController.$inject = ['ArquivoUploadResource', '$filter', '$mdToast', 'Util', '$state'];

    /** @ngInject */
    function ArquivoUploadController( Resource, $filter, $mdToast, Util, state ) {
        var vm = this;

        vm.periodoItens = [ 'Hoje', '15 Dias', '30 Dias', 'Selecionar Data' ];

        /**
         * POS selecionado.
         */
        vm.pos;

        /**
         * Período do relatório.
         */
        vm.periodo = 0;

        /**
         * Data de inicio do período.
         */
        vm.dataInicio = new Date();

        /**
         * Data de fim do período.
         */
        vm.dataFim = new Date();
        
        /**
         * Intervalo de horas dos filtros
         */
        vm.horaInicio = 0;
        vm.minutoInicio = 0;
        vm.horaFim = 23;
        vm.minutoFim = 59;
        
        vm.minutosInicio = [
            0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55
        ];
        vm.minutosFim = vm.minutosInicio.concat([59]);
        
        //---

        vm.carregarArquivosUpload = carregarArquivosUploadFn;
        vm.detalharItem = detalharItemFn;

        vm.changeOrder = function( order ) {
            if (vm.order !== order) {
                vm.reverse = false;
            } else {
                vm.reverse = !vm.reverse;
            }
            vm.order = order;
        };

        vm.order = 'dhSincronismo';
        vm.reverse = true;

        carregarArquivosUploadFn();

        //---

        function carregarArquivosUploadFn() {
            Resource.getArquivosUpload( getData() ).then(function( content ) {
                vm.data = content.data;
            });
        }

        function getData() {
            var today = new Date();

            var dataInicio;
            var dataFim = Util.formatDate(today) + 'T23:59:59';

            if( vm.periodo == 0 ) {
        
                dataInicio = Util.formatDate(today) + 'T00:00:00';
            
            } else if( vm.periodo == 1 ) {
                
                dataInicio = getDate( 15 );

            } else if( vm.periodo == 2 ) {

                dataInicio = getDate( 30 );
                
            } else if( vm.periodo == 3 ) {
                
                if( !vm.dataInicio ) {
                    return;
                } else {
                    dataInicio = Util.formatDate(vm.dataInicio) + 'T' + getTime(vm.horaInicio, vm.minutoInicio);
                }

                dataFim = Util.formatDate(vm.dataFim) + 'T' + getTime(vm.horaFim, vm.minutoFim);
            }

            return {
                dtInicio: dataInicio,
                dtTermino: dataFim,
                dsNumeroSerie: vm.pos,
                dsOperacao: 'ENVIAR_VENDAS'
            };
            
            function getDate( less ) {
                var today = new Date()
                var priorDate = new Date().setDate(today.getDate() - less );

                return Util.formatDate(new Date(priorDate)) + 'T00:00:00';
            }
            
            function getTime(hour, minute) {
                var time = '';
                if (hour < 10) {
                    time = '0' + hour;
                } else {
                    time += hour;
                }
                time += ":";
                if (minute < 10) {
                    time += '0' + minute;
                } else {
                    time += minute;
                }
                if (minute == 59) {
                    time += ":59";
                } else {
                    time += ":00";
                }
                
                return time;
            }

        }

        function detalharItemFn(item) {
            state.go('.detalhes', { id: item.id, data: item });
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.pages.sistema.arquivoupload')
        .controller('ArquivoUploadDetalhesController', ArquivoUploadDetalhesController);

    ArquivoUploadDetalhesController.$inject = ['ArquivoUploadResource', '$filter', '$mdToast', 'Util', '$stateParams'];

    /** @ngInject */
    function ArquivoUploadDetalhesController( Resource, $filter, $mdToast, Util, stateParams ) {
        var vm = this;
        vm.data = stateParams.data;
        //---
        
        vm.changeOrder = function( order ) {
            if (vm.order !== order) {
                vm.reverse = false;
            } else {
                vm.reverse = !vm.reverse;
            }
            vm.order = order;
        };

        vm.order = 'dhStatus';
        vm.reverse = true;

        //---

        if (stateParams && stateParams.data && stateParams.data.id) {
            Resource.getDetalhesUpload( stateParams.data.id ).then(function( content ) {
                vm.detalhes = content.data;
            });
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.pages.eventos.produtos', ['md.data.table'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {

        $stateProvider
            .state('eventos.produtos', {
                url    : '/produtos',
                templateUrl: 'app/main/pages/eventos/produtos/index.html',
                controller : 'EventosProdutosController as produtos'
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/eventos/produtos');

        //---

        msNavigationServiceProvider.saveItem('eventos.produtos', {
            title    : 'Produtos',
            icon     : 'icon-archive',
            state    : ['eventos.produtos', 'eventos.produtosCadastro'],
            translate: 'EVENTOS.PRODUTOS.NAV'
        });

    }
})();
(function () {
    'use strict';

    angular
        .module('app.pages.eventos.produtos')
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {

        $stateProvider
            .state('eventos.produtosCadastro', {
                url: '/produtos/cadastro',
                templateUrl: 'app/main/pages/eventos/produtos/cadastro/index.html',
                controller : 'EventosProdutosCadastroController as produtos',
                params: {
                    produto: undefined 
                }
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/eventos/produtos/cadastro');

        //---

        // msNavigationServiceProvider.saveItem('eventos.produtos', {
        //     title    : 'Cadastro de Produtos',
        //     icon     : 'icon-tile-four',
        //     state    : 'eventos.produtosCadastro',
        //     translate: 'EVENTOS.PRODUTOS.CADASTRO.NAV'
        // });

    }
})();
(function () {
    'use strict';

    angular
        .module('app.pages.eventos.produtos')
        .controller('EventosProdutosCadastroController', EventosProdutosCadastroController);

    EventosProdutosCadastroController.$inject = [
        'EventosProdutosResource',
        'EventosGrupoProdutosResource',
        '$stateParams',
        'Util',
        '$mdDialog'
    ];
    
    function EventosProdutosCadastroController( Resource, GrupoProdutoResource, $stateParams, Util, $mdDialog) {
        var vm = this;

        vm.produto = $stateParams.produto || {};
        vm.locatario;
        vm.evento;
        vm.grupo;
        vm.grupos = [];
        vm.saving = false;

        //---

        vm.salvar = salvarFn;
        vm.onSelectEvento = onSelectEventoFn;
        vm.onChangeLocatario = onChangeLocatarioFn;
        vm.onSelectGrupo = onSelectGrupoFn;

        //---

        if (vm.produto.id) {
            vm.produto.vlPreco = vm.produto.vlPreco.toFixed(2);
        }

        function onSelectEventoFn() {
            if( !vm.produto.id ) {
                inicializarProduto();
            }
        }

        function onChangeLocatarioFn() {
            GrupoProdutoResource.findAllByIdIgreja(vm.locatario.regPessoa.id)
                .then(onSuccessGrupoProdutos, onErrorGrupoProdutos)

            function onSuccessGrupoProdutos(result) {
                vm.grupos = result.data;

                if (vm.produto.id) {
                    vm.grupo = vm.produto.regGrupoProduto;
                }
            }

            function onErrorGrupoProdutos(err) {
                console.log(err);
                sendErrorMessage('Erro ao obter grupos de produtos.');
            }
        }

        function onSelectGrupoFn() {    
            if (vm.evento.fgGerarContabil === 1) {
                if (!vm.grupo || !vm.grupo.nrContaContabil || vm.grupo.nrContaContabil.length === 0) {
                    vm.grupo = null;
                    sendErrorMessage('Grupo do Produto não possui configuração contábil.');
                    throw 'Grupo sem configuração contábil';
                }
            }
        }

        function salvarFn() {
            vm.saving = true;

            try {
                validarCampo(vm.produto.regProduto.dsDescricao, 'Descrição do Produto', 50);
                validarNumero(vm.produto.vlPreco);
                validarCampo(vm.produto.vlPreco, 'Preço', 9);
                validarCampo(vm.produto.dsDescricaoDisplayPos, 'Descrição POS', 15);
                validarCaracteres(vm.produto.dsDescricaoDisplayPos)
                validarCampo(vm.produto.dsDescricaoImpressaoLinhaUm, 'Descrição Impressão Linha 1', 100, true, ' não pode ser vazia.');
                validarCampo(vm.produto.dsDescricaoImpressaoLinhaDois, 'Descrição Impressão Linha 2', 100, true, ' não pode ser vazia.');
                validarCampo(vm.produto.nrViasTicket, 'Número de vias de impressão', 3);
                validarGrupoProduto();
            } catch (err) {
                vm.saving = false;
                return false;
            }

            vm.produto.vlPreco = vm.produto.vlPreco.toString().replace(',', '.');

            vm.produto.idLocatario = vm.locatario.regPessoa.id;
            vm.produto.regGrupoProduto = vm.grupo
              ? {
                  id: vm.grupo.id
                }
              : undefined;
            var controlaEstoque = vm.produto.fgEstoque;
            Resource.saveOrUpdate(vm.produto).then(function() {

                inicializarProduto();
                Util.showToastMessage('Produto salvo com sucesso.');

                vm.formProduto.$setPristine();
                vm.formProduto.$setUntouched();
                vm.saving = false;
                if (controlaEstoque === 1) {
                    $mdDialog.hide();
                    var dialogoLancamentoProduto = $mdDialog
                        .alert()
                        .title("Lembre de efetuar lançamentos de estoque para o produto.")
                        .ok("Entendido");
                    $mdDialog.show(dialogoLancamentoProduto);
                }
            }, onError);

            function onError( error ) {
                var errors = error.data || [];

                for (var i = 0; i < errors.length; i++) {
                    if (errors[i].type == 'COD_DUPLICADO') {
                        showConfirmCodigoDuplicado(errors[i].message);
                    } else {
                        vm.saving = false;
                        sendErrorMessage(errors[i].message);
                    }
                }
            }
        }

        function showConfirmCodigoDuplicado( message ) {
            var confirm = $mdDialog.confirm()
                .title('Aviso')
                .textContent(message + ', deseja continuar?')
                .ok('Sim')
                .cancel('Não');

                $mdDialog.show(confirm).then(function() {
                    vm.produto.permiteCodVendaDuplicado = true;
                    vm.salvar();
                }, function() {
                    vm.saving = false;
                    document.querySelector('#idCodigoVenda').focus();
                });
        }

        function inicializarProduto() {
            vm.produto = {};
            vm.produto.vlPreco = '';
            vm.produto.fgImprimeTicket = 1;
            vm.produto.tpImpressaoTicket = 0;
            vm.produto.nrViasTicket = 1;
            vm.produto.fgSolicitaPreco = 0;
            vm.produto.fgImprimeCodigoBarras = 0;
            vm.produto.fgEstoque = 0;
            vm.produto.fgAtivo = 1;
            vm.produto.regEvento = vm.evento;
            vm.produto.regGrupoProduto = null;
            vm.produto.regProduto = {};
            vm.produto.regProduto.dsDescricao = '';
            vm.produto.dsDescricaoDisplayPos = '';
            vm.produto.dsDescricaoImpressaoLinhaUm = '';
            vm.produto.dsDescricaoImpressaoLinhaDois = '';
            vm.grupo = undefined;
        }

        function validarGrupoProduto() {
            if (vm.evento.fgGerarContabil === 1) {
                if(!vm.grupo) {
                    sendErrorMessage('Grupo do Produto não pode ser vazio.');
                    throw 'Grupo obrigatório';
                }

                if( !vm.grupo.nrContaContabil || vm.grupo.nrContaContabil.length === 0) {
                    vm.grupo = null;
                    sendErrorMessage('Grupo do Produto não possui configuração contábil.');
                    throw 'Grupo sem configuração contábil';
                }
            }
        }

        function validarCampo(value, name, size, permiteVazio, emptyMessage) {
            emptyMessage = emptyMessage || ' não pode ser vazio.';
            var message = '';

            if ((!value || value.length == 0) && !permiteVazio) {
                if (name == 'Descrição POS') {
                    vm.produto.dsDescricaoDisplayPos = vm.produto.regProduto.dsDescricao.slice(0, size);
                } else {
                    sendErrorMessage(message = (name + emptyMessage));
                }
            } else if (value && value.length > size) {
                sendErrorMessage(message = (name + ' não pode conter mais que ' + size + ' caracteres.'));
            }

            if (message) {
                throw "Campo inválido" + name;
            }
        }

        function validarNumero(value) {
            var message = '';
            var regexp = new  RegExp(/^(\d+(?:[\.\,]\d{2})?)$/);

            if (!regexp.test(value)) {
                sendErrorMessage("Preço inválido.");

                throw "Valor inválido";
            }
        }

        function sendErrorMessage(message ) {
            message = message || "Erro ao salvar produto";

            Util.showToastMessage( message ); 
        }

        function validarCaracteres( value ) {
            var defaultMessage = 'Descrição POS possui Carácter inválido. Consulte ajuda!';
            if( value ) {
                var result = value.match(/[a-zA-Z0-9\s@!#$%&*()?;:,/"+=.\-_]/g);
                if( result == null || result.length < value.length ) {
                    result = result || [];
                    Util.showToastMessage( defaultMessage );
                    throw defaultMessage;
                }
            }        
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('app.pages.eventos.lancamentoestoque')
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
        
        $stateProvider
            .state('eventos.lancamentoestoqueCadastro', {
                url: '/lancamentoestoque/cadastro',
                templateUrl: 'app/main/pages/eventos/lancamentoestoque/cadastro/index.html',
                controller: 'EventosLancamentoEstoqueCadastroController as lancamentos',
                params: {   
                    produto: undefined
                }
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/eventos/lancamentoestoque/cadastro');
    }
})();

(function () {
  "use strict";

  angular
    .module("app.pages.eventos.lancamentoestoque")
    .controller(
      "EventosLancamentoEstoqueCadastroController",
      EventosLancamentoEstoqueCadastroController
    );

  EventosLancamentoEstoqueCadastroController.$inject = [
    "EventosLancamentoEstoqueResource",
    "EventosProdutosResource",
    "$stateParams",
    "$state",
    "Util",
    "$mdDialog",
  ];

  function EventosLancamentoEstoqueCadastroController(
    Resource,
    ProdutoResource,
    $stateParams,
    $state,
    Util,
    $mdDialog
  ) {
    var vm = this;
    vm.search = "";

    vm.locatario;
    vm.evento;
    vm.produto = $stateParams.produto || {};
    if (vm.produto.id) {
      vm.search = vm.produto.dsDescricao;
    }
    vm.saving = false;

    vm.pageLabels = {
      of: "de",
      page: "Página:",
      rowsPerPage: "Registros por página:",
    };

    vm.limit = 4;
    vm.page = 1;
    vm.produtos = {
      totalRegistros: 0,
      data: [],
    };
    vm.pageChanged = pageChangedFn;
    vm.onRowClick = onRowClickFn;

    vm.limitEstoque = 25;
    vm.pageEstoque = 1;
    vm.listaLancamentos = [];
    vm.delete = deleteFn;
    vm.salvar = salvarFn;
    vm.onSelectEvento = onSelectEventoFn;
    // vm.onSelectProduto = onSelectProdutoFn;

    vm.filter = filter;

    function onRowClickFn(produto) {
      $mdDialog
        .show({
          templateUrl:
            "app/main/pages/eventos/lancamentoestoque/cadastro/modal/index.html",
          controller: "ModalController",
          locals: {
            evento: vm.evento,
            produto: produto,
            tipoOperacaoList: [
              { id: 0, nome: "Entrada de estoque" },
              { id: 1, nome: "Saída avulsa de estoque" },
            ],
          },
        })
        .then(
          function (resultado) {
            resultado.regEvento = vm.evento;
            var lancamento = vm.listaLancamentos.filter(function (l) {
              return l.regProduto.id == resultado.regProduto.id;
            })[0];
            if (lancamento != null) {
              var dialogoSubstituiLancamento = $mdDialog
                .confirm()
                .title("Produto já foi lançado.")
                .textContent("Deseja substituir os dados?")
                .ok("Sim")
                .cancel("Não");

              $mdDialog.show(dialogoSubstituiLancamento).then(function (resposta) {
                if (resposta) {
                  lancamento.nrQuantidade = resultado.nrQuantidade;
                  lancamento.regEvento = resultado.regEvento;
                  lancamento.tipoOperacao = resultado.tipoOperacao;
                }
              });
            } else {
              vm.listaLancamentos.push(resultado);
            }
          });
    }

    function deleteFn(estoque) {
      var i = vm.listaLancamentos.indexOf(estoque);
      if (i !== -1) {
        vm.listaLancamentos.splice(i, 1);
      }
    }

    function salvarFn() {
      vm.saving = true;
      Resource.salvar(vm.listaLancamentos).then(
        function () {
          Util.showToastMessage("Lançamento(s) salvos com sucesso.");
          $state.go("eventos.lancamentoestoque");
        },
        function (error) {
          Util.showToastMessage("Erro ao salvar lançamento(s).");
          console.log(error);
        }
      );
    }

    function filter() {
      if (!vm.search && vm.search !== 0) {
        listaProduto();
      }

      var campo;
      if (new RegExp(/^\d+$/).test(vm.search)) {
        campo = "idCodigoVenda";
      } else if (vm.search.length >= 3) {
        campo = "regProduto.dsDescricao";
      } else {
        return;
      }

      listaProduto(campo);
    }

    function listaProduto(campo) {
      var filter =
        "pageSize:" +
        vm.limit +
        ",pag:" +
        vm.page +
        ",orderField:regProduto.dsDescricao" +
        ",orderType:ASC";

      if (campo) {
        filter += "," + campo + ":" + vm.search;
      }
      filter += "," + "fgEstoque" + ":" + 1;

      ProdutoResource.searchByEvent(vm.evento.id, filter).then(
        function (data) {
          vm.produtos = data.data;
        },
        function (error) {
          vm.produtos = {
            totalRegistros: 0,
            data: [],
          };
        }
      );
    }

    function pageChangedFn(page, limit) {
      vm.page = page;
      vm.limit = limit;
      vm.filter();
    }

    function onSelectEventoFn() {
      filter();
    }
  }
})();

(function() {
  "use strict";

  angular
    .module("app.pages.eventos.grupoprodutos", ["md.data.table"])
    .config(config);

  function config(
    $stateProvider,
    $translatePartialLoaderProvider,
    msApiProvider,
    msNavigationServiceProvider
  ) {
    $stateProvider.state("eventos.grupoprodutos", {
      url: "/grupoprodutos",
      templateUrl: "app/main/pages/eventos/grupoprodutos/index.html",
      controller: "EventosGrupoProdutosController as ctrl"
    });

    $translatePartialLoaderProvider.addPart(
      "app/main/pages/eventos/grupoprodutos"
    );

    msNavigationServiceProvider.saveItem("eventos.grupoprodutos", {
      title: "Grupo de Produtos",
      icon: "icon-view-module",
      state: ["eventos.grupoprodutos", "eventos.grupoprodutosCadastro"],
      translate: "EVENTOS.GRUPOPRODUTOS.NAV"
    });
  }
})();

(function() {
  "use strict";

  angular.module("app.pages.eventos.grupoprodutos").config(config);

  function config(
    $stateProvider,
    $translatePartialLoaderProvider,
    msNavigationServiceProvider
  ) {
    $stateProvider.state("eventos.grupoProdutosCadastro", {
      url: "/grupoprodutos/cadastro",
      templateUrl: "app/main/pages/eventos/grupoprodutos/cadastro/index.html",
      controller: "EventosGrupoProdutosCadastroController as ctrl",
      params: {
        grupo: undefined,
        locatario: undefined
      }
    });

    $translatePartialLoaderProvider.addPart(
      "app/main/pages/eventos/grupoprodutos/cadastro"
    );
  }
})();

(function() {
  "use strict";

  angular
    .module("app.pages.eventos.grupoprodutos")
    .controller(
      "EventosGrupoProdutosCadastroController",
      EventosGrupoProdutosCadastroController
    );

  EventosGrupoProdutosCadastroController.$inject = [
    "EventosGrupoProdutosResource",
    "ServoTicketEventosResource",
    "$stateParams",
    "Util",
    "$state"
  ];

  function EventosGrupoProdutosCadastroController(
    GrupoProdutosResource,
    ServoTicketResource,
    $stateParams,
    Util,
    state
  ) {
    var vm = this;

    vm.grupo = $stateParams.grupo || {};
    vm.locatario = "";
    vm.saving = false;
    vm.cfgContabilLocatario = {
      fgGerarContabil: 0
    };
    vm.salvar = salvarFn;

    if ($stateParams.locatario) {
      const regPessoa = $stateParams.locatario.regPessoa;
      vm.grupo.regIgreja = {
        id: regPessoa.id
      };

      vm.locatario =
        regPessoa.dsNome +
        " - " +
        regPessoa.dsCidade +
        " - " +
        regPessoa.sgEstado;

      ServoTicketResource.cfgContabilLocatario(regPessoa.id).then(
        function(result) {
          if (result.data) {
            vm.cfgContabilLocatario = result.data || { fgGerarContabil: 0 };
          }
        },
        function(err) {
          console.log(err);
          Util.showToastMessage("Falha ao carregar configurações contábeis.");
        }
      );
    }

    function salvarFn() {
      try {
        vm.saving = true;
        validarCampo(vm.grupo.dsNomeGrupo, "Nome do Grupo", 100, false);
        validarNumero(vm.grupo.nrContaContabil);
        validarCampo(vm.grupo.nrContaContabil, "Nr. Conta Contábil", 50, true);
        validarCampo(
          vm.grupo.dsHistoricoContabil,
          "Histórico Contábil",
          100,
          true
        );
      } catch (err) {
        vm.saving = false;
        return false;
      }

      GrupoProdutosResource.saveOrUpdate(vm.grupo).then(function() {
        vm.saving = false;
        initGrupo();
        Util.showToastMessage("Grupo salvo com sucesso.");
        state.go("eventos.grupoprodutos");
      }, onError);

      function onError(error) {
        if (error.status === 400) {
          Util.showToastMessage(error.data);
        } else {
          Util.showToastMessage("Falha ao salvar dados do grupo.");
        }

        vm.saving = false;
      }
    }

    function initGrupo() {
      vm.grupo = {};
      vm.grupo.dsNomeGrupo = "";
      vm.grupo.nrContaContabil = "";
      vm.grupo.dsHistoricoContabil = "";
      vm.grupo.regIgreja = {};
    }

    function validarCampo(value, name, size, permiteVazio, emptyMessage) {
      emptyMessage = emptyMessage || " não pode ser vazio.";
      var message = "";

      if ((!value || value.length === 0) && !permiteVazio) {
        sendErrorMessage((message = name + emptyMessage));
      } else if (value && value.length > size) {
        sendErrorMessage(
          (message =
            name + " não pode conter mais que " + size + " caracteres.")
        );
      }

      if (message) {
        throw "Campo inválido" + name;
      }
    }

    function validarNumero(value) {
      var regexp = new RegExp(/^(\d+(?:[\.\,]\d{2})?)$/);

      if (value && !regexp.test(value)) {
        sendErrorMessage("Nr. Conta Contábil inválida.");

        throw "Valor inválido";
      }
    }

    function sendErrorMessage(message) {
      message = message || "Erro ao salvar produto";

      Util.showToastMessage(message);
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('app.pages.cadastros.evento')
        .controller('EventosListagemController', EventosListagemController);

    EventosListagemController.$inject = [
        'ServoTicketEventosResource',
        'ServoTicketLocatariosResource',
        'Util',
        '$state',
    ];

    function EventosListagemController( EventosResource, LocatariosResource, Util, state ) {
        var vm = this;

        vm.locatarios = [];
        vm.eventos = [];
        vm.locatario = undefined;

        vm.onSelectLocatario = onSelectLocatarioFn;
        vm.novo = novoFn;
        vm.editar = editarFn;

        LocatariosResource.findAll().then(function(result) {
            vm.locatarios = result.data;
            var locatario = localStorage.getItem('locatario');

            if( locatario ) {
                vm.locatario = JSON.parse(locatario);
                vm.onSelectLocatario();
            }
        });

        function onSelectLocatarioFn() {
            if (vm.locatario && vm.locatario.id) {
                EventosResource.findAllByIdLocatario(vm.locatario.id).then(function(result) {
                    vm.eventos = result.data;
                }, function (error){ 
                    vm.eventos = [];
                    Util.showToastMessage('Falha ao carregar eventos do locatário selecionado.');
                });
            }
        }

        function novoFn() {
            if (vm.locatario && vm.locatario.id) {
                localStorage.setItem('locatario', JSON.stringify(vm.locatario));
                state.go('.novo');
            }
        }

        function editarFn(evento) {
            if (evento && evento.id) {
                localStorage.setItem('locatario', JSON.stringify(vm.locatario));
                state.go('.editar', { id: evento.id });
            }
        }

    }

})();

(function () {
    'use strict';

    angular
        .module('app.pages.cadastros.evento')
        .controller('EventosEdicaoController', EventosEdicaoController);

    EventosEdicaoController.$inject = [
        'ServoTicketEventosResource',
        'Util',
        '$stateParams',
        '$mdDialog',
        '$scope',
        '$state'
    ];

    function EventosEdicaoController( Resource, Util, stateParams, mdDialog, scope, state ) {
        var vm = this;

        vm.evento = {
            regPessoa: {},
            regPos: []
        };
        vm.locatario = '';
        vm.cfgContabilLocatario = {
            fgGerarContabil: 0,
        };
        vm.posErro = [];
        vm.dtFinalEvento = new Date();
        vm.dtInicioEvento = new Date();
        vm.saving = false;
        
        vm.salvar = salvarFn;
        vm.removePos = removePosFn;
        vm.addPos = addPosFn;

        var locatario = localStorage.getItem('locatario');
        
        if (locatario) {
            vm.evento.regPessoa = JSON.parse(locatario).regPessoa;
            vm.locatario = vm.evento.regPessoa.dsNome + ' - ' 
                        + vm.evento.regPessoa.dsCidade + ' - ' 
                        + vm.evento.regPessoa.sgEstado;

            Resource.cfgContabilLocatario(vm.evento.regPessoa.id)
                .then(onSuccessCfgContabil, onErrorCfgContabil);
        }

        if (stateParams.id) {
            Resource.get(stateParams.id).then(function(result) {
                vm.evento = result.data;
                vm.locatario = vm.evento.regPessoa.dsNome + ' - ' 
                        + vm.evento.regPessoa.dsCidade + ' - ' 
                        + vm.evento.regPessoa.sgEstado;
                vm.dtInicioEvento = moment(vm.evento.dtInicioEvento, 'DD/MM/YYYY').toDate();
                vm.dtFinalEvento = moment(vm.evento.dtFinalEvento, 'DD/MM/YYYY').toDate();
            }, function(error){ 
                Util.showToastMessage('Falha ao carregar dados do evento.');
            });
        }

        function salvarFn($event) {
            vm.saving = true;
            vm.evento.dtInicioEvento = moment(vm.dtInicioEvento).format('YYYY-MM-DD');
            vm.evento.dtFinalEvento = moment(vm.dtFinalEvento).format('YYYY-MM-DD');

            if (vm.evento.id) {
                Resource.update(vm.evento).then(function(result) {
                    vm.saving = false;
                    Util.showToastMessage('Evento atualizado com sucesso!');
                    state.go('^');
                }, function(error) {
                    if (error.status === 409) {
                        vm.posErro = error.data;
                        confirmarPos($event);
                    } else if (error.status === 400) {
                        Util.showToastMessage(error.data);
                    } else {
                        Util.showToastMessage('Falha ao atualizar dados do evento.');
                    }
                    vm.saving = false;
                });
            } else {
                Resource.save(vm.evento).then(function(result) {
                    vm.saving = false;
                    Util.showToastMessage('Evento criado com sucesso!');
                    state.go('^');
                }, function(error) {
                    if (error.status === 409) {
                        vm.posErro = error.data;
                        confirmarPos($event);
                    } else if (error.status === 400) {
                        Util.showToastMessage(error.data);
                    } else {
                        Util.showToastMessage('Falha ao criar novo evento.');
                    }
                    vm.saving = false;
                });
            }
            
        }

        function onSuccessCfgContabil(result) {
            vm.cfgContabilLocatario = result.data || { fgGerarContabil: 0 };
        }

        function onErrorCfgContabil(error) {
            Util.showToastMessage('Falha ao carregar configurações contábeis.');
        }

        function removePosFn(pos){ 
            var idx = vm.evento.regPos.indexOf(pos);
            if (idx > -1) {
                vm.evento.regPos.splice(idx, 1);
            }
        }

        function addPosFn($event) {
            mdDialog.show({
                templateUrl: 'app/main/pages/cadastros/evento/edicao/pos/index.html',
                controller: 'PosModalController',
                controllerAs: 'modal',
                targetEvent: $event,
                locals: {
                    pos: vm.evento.regPos,
                    regLocatario: vm.evento.regPessoa
                }
            });
        } 

        function confirmarPos($event) {
            var pos = vm.posErro.pop();

            if (pos) {
                var content = 'POS ' + pos.dsNumeroSerie 
                        + ' está relacionado ao evento ' + pos.dsEvento 
                        + '.<br>Deseja relacionar assim mesmo a este evento?'
                        + '<br>O POS será desvinculado do evento ' + pos.dsEvento + '.';

                var confirm = mdDialog.confirm()
                    .title('POS já relacionado')
                    .htmlContent(content)
                    .targetEvent($event)
                    .ok('Relacionar mesmo assim')
                    .cancel('Ignorar');

                mdDialog.show(confirm).then(function() { 
                    confirmarPos($event);
                }, function() {
                    removePos(pos);
                    confirmarPos($event);
                });
            } else {
                vm.evento.forcarRelacaoPos = true;
                salvarFn($event);
            }
        }

        function removePos(pos) {
            var oldPos = vm.evento.regPos.find(function(oldPos) {
                if (oldPos.id === pos.id) {
                    return oldPos;
                }
            });

            if (oldPos) {
                var idx = vm.evento.regPos.indexOf(oldPos);
                vm.evento.regPos.splice(idx, 1);
            }
        }

    }

})();

(function () {
    'use strict';

    angular
        .module('app.pages.sistema.arquivoupload')
        .factory('ArquivoUploadResource', ArquivoUploadResource);

        ArquivoUploadResource.$inject = ['$http', 'BACKEND_URL'];
    
    function ArquivoUploadResource( Http, backendUrl) {

        var vm = {
            getArquivosUpload: getArquivosUploadFn,
            getDetalhesUpload: getDetalhesUploadFn
        };

        return vm;

        function getArquivosUploadFn( data ) {
            return Http.get(backendUrl + '/sincarquivoupload', {
                params: data
            });
        }

        function getDetalhesUploadFn( id ) {
            return Http.get(backendUrl + '/sincarquivoupload/detalhes/' + id);
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.pages.sistema.ajuda', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {

        $stateProvider
            .state('sistema.ajuda', {
                url    : '/ajuda',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/pages/sistema/ajuda/index.html',
                        controller : 'AjudaController as ctrl'
                    }
                }
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/sistema/ajuda');

        //---

        msNavigationServiceProvider.saveItem('sistema.ajuda', {
            title    : 'Ajuda',
            icon     : 'icon-help',
            state    : ['sistema.ajuda'],
            translate: 'SISTEMA.AJUDA.NAV'
        });
    }
})();
(function () {
    'use strict';

    angular
        .module('app.pages.sistema.ajuda')
        .factory('ProdutosResource', ProdutosResource);

    ProdutosResource.$inject = ['$http', 'BACKEND_URL'];
    
    function ProdutosResource( Http, backendUrl) {

        var vm = {
            findRestrictKeys: findRestrictKeysFn,
        };

        return vm;

        function findRestrictKeysFn( ) {
            return Http.get(backendUrl + '/palavrarestrita');
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.pages.sistema.ajuda')
        .controller('AjudaController', AjudaController);

    AjudaController.$inject = [
        'ProdutosResource',
        'Util'
    ];

    function AjudaController( ProdutosResource, Util ) {
        var vm = this;

        vm.palavrasRestritas = [];
        
        ProdutosResource.findRestrictKeys().then(function(result) {
            vm.palavrasRestritas = result.data;
        }, function(error){ 
            Util.showToastMessage('Falha ao carregar as palavras reservadas.');
        });

    }

})();

(function () {
    'use strict';

    angular
        .module('app.pages.servoticket.usuarios', []);
        // .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {

        $stateProvider
            .state('servoticket.usuarios', {
                url    : '/usuarios',
                templateUrl: 'app/main/pages/servoticket/usuarios/index.html',
                controller : 'ServoTicketUsuariosController as vm',
                resolve: {
                    SampleData: function (msApi) {
                        return msApi.resolve('servoticketusuarios@get');
                    }
                }
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/servoticket/usuarios');

        // Api
        msApiProvider.register('servoticketusuarios', ['app/data/servoticket/usuarios/index.json']);

        //---

        msNavigationServiceProvider.saveItem('servoticket.usuarios', {
            title    : 'Usuários',
            icon     : 'icon-tile-four',
            state    : ['servoticket.usuarios'],
            translate: 'SERVOTICKET.USUARIOS.NAV'
        });
        
    }
})();
(function () {
    'use strict';

    angular
        .module('app.pages.servoticket.usuarios')
        .controller('ServoTicketUsuariosController', ServoTicketUsuariosController);

    /** @ngInject */
    function ServoTicketUsuariosController(SampleData) {
        var vm = this;

        // SampleData.data.helloText;

        vm.whoami = 'ServoTicket - Usuários';
    }
})();

(function () {
    'use strict';

    angular
        .module('app.pages.servoticket.pos', []);
        // .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {

        $stateProvider
            .state('servoticket.pos', {
                url    : '/pos',
                templateUrl: 'app/main/pages/servoticket/pos/index.html',
                controller : 'ServoTicketPosController as vm'
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/servoticket/pos');

        //---

        msNavigationServiceProvider.saveItem('servoticket.pos', {
            title    : 'POS',
            icon     : 'icon-tile-four',
            state    : ['servoticket.pos'],
            translate: 'SERVOTICKET.POS.NAV'
        });

    }
})();
(function () {
    'use strict';

    angular
        .module('app.pages.servoticket.pos')
        .factory('ServoTicketPOSResource', ServoTicketPOSResource);

    ServoTicketPOSResource.$inject = ['$http', 'BACKEND_URL'];
    
    function ServoTicketPOSResource( Http, backendUrl) {

        var vm = {
            findByLocatario: findByLocatarioFn
        };

        return vm;

        function findByLocatarioFn( idLocatario, dsNumeroSerie ) {
            return Http.get(backendUrl + '/regpos/locatario', {
                params: {
                    idLocatario: idLocatario,
                    dsNumeroSerie: dsNumeroSerie
                }
            });
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.pages.servoticket.pos')
        .controller('ServoTicketPosController', ServoTicketPosController);

    /** @ngInject */
    function ServoTicketPosController() {
        var vm = this;

        vm.whoami = 'ServoTicket - POS';
    }
})();

(function () {
    'use strict';

    angular
        .module('app.pages.servoticket.locatarios', []);
        // .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {

        $stateProvider
            .state('servoticket.locatarios', {
                url    : '/locatarios',
                templateUrl: 'app/main/pages/servoticket/locatarios/index.html',
                controller : 'ServoTicketLocatariosController as vm'
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/servoticket/locatarios');

        //---

        msNavigationServiceProvider.saveItem('servoticket.locatarios', {
            title    : 'Locatários',
            icon     : 'icon-tile-four',
            state    : ['servoticket.locatarios'],
            translate: 'SERVOTICKET.LOCATARIOS.NAV'
        });

    }
})();
(function () {
    'use strict';

    angular
        .module('app.pages.servoticket.locatarios')
        .factory('ServoTicketLocatariosResource', ServoTicketLocatariosResource);

    ServoTicketLocatariosResource.$inject = ['$http', 'BACKEND_URL'];
    
    function ServoTicketLocatariosResource( Http, backendUrl) {

        var vm = {
            findAll: findAllFn
        };

        return vm;

        function findAllFn( ) {
            return Http.get(backendUrl + '/regpessoausuario/list/usuario');
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.pages.servoticket.locatarios')
        .controller('ServoTicketLocatariosController', ServoTicketLocatariosController);

    /** @ngInject */
    function ServoTicketLocatariosController() {
        var vm = this;

        vm.whoami = 'ServoTicket - Locatários';
    }
})();

(function () {
    'use strict';

    angular
        .module('app.pages.servoticket.eventos', []);
        // .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {

        $stateProvider
            .state('servoticket.eventos', {
                url    : '/eventos',
                templateUrl: 'app/main/pages/servoticket/eventos/index.html',
                controller : 'ServoTicketEventosController as vm'
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/servoticket/eventos');

        //---

        msNavigationServiceProvider.saveItem('servoticket.eventos', {
            title    : 'Eventos',
            icon     : 'icon-tile-four',
            state    : ['servoticket.eventos'],
            translate: 'SERVOTICKET.EVENTOS.NAV'
        });
    }
})();
(function() {
  "use strict";

  angular
    .module("app.pages.servoticket.eventos")
    .factory("ServoTicketEventosResource", ServoTicketEventosResource);

  ServoTicketEventosResource.$inject = ["$http", "BACKEND_URL"];

  function ServoTicketEventosResource(Http, backendUrl) {
    var vm = {
      save: saveFn,
      update: updateFn,
      get: getFn,
      findAllByIdLocatario: findAllByIdLocatarioFn,
      cfgContabilLocatario: cfgContabilLocatarioFn
    };

    return vm;

    function findAllByIdLocatarioFn(id) {
      return Http.get(backendUrl + "/regevento/list/locatario/" + id);
    }

    function getFn(id) {
      return Http.get(backendUrl + "/regevento/" + id);
    }

    function saveFn(evento) {
      return Http.post(backendUrl + "/regevento", evento);
    }

    function updateFn(evento) {
      return Http.put(backendUrl + "/regevento", evento);
    }

    function cfgContabilLocatarioFn(idIgreja) {
      return Http.get(backendUrl + "/locatario/contabil/" + idIgreja);
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('app.pages.servoticket.eventos')
        .controller('ServoTicketEventosController', ServoTicketEventosController);

    /** @ngInject */
    function ServoTicketEventosController() {
        var vm = this;

        vm.whoami = 'ServoTicket - Eventos';
    }
})();

(function () {
    'use strict';

    angular
        .module('app.pages.relatorios.vendasprodutos', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {

        $stateProvider
            .state('relatorios.vendasprodutos', {
                url    : '/vendasprodutos',
                templateUrl: 'app/main/pages/relatorios/vendasprodutos/index.html',
                controller : 'RelatoriosVendasrodutosController as relatorio'
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/relatorios/vendasprodutos');

        //---

        msNavigationServiceProvider.saveItem('relatorios.vendasprodutos', {
            title    : 'Vendas por Produtos',
            icon     : 'icon-chart-line',
            state    : ['relatorios.vendasprodutos'],
            translate: 'RELATORIOS.VENDASPRODUTOS.NAV'
        });
    }
})();
(function () {
    'use strict';

    angular
        .module('app.pages.relatorios.vendasprodutos')
        .factory('RelatorioVendaResource', RelatorioVendaResource);

    RelatorioVendaResource.$inject = ['$http', 'BACKEND_URL'];
    
    function RelatorioVendaResource( Http, backendUrl ) {

        var vm = {
            filtrarDadosVenda: filtrarDadosVendaFn,

            exportarAnaliticoPdf: exportarAnaliticoPdf,
            exportarAnaliticoExcel: exportarAnaliticoExcel,

            exportarSinteticoPdf: exportarSinteticoPdf,
            exportarSinteticoExcel: exportarSinteticoExcel
        };

        return vm;

        function filtrarDadosVendaFn( data ) {
            return Http.post(backendUrl + '/relatorio/resumovenda/sintetico', data);
        }

        function exportarAnaliticoPdf( data ) {
            return Http.post(backendUrl + '/relatorio/resumovenda/analitico/pdf', data);
        }

        function exportarAnaliticoExcel( data ) {
            return Http.post(backendUrl + '/relatorio/resumovenda/analitico/excel', data);
        }

        function exportarSinteticoPdf( data ) {
            return Http.post(backendUrl + '/relatorio/resumovenda/sintetico/pdf', data);
        }

        function exportarSinteticoExcel( data ) {
            return Http.post(backendUrl + '/relatorio/resumovenda/sintetico/excel', data);
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.pages.relatorios.vendasprodutos')
        .controller('RelatoriosVendasrodutosController', RelatoriosVendasrodutosController);

    RelatoriosVendasrodutosController.$inject = ['RelatorioVendaResource', '$filter', '$mdToast', 'downloadService', 'Util'];

    /** @ngInject */
    function RelatoriosVendasrodutosController( Resource, $filter, $mdToast, downloadService, Util ) {
        var vm = this;

        vm.myChart;

        vm.periodoItens = [ 'Hoje', '15 Dias', '30 Dias', 'Selecionar Data' ];

        /**
         * Locatário selecionado.
         */
        vm.locatario;

        /**
         * Evento selecionado.
         */
        vm.evento;

        /**
         * POS selecionado.
         */
        vm.pos;

        /**
         * Id do movimento de abertura selecionado.
         */
        vm.idAbertura;

        /**
         * Período do relatório.
         */
        vm.periodo = 2;

        /**
         * Data de inicio do período.
         */
        vm.dataInicio = new Date();

        /**
         * Data de fim do período.
         */
        vm.dataFim = new Date();

        /**
         * Intervalo de horas dos filtros
         */
        vm.horaInicio = 0;
        vm.minutoInicio = 0;
        vm.horaFim = 23;
        vm.minutoFim = 59;
        
        vm.minutosInicio = [
            0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55
        ];
        vm.minutosFim = vm.minutosInicio.concat([59]);
        
        vm.totalQuantidade = 0;
        vm.totalValor = 0;
        
        vm.exporting = false;
        vm.somenteCortesia = false;

        //---

        vm.onSelectEvento = onSelectEvento;
        vm.onSelectLocatario = onSelectLocatario;

        vm.carregarDadosVenda = carregarDadosVenda;

        vm.calcularPorcentagem = calcularPorcentagem;

        vm.formatarValor = formatarValor;

        vm.changeOrder = function( order ) {
            vm.order = order;
            vm.reverse = !vm.reverse;
        };

        vm.order = 'quantidade';
        vm.reverse = true;

        //---

        vm.exportarAnaliticoPdf = exportarAnaliticoPdf;
        vm.exportarAnaliticoExcel = exportarAnaliticoExcel;

        vm.exportarSinteticoPdf = exportarSinteticoPdf;
        vm.exportarSinteticoExcel = exportarSinteticoExcel;

        //---

        function exportarAnaliticoExcel() {
            vm.exporting = true;
            showLoadingToast();
            Resource.exportarAnaliticoExcel( getData() ).then(function( data ) {
                downloadService.download(data.data.fileName, data.data.conteudo);
                $mdToast.hide();
                vm.exporting = false;
            }, function(error) {
                vm.exporting = false;
                $mdToast.hide();
                Util.showToastMessage('Erro ao gerar relatório');
            });
        }

        function exportarAnaliticoPdf() {
            vm.exporting = true;
            showLoadingToast();
            Resource.exportarAnaliticoPdf( getData() ).then(function( data ) {
                downloadService.download(data.data.fileName, data.data.conteudo);
                $mdToast.hide();
                vm.exporting = false;
            }, function(error) {
                vm.exporting = false;
                $mdToast.hide();
                Util.showToastMessage('Erro ao gerar relatório');
            });
        }

        //---

        function exportarSinteticoPdf() {
            vm.exporting = true;
            showLoadingToast();
            Resource.exportarSinteticoPdf( getData() ).then(function( data ) {
                downloadService.download(data.data.fileName, data.data.conteudo);
                $mdToast.hide();
                vm.exporting = false;
            }, function(error) {
                vm.exporting = false;
                $mdToast.hide();
                Util.showToastMessage('Erro ao gerar relatório');
            });
        }

        function exportarSinteticoExcel() {
            vm.exporting = true;
            showLoadingToast();
            Resource.exportarSinteticoExcel( getData() ).then(function( data ) {
                downloadService.download(data.data.fileName, data.data.conteudo);
                $mdToast.hide();
                vm.exporting = false;
            }, function(error) {
                vm.exporting = false;
                $mdToast.hide();
                Util.showToastMessage('Erro ao gerar relatório');
            });
        }
        
        //---

        /**
         * Executado ao selecionar o locatario.
         */
        function onSelectLocatario() {
            delete vm.data;
        }

        /**
         * Executado ao selecionar o evento.
         */
        function onSelectEvento() {
            carregarDadosVenda();
        }

        function carregarDadosVenda() {
            if (!vm.evento || !vm.evento.id) {
                return;
            }
            
            Chart.defaults.global.legend.display = false;
            Chart.defaults.global.maintainAspectRatio = false;

            vm.totalValor = 0;
            vm.totalQuantidade = 0;

            Resource.filtrarDadosVenda( getData() ).then(function( content ) {
                vm.data = content.data;
                
                var item;

                for(var i in vm.data) {
                    item = vm.data[i];

                    item.total = Number( item.total );
                    item.quantidade = Number( item.quantidade );

                    vm.totalValor += item.total;
                    vm.totalQuantidade += item.quantidade;
                }

                for(var x in vm.data) {
                    item = vm.data[x];

                    item.porcentagemQuantidade = Number(vm.calcularPorcentagem(Number(vm.totalQuantidade), item.quantidade));
                    item.porcentagemValor = Number(vm.calcularPorcentagem(Number(vm.totalValor), item.total));
                }

                inicializarGrafico();
            });
        }

        function showLoadingToast() {
            $mdToast.show({
                template: '<md-toast><span flex>Gerando relatório</span> <md-progress-circular class="md-accent" md-mode="indeterminate"></md-progress-circular></md-toast>',
                hideDelay: 0,
                position: 'bottom right'
            });
        }

        function getData() {
            var today = new Date();

            var dataInicio;
            var dataFim = Util.formatDate(today) + ' 23:59:59';

            if( !vm.evento ) return;
            
            if( vm.periodo == 0 ) {
        
                dataInicio = Util.formatDate(today) + ' 00:00:00';
            
            } else if( vm.periodo == 1 ) {
                
                dataInicio = getDate( 15 );

            } else if( vm.periodo == 2 ) {

                dataInicio = getDate( 30 );
                
            } else if( vm.periodo == 3 ) {
                
                if( !vm.dataInicio ) {
                    return;
                } else {
                    dataInicio = Util.formatDate(vm.dataInicio) + ' ' + getTime(vm.horaInicio, vm.minutoInicio);
                }

                dataFim = Util.formatDate(vm.dataFim) + ' ' + getTime(vm.horaFim, vm.minutoFim);
            }

            var perfilamento = JSON.parse( localStorage.getItem('perfilamento') );

            return {
                idEvento: vm.evento.id,
                idLocatario: vm.locatario.id,
                usuario: perfilamento.dsNomeUsuario,
                dataInicio: dataInicio,
                dataFim: dataFim,
                pos: vm.pos,
                idMovimentoAbertura: vm.idAbertura,
                somenteCortesia: vm.somenteCortesia
            };
            
            function getDate( less ) {
                var today = new Date()
                var priorDate = new Date().setDate(today.getDate() - less );

                return Util.formatDate(new Date(priorDate)) + ' 00:00:00';
            }

            function getTime(hour, minute) {
                var time = '';
                if (hour < 10) {
                    time = '0' + hour;
                } else {
                    time += hour;
                }
                time += ":";
                if (minute < 10) {
                    time += '0' + minute;
                } else {
                    time += minute;
                }
                if (minute == 59) {
                    time += ":59";
                } else {
                    time += ":00";
                }
                
                return time;
            }

        }

        function calcularPorcentagem(total, valor) {
            var porcentagem = (100 * valor) / total;
            return parseFloat( porcentagem.toFixed( 2 ) ).toFixed(2);
        }

        /**
         * Inicializa o gráfico da tela.
         */
        function inicializarGrafico() {
            if( vm.myChart ) {
                vm.myChart.destroy();
            }

            var ctx = document.getElementById("myChart");

                var options = {
                    scales: {
                        yAxes: [{
                            ticks: {
                                beginAtZero:true,
                                callback: function( value ) {
                                    return value == 0 ? '0,00' : formatarValor( value );
                                }
                            }
                        }]
                    },
                    tooltips: {
                        callbacks: {
                            label: function( tooltipItem, data ) {
                                var value = data.datasets[0].data[tooltipItem.index];

                                return value == 0 ? '0,00' : formatarValor( value );
                            }
                        }
                    }
                };

                var content = {
                    labels: [],
                    datasets: [{
                        data: [],
                        backgroundColor: [],
                        borderColor: [],
                        borderWidth: 1
                    }]
                };

                var filteredList = $filter('orderBy')(vm.data, 'total', true);

                var hasData = false, totalOutros = 0;

                for(var i in filteredList) {
                    var item = filteredList[i];

                    if( i < 19 ) {
                        content.labels.push( item.displayPos );
                        content.datasets[0].data.push(item.total);
                        content.datasets[0].backgroundColor.push('rgba(54, 162, 235, 0.2)');
                        content.datasets[0].borderColor.push('rgba(54, 162, 235, 1)');
                    } else {
                        totalOutros += item.total;
                        hasData = true;
                    }
                }

                if( hasData ) {
                    content.labels.push( 'Outros' );
                    content.datasets[0].data.push( totalOutros );
                    content.datasets[0].backgroundColor.push('rgba(54, 162, 235, 0.2)');
                    content.datasets[0].borderColor.push('rgba(54, 162, 235, 1)');
                }

                vm.myChart = new Chart(ctx, {
                    type: 'bar',
                    data: content,
                    options: options
                });
        }

        function converterData(data) {
            return data.split('-').reverse().join('/');
        }

        function formatarValor( valor, quantidade ) {
            valor = valor.toFixed(2).split('.');

            var output = '';
            var count = 0;

            for(var i = valor[0].length - 1; i >= 0 ; i--) {
                count++;

                output += valor[0][i];

                if( count == 3 ) {
                    count = 0;
                    
                    if( (i - 1) >= 0 ) {
                        output += '.';
                    }
                }
            }

            var retorno = output.split('').reverse().join(''); 

            if( !quantidade ) { 
                retorno += ',' + valor[1];
            }   

            return retorno;
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('app.pages.relatorios.saldoestoque', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {

        $stateProvider
            .state('relatorios.saldoestoque', {
                url    : '/saldoestoque',
                templateUrl: 'app/main/pages/relatorios/saldoestoque/index.html',
                controller : 'RelatoriosSaldoEstoqueController as relatorio'
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/relatorios/saldoestoque');

        //---

        msNavigationServiceProvider.saveItem('relatorios.saldoestoque', {
            title    : 'Saldo de Estoque',
            icon     : 'icon-chart-histogram',
            state    : ['relatorios.saldoestoque'],
            translate: 'RELATORIOS.SALDOESTOQUE.NAV'
        });
    }
    
})();
(function() {
    'use strict';

    angular
        .module('app.pages.relatorios.saldoestoque')
        .factory('RelatorioSaldoEstoqueResource', RelatorioSaldoEstoqueResource);

    RelatorioSaldoEstoqueResource.$inject = ['$http', 'BACKEND_URL'];

    function RelatorioSaldoEstoqueResource( Http, backendUrl ) {

        var vm = {
            filtrarSaldoEstoque: filtrarSaldoEstoqueFn,
            exportarAnaliticoPdf: exportarAnaliticoPdfFn,
            exportarAnaliticoExcel: exportarAnaliticoExcelFn,
            exportarSinteticoPdf: exportarSinteticoPdfFn,
            exportarSinteticoExcel: exportarSinteticoExcelFn
        };

        return vm;

        function filtrarSaldoEstoqueFn( idEvento, produto ) {
            return Http.post(backendUrl + '/relatorio/saldoestoque/' + idEvento + '/' + produto);
        }

        function exportarAnaliticoPdfFn( idLocatario, idEvento, produto ) {
            return Http.post(backendUrl + '/relatorio/saldoestoque/analitico/pdf/' + idLocatario + '/' + idEvento + '/' + produto);
        }

        function exportarAnaliticoExcelFn( idLocatario, idEvento, produto ) {
            return Http.post(backendUrl + '/relatorio/saldoestoque/analitico/excel/' + idLocatario + '/' + idEvento + '/' + produto);
        }

        function exportarSinteticoPdfFn( idLocatario, idEvento, produto ) {
            return Http.post(backendUrl + '/relatorio/saldoestoque/sintetico/pdf/' + idLocatario + '/' + idEvento + '/' + produto);
        }

        function exportarSinteticoExcelFn( idLocatario, idEvento, produto ) {
            return Http.post(backendUrl + '/relatorio/saldoestoque/sintetico/excel/' + idLocatario + '/' + idEvento + '/' + produto);
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.pages.relatorios.saldoestoque')
        .controller('RelatoriosSaldoEstoqueController', RelatoriosSaldoEstoqueController);

        RelatoriosSaldoEstoqueController.$inject = ['RelatorioSaldoEstoqueResource', '$filter', '$mdToast', 'downloadService', 'Util'];

        /** @ngInject */
        function RelatoriosSaldoEstoqueController( Resource, $filter, $mdToast, downloadService, Util ) {
            var vm = this;

            vm.barChart;

            vm.search = "";

            vm.locatario;

            vm.evento;

            vm.onSelectEvento = onSelectEventoFn;
            vm.onSelectLocatario = onSelectLocatarioFn;
            vm.exportarAnaliticoPdf = exportarAnaliticoPdfFn;
            vm.exportarAnaliticoExcel = exportarAnaliticoExcelFn;
            vm.exportarSinteticoPdf = exportarSinteticoPdfFn;
            vm.exportarSinteticoExcel = exportarSinteticoExcelFn;

            vm.carregarDados = carregarDadosFn;

            vm.formatarValor = formatarValorFn;

            vm.filter = filterFn;

            vm.exporting = false;

            function onSelectEventoFn() {
                carregarDadosFn("null");
            }

            function onSelectLocatarioFn() {
                delete vm.data;
            }

            function carregarDadosFn(produto) {
                if (!vm.evento || !vm.evento.id) {
                    return;
                }
            
                Chart.defaults.global.legend.display = false;
                Chart.defaults.global.maintainAspectRatio = false;
                
                vm.totalValor = 0;
    
                Resource.filtrarSaldoEstoque( vm.evento.id, produto ).then(function( content ) {
                    vm.data = content.data;
                    inicializarGraficoColunas();
                });
            }

            function exportarAnaliticoPdfFn() {
                var produto = vm.search;
                if (produto == "") {
                    produto = "null"; 
                }
                vm.exporting = true;
                showLoadingToast();
                Resource.exportarAnaliticoPdf( vm.locatario.id, vm.evento.id, produto ).then(function( data ) {
                    if (data != null && data.data != "") {
                        downloadService.download(data.data.fileName, data.data.conteudo);
                    } else {
                        Util.showToastMessage('Erro ao gerar relatório');
                    }
                    $mdToast.hide();
                    vm.exporting = false;
                }, function(error) {
                    vm.exporting = false;
                    $mdToast.hide();
                    Util.showToastMessage('Erro ao gerar relatório');
                });
            }

            function exportarAnaliticoExcelFn() {
                var produto = vm.search;
                if (produto == "") {
                    produto = "null"; 
                }
                vm.exporting = true;
                showLoadingToast();
                Resource.exportarAnaliticoExcel( vm.locatario.id, vm.evento.id, produto ).then(function( data ) {
                    if (data != null && data.data != "") {
                        downloadService.download(data.data.fileName, data.data.conteudo);
                    } else {
                        Util.showToastMessage('Erro ao gerar relatório');
                    }
                    $mdToast.hide();
                    vm.exporting = false;
                }, function(error) {
                    vm.exporting = false;
                    $mdToast.hide();
                    Util.showToastMessage('Erro ao gerar relatório');
                });
            }

            function exportarSinteticoPdfFn() {
                var produto = vm.search;
                if (produto == "") {
                    produto = "null"; 
                }
                vm.exporting = true;
                showLoadingToast();
                Resource.exportarSinteticoPdf( vm.locatario.id, vm.evento.id, produto ).then(function( data ) {
                    if (data != null && data.data != "") {
                        downloadService.download(data.data.fileName, data.data.conteudo);
                    } else {
                        Util.showToastMessage('Erro ao gerar relatório');
                    }
                    $mdToast.hide();
                    vm.exporting = false;
                }, function(error) {
                    vm.exporting = false;
                    $mdToast.hide();
                    Util.showToastMessage('Erro ao gerar relatório');
                });
            }

            function exportarSinteticoExcelFn() {
                var produto = vm.search;
                if (produto == "") {
                    produto = "null"; 
                }
                vm.exporting = true;
                showLoadingToast();
                Resource.exportarSinteticoExcel( vm.locatario.id, vm.evento.id, produto ).then(function( data ) {
                    if (data != null && data.data != "") {
                        downloadService.download(data.data.fileName, data.data.conteudo);
                    } else {
                        Util.showToastMessage('Erro ao gerar relatório');
                    }
                    $mdToast.hide();
                    vm.exporting = false;
                }, function(error) {
                    vm.exporting = false;
                    $mdToast.hide();
                    Util.showToastMessage('Erro ao gerar relatório');
                });
            }

            function inicializarGraficoColunas() {
                if( vm.barChart ) {
                    vm.barChart.destroy();
                }
    
                var ctx = document.getElementById("barChart");
    
                var options = {
                    legend: {
                        display: false
                    },
                    scales: {
                        yAxes: [{
                            ticks: {
                                beginAtZero:true,
                                callback: function( value ) {
                                    return value == 0 ? '0,00' : formatarValorFn( value );
                                }
                            }
                        }]
                    },
                    tooltips: {
                        callbacks: {
                            label: function ( tooltipItem, data ) {
                                var value = data.datasets[0].data[tooltipItem.index];
                                
                                return (value == 0 ? '0,00' : formatarValorFn( value ));
                            }
                        }
                    }
                };
    
                var content = {
                    labels: [],
                    datasets: [{
                        data: [],
                        backgroundColor: [],
                        borderColor: [],
                        borderWidth: 1
                    }]
                };
                for(var i = 0; i < vm.data.length; i++) {
                    content.labels.push( vm.data[i].dsDescricao );
                    content.datasets[0].data.push( vm.data[i].qtdSaldo );
                    content.datasets[0].backgroundColor.push('rgba(54, 162, 235, 0.2)');
                    content.datasets[0].borderColor.push('rgba(54, 162, 235, 1)');
                }
    
                vm.barChart = new Chart(ctx, {
                    type: 'bar',
                    data: content,
                    options: options
                });
            }

            function formatarValorFn( valor, quantidade ) {
                valor = valor.toFixed(2).split('.');
    
                var output = '';
                var count = 0;
    
                for(var i = valor[0].length - 1; i >= 0 ; i--) {
                    count++;
    
                    output += valor[0][i];
    
                    if( count == 3 ) {
                        count = 0;
                        
                        if( (i - 1) >= 0 ) {
                            output += '.';
                        }
                    }
                }
    
                var retorno = output.split('').reverse().join(''); 
    
                if( !quantidade ) { 
                    retorno += ',' + valor[1];
                }   
    
                return retorno;
            }

            function filterFn() {
                if (!vm.search || vm.search == "") {
                    carregarDadosFn("null");
                }
                carregarDadosFn(vm.search);
            }

            function showLoadingToast() {
                $mdToast.show({
                    template: '<md-toast><span flex>Gerando relatório</span> <md-progress-circular class="md-accent" md-mode="indeterminate"></md-progress-circular></md-toast>',
                    hideDelay: 0,
                    position: 'bottom right'
                });
            }
        }
})();
(function () {
    'use strict';

    angular
        .module('app.pages.relatorios.movimentacaofinanceira', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {

        $stateProvider
            .state('relatorios.movimentacaofinanceira', {
                url    : '/movimentacaofinanceira',
                templateUrl: 'app/main/pages/relatorios/movimentacaofinanceira/index.html',
                controller : 'RelatoriosMovFinanceiraController as relatorio'
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/relatorios/movimentacaofinanceira');

        //---

        msNavigationServiceProvider.saveItem('relatorios.movimentacaofinanceira', {
            title    : 'Vendas por F. Pagamento',
            icon     : 'icon-chart-pie',
            state    : ['relatorios.movimentacaofinanceira'],
            translate: 'RELATORIOS.MOVFINANCEIRA.NAV'
        });
    }
})();
(function () {
    'use strict';

    angular
        .module('app.pages.relatorios.movimentacaofinanceira')
        .factory('RelatorioMovFinanceiraResource', RelatorioMovFinanceiraResource);

    RelatorioMovFinanceiraResource.$inject = ['$http', 'BACKEND_URL'];
    
    function RelatorioMovFinanceiraResource( Http, backendUrl) {

        var vm = {
            filtrarDadosMovFinanceira: filtrarDadosMovFinanceiraFn,

            exportarAnaliticoPdf: exportarAnaliticoPdf,
            exportarAnaliticoExcel: exportarAnaliticoExcel,

            exportarSinteticoPdf: exportarSinteticoPdf,
            exportarSinteticoExcel: exportarSinteticoExcel
        };

        return vm;

        function filtrarDadosMovFinanceiraFn( data ) {
            return Http.post(backendUrl + '/relatorio/movfinanceira/sintetico', data);
        }

        function exportarAnaliticoPdf( data ) {
            return Http.post(backendUrl + '/relatorio/movfinanceira/analitico/pdf', data);
        }

        function exportarAnaliticoExcel( data ) {
            return Http.post(backendUrl + '/relatorio/movfinanceira/analitico/excel', data);
        }

        function exportarSinteticoPdf( data ) {
            return Http.post(backendUrl + '/relatorio/movfinanceira/sintetico/pdf', data);
        }

        function exportarSinteticoExcel( data ) {
            return Http.post(backendUrl + '/relatorio/movfinanceira/sintetico/excel', data);
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.pages.relatorios.movimentacaofinanceira')
        .controller('RelatoriosMovFinanceiraController', RelatoriosMovFinanceiraController);

    RelatoriosMovFinanceiraController.$inject = ['RelatorioMovFinanceiraResource', '$filter', '$mdToast', 'downloadService', 'Util'];

    /** @ngInject */
    function RelatoriosMovFinanceiraController( Resource, $filter, $mdToast, downloadService, Util ) {
        var vm = this;

        vm.barChart;

        vm.periodoItens = [ 'Hoje', '15 Dias', '30 Dias', 'Selecionar Data' ];

        /**
         * Locatário selecionado.
         */
        vm.locatario;

        /**
         * Evento selecionado.
         */
        vm.evento;

        /**
         * POS selecionado.
         */
        vm.pos;

        /**
         * Id de Movimento de Abertura selecionado.
         */
        vm.idAbertura;

        /**
         * Período do relatório.
         */
        vm.periodo = 2;

        /**
         * Data de inicio do período.
         */
        vm.dataInicio = new Date();

        /**
         * Data de fim do período.
         */
        vm.dataFim = new Date();
        
        /**
         * Intervalo de horas dos filtros
         */
        vm.horaInicio = 0;
        vm.minutoInicio = 0;
        vm.horaFim = 23;
        vm.minutoFim = 59;
        
        vm.minutosInicio = [
            0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55
        ];
        vm.minutosFim = vm.minutosInicio.concat([59]);
        
        vm.totalValor = 0;

        //---

        vm.onSelectEvento = onSelectEvento;
        vm.onSelectLocatario = onSelectLocatario;

        vm.carregarDadosMovimentacao = carregarDadosMovimentacao;

        vm.formatarValor = formatarValor;

        vm.changeOrder = function( order ) {
            vm.order = order;
            vm.reverse = !vm.reverse;
        };

        vm.order = 'total';
        vm.reverse = true;

        //---

        vm.exportarAnaliticoPdf = exportarAnaliticoPdf;
        vm.exportarAnaliticoExcel = exportarAnaliticoExcel;

        vm.exportarSinteticoPdf = exportarSinteticoPdf;
        vm.exportarSinteticoExcel = exportarSinteticoExcel;
        
        vm.exporting = false;

        //---

        function exportarAnaliticoExcel() {
            vm.exporting = true;
            showLoadingToast();
            Resource.exportarAnaliticoExcel( getData() ).then(function( data ) {
                downloadService.download(data.data.fileName, data.data.conteudo);
                $mdToast.hide();
                vm.exporting = false;
            }, function(error) {
                vm.exporting = false;
                $mdToast.hide();
                Util.showToastMessage('Erro ao gerar relatório');
            });
        }

        function exportarAnaliticoPdf() {
            vm.exporting = true;
            showLoadingToast();
            Resource.exportarAnaliticoPdf( getData() ).then(function( data ) {
                downloadService.download(data.data.fileName, data.data.conteudo);
                $mdToast.hide();
                vm.exporting = false;
            }, function(error) {
                vm.exporting = false;
                $mdToast.hide();
                Util.showToastMessage('Erro ao gerar relatório');
            });
        }

        //---

        function exportarSinteticoPdf() {
            vm.exporting = true;
            showLoadingToast();
            Resource.exportarSinteticoPdf( getData() ).then(function( data ) {
                downloadService.download(data.data.fileName, data.data.conteudo);
                $mdToast.hide();
                vm.exporting = false;
            }, function(error) {
                vm.exporting = false;
                $mdToast.hide();
                Util.showToastMessage('Erro ao gerar relatório');
            });
        }

        function exportarSinteticoExcel() {
            vm.exporting = true;
            showLoadingToast();
            Resource.exportarSinteticoExcel( getData() ).then(function( data ) {
                downloadService.download(data.data.fileName, data.data.conteudo);
                $mdToast.hide();
                vm.exporting = false;
            }, function(error) {
                vm.exporting = false;
                $mdToast.hide();
                Util.showToastMessage('Erro ao gerar relatório');
            });
        }

        //---

        /**
         * Executado ao selecionar o locatario.
         */
        function onSelectLocatario() {
            delete vm.data;
        }

        /**
         * Executado ao selecionar o evento.
         */
        function onSelectEvento() {
            carregarDadosMovimentacao();
        }

        function carregarDadosMovimentacao() {
            if (!vm.evento || !vm.evento.id) {
                return;
            }
            
            Chart.defaults.global.legend.display = false;
            Chart.defaults.global.maintainAspectRatio = false;
            
            vm.totalValor = 0;

            Resource.filtrarDadosMovFinanceira( getData() ).then(function( content ) {
                vm.data = content.data;

                inicializarGraficoColunas();
                inicializarGraficoPizza();
            });
        }

        function showLoadingToast() {
            $mdToast.show({
                template: '<md-toast><span flex>Gerando relatório</span> <md-progress-circular class="md-accent" md-mode="indeterminate"></md-progress-circular></md-toast>',
                hideDelay: 0,
                position: 'bottom right'
            });
        }

        function getData() {
            var today = new Date();

            var dataInicio;
            var dataFim = Util.formatDate(today) + ' 23:59:59';

            if( vm.periodo == 0 ) {
        
                dataInicio = Util.formatDate(today) + ' 00:00:00';
            
            } else if( vm.periodo == 1 ) {
                
                dataInicio = getDate( 15 );

            } else if( vm.periodo == 2 ) {

                dataInicio = getDate( 30 );
                
            } else if( vm.periodo == 3 ) {
                
                if( !vm.dataInicio ) {
                    return;
                } else {
                    dataInicio = Util.formatDate(vm.dataInicio) + ' ' + getTime(vm.horaInicio, vm.minutoInicio);
                }

                dataFim = Util.formatDate(vm.dataFim) + ' ' + getTime(vm.horaFim, vm.minutoFim);
            }

            var perfilamento = JSON.parse( localStorage.getItem('perfilamento') );

            return {
                idEvento: vm.evento.id,
                idLocatario: vm.locatario.id,
                usuario: perfilamento.dsNomeUsuario,
                dataInicio: dataInicio,
                dataFim: dataFim,
                pos: vm.pos,
                idMovimentoAbertura: vm.idAbertura
            };
            
            function getDate( less ) {
                var today = new Date()
                var priorDate = new Date().setDate(today.getDate() - less );

                return Util.formatDate(new Date(priorDate)) + ' 00:00:00';
            }
            
            function getTime(hour, minute) {
                var time = '';
                if (hour < 10) {
                    time = '0' + hour;
                } else {
                    time += hour;
                }
                time += ":";
                if (minute < 10) {
                    time += '0' + minute;
                } else {
                    time += minute;
                }
                if (minute == 59) {
                    time += ":59";
                } else {
                    time += ":00";
                }
                
                return time;
            }

        }

        /**
         * Inicializa o gráfico de colunas.
         */
        function inicializarGraficoColunas() {
            if( vm.barChart ) {
                vm.barChart.destroy();
            }

            var ctx = document.getElementById("barChart");

            var options = {
                legend: {
                    display: false
                },
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero:true,
                            callback: function( value ) {
                                return value == 0 ? '0,00' : formatarValor( value );
                            }
                        }
                    }]
                },
                tooltips: {
                    callbacks: {
                        label: function ( tooltipItem, data ) {
                            var value = data.datasets[0].data[tooltipItem.index];
                            
                            return (value == 0 ? '0,00' : formatarValor( value ));
                        }
                    }
                }
            };

            var content = {
                labels: [],
                datasets: [{
                    data: [],
                    backgroundColor: [],
                    borderColor: [],
                    borderWidth: 1
                }]
            };

            for(var i = 0; i < vm.data.totalVendas.length; i++) {
                content.labels.push( vm.data.totalVendas[i].data );
                content.datasets[0].data.push( vm.data.totalVendas[i].total );
                content.datasets[0].backgroundColor.push('rgba(54, 162, 235, 0.2)');
                content.datasets[0].borderColor.push('rgba(54, 162, 235, 1)');
            }

            vm.barChart = new Chart(ctx, {
                type: 'bar',
                data: content,
                options: options
            });
        }

        /**
         * Inicializa o gráfico de pizza.
         */
        function inicializarGraficoPizza() {
            if( vm.pieChart ) {
                vm.pieChart.destroy();
            }

            var ctx = document.getElementById("pieChart");

            var dataset = {
                data: [],
                backgroundColor: [
                    "#FF6384",
                    "#36A2EB",
                    "#FFCE56"
                ],
                hoverBackgroundColor: [
                    "#FF6384",
                    "#36A2EB",
                    "#FFCE56"
                ]
            };
            var content = {
                labels: [],
                datasets: [dataset]
            };

            for(var i = 0; i < vm.data.totalVendasFormaPagamento.length; i++) {
                content.labels.push( vm.data.totalVendasFormaPagamento[i].dsFormaPagRec );
                dataset.data.push(vm.data.totalVendasFormaPagamento[i].total);
                
                vm.totalValor += vm.data.totalVendasFormaPagamento[i].total;
            }

            var options = {
                legend: {
                    display: true
                },
                tooltips: {
                    callbacks: {
                        label: function ( tooltipItem, data ) {
                            var value = data.datasets[0].data[tooltipItem.index];
                            var label = data.labels[tooltipItem.index];

                            return label + ': ' + (value == 0 ? '0,00' : formatarValor( value ));
                        }
                    }
                }
            };

            vm.pieChart = new Chart(ctx, {
                type: 'pie',
                data: content,
                options: options
            });
        }
        
        function converterData(data) {
            return data.split('-').reverse().join('/');
        }

        function formatarValor( valor, quantidade ) {
            valor = valor.toFixed(2).split('.');

            var output = '';
            var count = 0;

            for(var i = valor[0].length - 1; i >= 0 ; i--) {
                count++;

                output += valor[0][i];

                if( count == 3 ) {
                    count = 0;
                    
                    if( (i - 1) >= 0 ) {
                        output += '.';
                    }
                }
            }

            var retorno = output.split('').reverse().join(''); 

            if( !quantidade ) { 
                retorno += ',' + valor[1];
            }   

            return retorno;
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.pages.relatorios.consumoprepago', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {

        $stateProvider
            .state('relatorios.consumoprepago', {
                url    : '/consumoprepago',
                templateUrl: 'app/main/pages/relatorios/consumoprepago/index.html',
                controller : 'RelatoriosConsumoPrePagoController as relatorio'
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/relatorios/consumoprepago');

        //---

        msNavigationServiceProvider.saveItem('relatorios.consumoprepago', {
            title    : 'Consumo Pré-pago Produtos',
            icon     : 'icon-chart-areaspline',
            state    : ['relatorios.consumoprepago'],
            translate: 'RELATORIOS.CONSUMOPREPAGO.NAV'
        }); 
        
    }
})();
(function () {
    'use strict';

    angular
        .module('app.pages.relatorios.consumoprepago')
        .factory('RelatorioConsumoPrePagoResource', RelatorioConsumoPrePagoResource);

    RelatorioConsumoPrePagoResource.$inject = ['$http', 'BACKEND_URL'];
    
    function RelatorioConsumoPrePagoResource( Http, backendUrl) {

        var vm = {
            filtrarDados: filtrarDadosFn,

            exportarAnaliticoPdf: exportarAnaliticoPdf,
            exportarAnaliticoExcel: exportarAnaliticoExcel,

            exportarSinteticoPdf: exportarSinteticoPdf,
            exportarSinteticoExcel: exportarSinteticoExcel
        };

        return vm;

        function filtrarDadosFn( data ) {
            return Http.post(backendUrl + '/relatorio/consumoprepago/sintetico', data);
        }

        function exportarAnaliticoPdf( data ) {
            return Http.post(backendUrl + '/relatorio/consumoprepago/analitico/pdf', data);
        }

        function exportarAnaliticoExcel( data ) {
            return Http.post(backendUrl + '/relatorio/consumoprepago/analitico/excel', data);
        }

        function exportarSinteticoPdf( data ) {
            return Http.post(backendUrl + '/relatorio/consumoprepago/sintetico/pdf', data);
        }

        function exportarSinteticoExcel( data ) {
            return Http.post(backendUrl + '/relatorio/consumoprepago/sintetico/excel', data);
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.pages.relatorios.consumoprepago')
        .controller('RelatoriosConsumoPrePagoController', RelatoriosConsumoPrePagoController);

    RelatoriosConsumoPrePagoController.$inject = ['RelatorioConsumoPrePagoResource', '$filter', '$mdToast', 'downloadService', 'Util'];

    /** @ngInject */
    function RelatoriosConsumoPrePagoController( Resource, $filter, $mdToast, downloadService, Util ) {
        var vm = this;

        vm.barChart;

        vm.periodoItens = [ 'Hoje', '15 Dias', '30 Dias', 'Selecionar Data' ];

        /**
         * Locatário selecionado.
         */
        vm.locatario;

        /**
         * Evento selecionado.
         */
        vm.evento;

        /**
         * POS selecionado.
         */
        vm.pos;

        /**
         * Período do relatório.
         */
        vm.periodo = 2;
        
        /**
         * ID da carga Mifare
         */
        vm.carga;
        
        /**
         * SN Mifare ou ID Mifare
         */
        vm.mifare;

        /**
         * Data de inicio do período.
         */
        vm.dataInicio = new Date();

        /**
         * Data de fim do período.
         */
        vm.dataFim = new Date();
        
        /**
         * Intervalo de horas dos filtros
         */
        vm.horaInicio = 0;
        vm.minutoInicio = 0;
        vm.horaFim = 23;
        vm.minutoFim = 59;
        
        vm.minutosInicio = [
            0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55
        ];
        vm.minutosFim = vm.minutosInicio.concat([59]);
        
        //---

        vm.onSelectEvento = onSelectEvento;
        vm.onSelectLocatario = onSelectLocatario;

        vm.carregarDadosMovimentacao = carregarDadosMovimentacao;

        vm.formatarValor = formatarValor;

        vm.changeOrder = function( order ) {
            vm.order = order;
            vm.reverse = !vm.reverse;
        };

        vm.order = 'valor';
        vm.reverse = true;

        //---

        vm.exportarAnaliticoPdf = exportarAnaliticoPdf;
        vm.exportarAnaliticoExcel = exportarAnaliticoExcel;

        vm.exportarSinteticoPdf = exportarSinteticoPdf;
        vm.exportarSinteticoExcel = exportarSinteticoExcel;
        
        vm.exporting = false;
        
        vm.total = {
            quantidade: 0,
            valor: 0,
            percentQuantidade: 0,
            percentValor: 0
        };

        //---

        function exportarAnaliticoExcel() {
            vm.exporting = true;
            showLoadingToast();
            Resource.exportarAnaliticoExcel( getData() ).then(function( data ) {
                downloadService.download(data.data.fileName, data.data.conteudo);
                $mdToast.hide();
                vm.exporting = false;
            }, function(error) {
                vm.exporting = false;
                $mdToast.hide();
                Util.showToastMessage('Erro ao gerar relatório');
            });
        }

        function exportarAnaliticoPdf() {
            vm.exporting = true;
            showLoadingToast();
            Resource.exportarAnaliticoPdf( getData() ).then(function( data ) {
                downloadService.download(data.data.fileName, data.data.conteudo);
                $mdToast.hide();
                vm.exporting = false;
            }, function(error) {
                vm.exporting = false;
                $mdToast.hide();
                Util.showToastMessage('Erro ao gerar relatório');
            });
        }

        //---

        function exportarSinteticoPdf() {
            vm.exporting = true;
            showLoadingToast();
            Resource.exportarSinteticoPdf( getData() ).then(function( data ) {
                downloadService.download(data.data.fileName, data.data.conteudo);
                $mdToast.hide();
                vm.exporting = false;
            }, function(error) {
                vm.exporting = false;
                $mdToast.hide();
                Util.showToastMessage('Erro ao gerar relatório');
            });
        }

        function exportarSinteticoExcel() {
            vm.exporting = true;
            showLoadingToast();
            Resource.exportarSinteticoExcel( getData() ).then(function( data ) {
                downloadService.download(data.data.fileName, data.data.conteudo);
                $mdToast.hide();
                vm.exporting = false;
            }, function(error) {
                vm.exporting = false;
                $mdToast.hide();
                Util.showToastMessage('Erro ao gerar relatório');
            });
        }

        //---

        /**
         * Executado ao selecionar o locatario.
         */
        function onSelectLocatario() {
            delete vm.data;
        }

        /**
         * Executado ao selecionar o evento.
         */
        function onSelectEvento() {
            carregarDadosMovimentacao();
        }

        function carregarDadosMovimentacao() {
            if (!vm.evento || !vm.evento.id) {
                return;
            }
            
            Chart.defaults.global.legend.display = false;
            Chart.defaults.global.maintainAspectRatio = false;
            
            Resource.filtrarDados( getData() ).then(function( content ) {
                vm.data = content.data;

                inicializarGraficoColunas();
                totalizar();
            });
        }

        function showLoadingToast() {
            $mdToast.show({
                template: '<md-toast><span flex>Gerando relatório</span> <md-progress-circular class="md-accent" md-mode="indeterminate"></md-progress-circular></md-toast>',
                hideDelay: 0,
                position: 'bottom right'
            });
        }

        function getData() {
            var today = new Date();

            var dataInicio;
            var dataFim = Util.formatDate(today) + ' 23:59:59';

            if( vm.periodo == 0 ) {
        
                dataInicio = Util.formatDate(today) + ' 00:00:00';
            
            } else if( vm.periodo == 1 ) {
                
                dataInicio = getDate( 15 );

            } else if( vm.periodo == 2 ) {

                dataInicio = getDate( 30 );
                
            } else if( vm.periodo == 3 ) {
                
                if( !vm.dataInicio ) {
                    return;
                } else {
                    dataInicio = Util.formatDate(vm.dataInicio) + ' ' + getTime(vm.horaInicio, vm.minutoInicio);
                }

                dataFim = Util.formatDate(vm.dataFim) + ' ' + getTime(vm.horaFim, vm.minutoFim);
            }

            var perfilamento = JSON.parse( localStorage.getItem('perfilamento') );

            return {
                idEvento: vm.evento.id,
                idLocatario: vm.locatario.id,
                usuario: perfilamento.dsNomeUsuario,
                dataInicio: dataInicio,
                dataFim: dataFim,
                pos: vm.pos,
                carga: vm.carga,
                mifare: vm.mifare
            };
            
            function getDate( less ) {
                var today = new Date()
                var priorDate = new Date().setDate(today.getDate() - less );

                return Util.formatDate(new Date(priorDate)) + ' 00:00:00';
            }
            
            function getTime(hour, minute) {
                var time = '';
                if (hour < 10) {
                    time = '0' + hour;
                } else {
                    time += hour;
                }
                time += ":";
                if (minute < 10) {
                    time += '0' + minute;
                } else {
                    time += minute;
                }
                if (minute == 59) {
                    time += ":59";
                } else {
                    time += ":00";
                }
                
                return time;
            }

        }

        /**
         * Inicializa o gráfico de colunas.
         */
        function inicializarGraficoColunas() {
            if( vm.barChart ) {
                vm.barChart.destroy();
            }

            var ctx = document.getElementById("barChart");

            var options = {
                legend: {
                    display: false
                },
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero:true,
                            callback: function( value ) {
                                return value == 0 ? '0,00' : formatarValor( value );
                            }
                        }
                    }]
                },
                tooltips: {
                    callbacks: {
                        label: function ( tooltipItem, data ) {
                            var value = data.datasets[0].data[tooltipItem.index];
                            
                            return (value == 0 ? '0,00' : formatarValor( value ));
                        }
                    }
                }
            };

            var content = {
                labels: [],
                datasets: [{
                    data: [],
                    backgroundColor: [],
                    borderColor: [],
                    borderWidth: 1
                }]
            };

            for(var i = 0; i < vm.data.length; i++) {
                content.labels.push( vm.data[i].dsDescricaoDisplayPos );
                content.datasets[0].data.push( vm.data[i].valor );
                content.datasets[0].backgroundColor.push('rgba(54, 162, 235, 0.2)');
                content.datasets[0].borderColor.push('rgba(54, 162, 235, 1)');
            }

            vm.barChart = new Chart(ctx, {
                type: 'bar',
                data: content,
                options: options
            });
        }

        function converterData(data) {
            return data.split('-').reverse().join('/');
        }

        function formatarValor( valor, quantidade ) {
            var negativeSymbol = '';
            valor = valor.toFixed(2);
            
            if (valor.substring(0, 1) == '-') {
                valor = valor.substring(1);
                negativeSymbol = '-';
            }
            
            valor = valor.split('.');

            var output = '';
            var count = 0;

            for(var i = valor[0].length - 1; i >= 0 ; i--) {
                count++;

                output += valor[0][i];

                if( count == 3 ) {
                    count = 0;
                    
                    if( (i - 1) >= 0 ) {
                        output += '.';
                    }
                }
            }

            var retorno = output.split('').reverse().join(''); 

            if( !quantidade ) { 
                retorno += ',' + valor[1];
            }   

            return negativeSymbol + retorno;
        }
        
        function totalizar() {
            vm.total = {
                quantidade : 0,
                valor : 0,
                percentQuantidade: vm.data.length > 0 ? 100 : 0,
                percentValor: vm.data.length > 0 ? 100 : 0
            };
            
            vm.data.forEach(function(item) {
                vm.total.quantidade += item.quantidade;
                vm.total.valor += item.valor;
            });
            
            vm.data.forEach(function(item) {
                if (item.quantidade > 0 && vm.total.quantidade > 0) {
                    item.percentQuantidade = (item.quantidade * 100 / vm.total.quantidade).toFixed(2); 
                } else {
                    item.percentQuantidade = '0.00';
                }
                
                if (item.valor > 0 && vm.total.valor > 0) {
                    item.percentValor = (item.valor * 100 / vm.total.valor).toFixed(2);
                } else {
                    item.percentValor = '0.00'
                }
            });
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.pages.relatorios.cargaprepago', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {

        $stateProvider
            .state('relatorios.cargaprepago', {
                url    : '/cargaprepago',
                templateUrl: 'app/main/pages/relatorios/cargaprepago/index.html',
                controller : 'RelatoriosCargaPrePagoController as relatorio'
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/relatorios/cargaprepago');

        //---

        msNavigationServiceProvider.saveItem('relatorios.cargaprepago', {
            title    : 'Cargas pré-pago',
            icon     : 'icon-chart-bar',
            state    : ['relatorios.cargaprepago'],
            translate: 'RELATORIOS.CARGAPREPAGO.NAV'
        });

    }
})();
(function () {
    'use strict';

    angular
        .module('app.pages.relatorios.cargaprepago')
        .factory('RelatorioCargaPrePagoResource', RelatorioCargaPrePagoResource);

    RelatorioCargaPrePagoResource.$inject = ['$http', 'BACKEND_URL'];
    
    function RelatorioCargaPrePagoResource( Http, backendUrl) {

        var vm = {
            filtrarDados: filtrarDadosFn,

            exportarAnaliticoPdf: exportarAnaliticoPdf,
            exportarAnaliticoExcel: exportarAnaliticoExcel,

            exportarSinteticoPdf: exportarSinteticoPdf,
            exportarSinteticoExcel: exportarSinteticoExcel
        };

        return vm;

        function filtrarDadosFn( data ) {
            return Http.post(backendUrl + '/relatorio/cargaprepago/sintetico', data);
        }

        function exportarAnaliticoPdf( data ) {
            return Http.post(backendUrl + '/relatorio/cargaprepago/analitico/pdf', data);
        }

        function exportarAnaliticoExcel( data ) {
            return Http.post(backendUrl + '/relatorio/cargaprepago/analitico/excel', data);
        }

        function exportarSinteticoPdf( data ) {
            return Http.post(backendUrl + '/relatorio/cargaprepago/sintetico/pdf', data);
        }

        function exportarSinteticoExcel( data ) {
            return Http.post(backendUrl + '/relatorio/cargaprepago/sintetico/excel', data);
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.pages.relatorios.cargaprepago')
        .controller('RelatoriosCargaPrePagoController', RelatoriosCargaPrePagoController);

    RelatoriosCargaPrePagoController.$inject = ['RelatorioCargaPrePagoResource', '$filter', '$mdToast', 'downloadService', 'Util'];

    /** @ngInject */
    function RelatoriosCargaPrePagoController( Resource, $filter, $mdToast, downloadService, Util ) {
        var vm = this;

        vm.barChart;

        vm.periodoItens = [ 'Hoje', '15 Dias', '30 Dias', 'Selecionar Data' ];

        /**
         * Locatário selecionado.
         */
        vm.locatario;

        /**
         * Evento selecionado.
         */
        vm.evento;

        /**
         * POS selecionado.
         */
        vm.pos;

        /**
         * Período do relatório.
         */
        vm.periodo = 2;

        /**
         * Data de inicio do período.
         */
        vm.dataInicio = new Date();

        /**
         * Data de fim do período.
         */
        vm.dataFim = new Date();
        
        /**
         * ID ou SN mifare
         */
        vm.mifare = '';
        
        /**
         * Código da carga
         */
        vm.carga = '';
        
        /**
         * Intervalo de horas dos filtros
         */
        vm.horaInicio = 0;
        vm.minutoInicio = 0;
        vm.horaFim = 23;
        vm.minutoFim = 59;
        
        vm.minutosInicio = [
            0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55
        ];
        vm.minutosFim = vm.minutosInicio.concat([59]);
        
        //---

        vm.onSelectEvento = onSelectEvento;
        vm.onSelectLocatario = onSelectLocatario;

        vm.carregarDadosMovimentacao = carregarDadosMovimentacao;

        vm.formatarValor = formatarValor;

        vm.changeOrder = function( order ) {
            vm.order = order;
            vm.reverse = !vm.reverse;
        };

        vm.order = '';
        vm.reverse = false;

        //---

        vm.exportarAnaliticoPdf = exportarAnaliticoPdf;
        vm.exportarAnaliticoExcel = exportarAnaliticoExcel;

        vm.exportarSinteticoPdf = exportarSinteticoPdf;
        vm.exportarSinteticoExcel = exportarSinteticoExcel;
        
        vm.exporting = false;

        //---

        function exportarAnaliticoExcel() {
            vm.exporting = true;
            showLoadingToast();
            Resource.exportarAnaliticoExcel( getData() ).then(function( data ) {
                downloadService.download(data.data.fileName, data.data.conteudo);
                $mdToast.hide();
                vm.exporting = false;
            }, function(error) {
                vm.exporting = false;
                $mdToast.hide();
                Util.showToastMessage('Erro ao gerar relatório');
            });
        }

        function exportarAnaliticoPdf() {
            vm.exporting = true;
            showLoadingToast();
            Resource.exportarAnaliticoPdf( getData() ).then(function( data ) {
                downloadService.download(data.data.fileName, data.data.conteudo);
                $mdToast.hide();
                vm.exporting = false;
            }, function(error) {
                vm.exporting = false;
                $mdToast.hide();
                Util.showToastMessage('Erro ao gerar relatório');
            });
        }

        //---

        function exportarSinteticoPdf() {
            vm.exporting = true;
            showLoadingToast();
            Resource.exportarSinteticoPdf( getData() ).then(function( data ) {
                downloadService.download(data.data.fileName, data.data.conteudo);
                $mdToast.hide();
                vm.exporting = false;
            }, function(error) {
                vm.exporting = false;
                $mdToast.hide();
                Util.showToastMessage('Erro ao gerar relatório');
            });
        }

        function exportarSinteticoExcel() {
            vm.exporting = true;
            showLoadingToast();
            Resource.exportarSinteticoExcel( getData() ).then(function( data ) {
                downloadService.download(data.data.fileName, data.data.conteudo);
                $mdToast.hide();
                vm.exporting = false;
            }, function(error) {
                vm.exporting = false;
                $mdToast.hide();
                Util.showToastMessage('Erro ao gerar relatório');
            });
        }

        //---

        /**
         * Executado ao selecionar o locatario.
         */
        function onSelectLocatario() {
            delete vm.data;
        }

        /**
         * Executado ao selecionar o evento.
         */
        function onSelectEvento() {
            carregarDadosMovimentacao();
        }

        function carregarDadosMovimentacao() {
            if (!vm.evento || !vm.evento.id) {
                return;
            }
            
            Chart.defaults.global.legend.display = false;
            Chart.defaults.global.maintainAspectRatio = false;
            
            Resource.filtrarDados( getData() ).then(function( content ) {
                vm.data = content.data;

                inicializarGraficoColunas();
            });
        }

        function showLoadingToast() {
            $mdToast.show({
                template: '<md-toast><span flex>Gerando relatório</span> <md-progress-circular class="md-accent" md-mode="indeterminate"></md-progress-circular></md-toast>',
                hideDelay: 0,
                position: 'bottom right'
            });
        }

        function getData() {
            var today = new Date();

            var dataInicio;
            var dataFim = Util.formatDate(today) + ' 23:59:59';

            if( vm.periodo == 0 ) {
        
                dataInicio = Util.formatDate(today) + ' 00:00:00';
            
            } else if( vm.periodo == 1 ) {
                
                dataInicio = getDate( 15 );

            } else if( vm.periodo == 2 ) {

                dataInicio = getDate( 30 );
                
            } else if( vm.periodo == 3 ) {
                
                if( !vm.dataInicio ) {
                    return;
                } else {
                    dataInicio = Util.formatDate(vm.dataInicio) + ' ' + getTime(vm.horaInicio, vm.minutoInicio);
                }

                dataFim = Util.formatDate(vm.dataFim) + ' ' + getTime(vm.horaFim, vm.minutoFim);
            }

            var perfilamento = JSON.parse( localStorage.getItem('perfilamento') );

            return {
                idEvento: vm.evento.id,
                idLocatario: vm.locatario.id,
                usuario: perfilamento.dsNomeUsuario,
                dataInicio: dataInicio,
                dataFim: dataFim,
                pos: vm.pos,
                mifare: vm.mifare,
                carga: vm.carga
            };
            
            function getDate( less ) {
                var today = new Date()
                var priorDate = new Date().setDate(today.getDate() - less );

                return Util.formatDate(new Date(priorDate)) + ' 00:00:00';
            }
            
            function getTime(hour, minute) {
                var time = '';
                if (hour < 10) {
                    time = '0' + hour;
                } else {
                    time += hour;
                }
                time += ":";
                if (minute < 10) {
                    time += '0' + minute;
                } else {
                    time += minute;
                }
                if (minute == 59) {
                    time += ":59";
                } else {
                    time += ":00";
                }
                
                return time;
            }

        }

        /**
         * Inicializa o gráfico de colunas.
         */
        function inicializarGraficoColunas() {
            if( vm.barChart ) {
                vm.barChart.destroy();
            }

            var ctx = document.getElementById("barChart");

            var options = {
                legend: {
                    display: false
                },
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero:true,
                            callback: function( value ) {
                                return value == 0 ? '0,00' : formatarValor( value );
                            }
                        }
                    }]
                },
                tooltips: {
                    callbacks: {
                        label: function ( tooltipItem, data ) {
                            var value = data.datasets[0].data[tooltipItem.index];
                            
                            return (value == 0 ? '0,00' : formatarValor( value ));
                        }
                    }
                }
            };

            var content = {
                labels: [],
                datasets: [{
                    data: [],
                    backgroundColor: [],
                    borderColor: [],
                    borderWidth: 1
                }]
            };

            for(var i = 0; i < vm.data.length; i++) {
                content.labels.push( vm.data[i].dsMovimento );
                content.datasets[0].data.push( vm.data[i].vlMovimento );
                
                //Fechamento e saldo negativo - Vermelho
                if ((vm.data[i].dsMovimento.startsWith('FEC')) ||
                    (vm.data[i].dsMovimento === 'SALDO' && vm.data[i].vlMovimento < 0)) 
                {
                    content.datasets[0].backgroundColor.push('rgba(244, 67, 54, 0.2)');
                    content.datasets[0].borderColor.push('rgba(244, 67, 54, 1)');
                    
                //Cobrança de taxas - Amarelo
                } else if (vm.data[i].dsMovimento.startsWith('COB')) {
                    content.datasets[0].backgroundColor.push('rgba(255, 206, 86, 0.2)');
                    content.datasets[0].borderColor.push('rgba(255, 206, 86, 1)');       
                    
                //Demais azuis
                } else {
                    content.datasets[0].backgroundColor.push('rgba(54, 162, 235, 0.2)');
                    content.datasets[0].borderColor.push('rgba(54, 162, 235, 1)');
                }
            }

            vm.barChart = new Chart(ctx, {
                type: 'bar',
                data: content,
                options: options
            });
        }

        function converterData(data) {
            return data.split('-').reverse().join('/');
        }

        function formatarValor( valor, quantidade ) {
            var negativeSymbol = '';
            valor = valor.toFixed(2);
            
            if (valor.substring(0, 1) == '-') {
                valor = valor.substring(1);
                negativeSymbol = '-';
            }
            
            valor = valor.split('.');

            var output = '';
            var count = 0;

            for(var i = valor[0].length - 1; i >= 0 ; i--) {
                count++;

                output += valor[0][i];

                if( count == 3 ) {
                    count = 0;
                    
                    if( (i - 1) >= 0 ) {
                        output += '.';
                    }
                }
            }

            var retorno = output.split('').reverse().join(''); 

            if( !quantidade ) { 
                retorno += ',' + valor[1];
            }   

            return negativeSymbol + retorno;
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.pages.eventos.usuarios', []);
        // .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {

        $stateProvider
            .state('eventos.usuarios', {
                url    : '/usuarios',
                templateUrl: 'app/main/pages/eventos/usuarios/index.html',
                controller : 'EventosUsuariosController as vm'
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/eventos/usuarios');

        //---

        msNavigationServiceProvider.saveItem('eventos.usuarios', {
            title    : 'Usuários',
            icon     : 'icon-tile-four',
            state    : ['eventos.usuarios'],
            translate: 'EVENTOS.USUARIOS.NAV'
        });
    }
})();
(function () {
    'use strict';

    angular
        .module('app.pages.eventos.usuarios')
        .controller('EventosUsuariosController', EventosUsuariosController);

    /** @ngInject */
    function EventosUsuariosController() {
        var vm = this;

        vm.whoami = 'Eventos - Usuários';
    }
})();

(function () {
    'use strict';

    angular
        .module('app.pages.eventos.produtos')
        .factory('EventosProdutosResource', EventosProdutosResource);

    EventosProdutosResource.$inject = ['$http', 'BACKEND_URL'];
    
    function EventosProdutosResource( Http, backendUrl) {

        var vm = {
            saveOrUpdate: saveOrUpdateFn,
            findAllByEventId: findAllByEventIdFn,
            delete: deleteFn,
            searchByEvent: searchByEventFn
        };

        return vm;

        function saveOrUpdateFn( data ) {
            return data.id ? update( data ) : save( data );
        }

        function save( data ) {
            return Http.post(backendUrl + '/regprodutoevento', data);
        }

        function update( data ) {
            return Http.put(backendUrl + '/regprodutoevento', data);
        }

        function findAllByEventIdFn( eventId ) {
            return Http.get(backendUrl + '/regprodutoevento/find/evento/' + eventId);
        }

        function searchByEventFn( eventID, search ) {
            return Http.get(backendUrl + '/regprodutoevento/find/evento/' + eventID + "/paginate", {
                params: {
                    search: search
                }
            });
        }
        
        function deleteFn(productID) {
            return Http.delete(backendUrl + '/regprodutoevento/' + productID);
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.pages.eventos.produtos')
        .controller('EventosProdutosController', EventosProdutosController);

    EventosProdutosController.$inject = [
        'EventosProdutosResource',
        '$state',
        '$mdDialog',
        'Util'
    ];
    
    function EventosProdutosController( Resource, $state, $mdDialog, Util ) {
        var vm = this;

        vm.search = '';

        vm.locatario = undefined;
        vm.evento = undefined;

        vm.limit = 25;
        vm.page = 1;
        vm.data = {
            totalRegistros: 0,
            data: []
        };
        vm.pageLabels = {
            of : 'de',
            page: 'Página:',
            rowsPerPage: 'Registros por página:'
        };

        //---

        vm.onNewClick = onNewClickFn;
        vm.onSelectEvento = onSelectEventoFn;
        vm.onSelectLocatario = onSelectLocatarioFn;
        vm.onRowClick = onRowClickFn;
        vm.delete = deleteFn;

        vm.filter = filter;
        vm.pageChanged = pageChangedFn;

        //---

        function onRowClickFn( produto ) {
            $state.go('eventos.produtosCadastro', {
                locatario: vm.locatario,
                evento: vm.evento,
                produto: produto
            });
        }

        function onNewClickFn() {
            $state.go('eventos.produtosCadastro');
        }

        function filter( ) {
            if( !vm.search && vm.search !== 0 ) {
                search();
            }

            var campo;
            if (new RegExp(/^\d+$/).test(vm.search)) {
                campo = "idCodigoVenda";
            } else if (vm.search.length >= 3) {
                campo = "regProduto.dsDescricao";
            } else {
                return;
            }

            search(campo);
        }

        function search(campo) {
            var filter = "pageSize:" + vm.limit
                + ",pag:" + vm.page
                + ",orderField:regProduto.dsDescricao"
                + ",orderType:ASC";
            
            if (campo) {
                filter += "," + campo + ":" + vm.search;
            }

            Resource.searchByEvent(vm.evento.id, filter).then(function(data) {
                vm.data = data.data;
            }, function(error) {
                vm.data = {
                    totalRegistros: 0,
                    data: []
                };
            });
        }

        function onSelectLocatarioFn() {
            vm.data = {
                totalRegistros: 0,
                data: []
            }
        }

        function onSelectEventoFn() {
            filter();
        }

        //---
        
        function deleteFn(produto, $event) {
            $event.preventDefault();
            $event.stopPropagation();
            
            var confirm = $mdDialog.confirm()
                .title('Aviso')
                .textContent('Deseja excluir o produto ' + produto.regProduto.dsDescricao + '?')
                .ok('Sim')
                .cancel('Não');

            $mdDialog.show(confirm).then(function() {
                Resource.delete( produto.id ).then(function(data) {
                    Util.showToastMessage('Produto excluído com sucesso.');
                    filter();
                }, function() {
                    Util.showToastMessage('Não foi possível excluir o produto.');
                });
            });
        }

        function pageChangedFn (page, limit) {
            vm.page = page;
            vm.limit = limit;
            vm.filter();
        }

    }
})();

(function () {
  "use strict";

  angular
    .module("app.pages.eventos.lancamentoestoque")
    .factory(
      "EventosLancamentoEstoqueResource",
      EventosLancamentoEstoqueResource
    );

  EventosLancamentoEstoqueResource.$inject = ["$http", "BACKEND_URL"];

  function EventosLancamentoEstoqueResource(Http, backendUrl) {
    var vm = {
      lista: lista,
      salvar: salvar,
    };

    return vm;

    function lista(eventId, tipoOperacao, search) {
      return Http.get(backendUrl + "/regprodutoestoqueanalitico/lista", {
        params: {
          eventId: eventId,
          tipoOperacao: tipoOperacao,
          search: search,
        },
      });
    }

    function salvar(lista) {
      return Http.post(backendUrl + "/regprodutoestoqueanalitico/salvar", lista);
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('app.pages.eventos.lancamentoestoque')
        .controller('EventosLancamentoEstoqueController', EventosLancamentoEstoqueController);

        EventosLancamentoEstoqueController.$inject = [
        'EventosLancamentoEstoqueResource',
        '$state',
        '$mdDialog',
        'Util'
    ];

    function EventosLancamentoEstoqueController(Resource, $state, $mdDialog, Util) {
        var vm = this;
        vm.tipoOperacao = {id: null, nome: 'Todos'};
        vm.periodo = 2;
        vm.periodoItens = [ 'Hoje', '15 Dias', '30 Dias', 'Selecionar Data' ];

        /**
         * Data de inicio do período.
         */
        vm.dataInicio = new Date();

        /**
         * Data de fim do período.
         */
        vm.dataFim = new Date();
        
        /**
         * Intervalo de horas dos filtros
         */
        vm.horaInicio = 0;
        vm.minutoInicio = 0;
        vm.horaFim = 23;
        vm.minutoFim = 59;
        
        vm.minutosInicio = [
            0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55
        ];
        vm.minutosFim = vm.minutosInicio.concat([59]);

        vm.locatario = undefined;
        vm.evento = {};

        vm.limit = 25;
        vm.page = 1;
        vm.data = {
            totalRegistros: 0,
            data: []
        };
        vm.pageLabels = {
            of: 'de',
            page: 'Página',
            rowsPerPage: 'Registros por página'
        };
        vm.listaTipoOperacao = [
            {id: null, nome: 'Todos'},
            {id: 0, nome: 'Entrada de estoque'},
            {id: 1, nome: 'Saída avulsa de estoque'},
            {id: 2, nome: 'Vendas'},
            {id: 3, nome: 'Devolução de venda'},
        ];

        //---

        vm.onNewClick = onNewClickFn;
        vm.onSelectEvento = onSelectEventoFn;
        vm.onSelectLocatario = onSelectLocatarioFn;
        vm.onRowClick = onRowClickFn;
        vm.onSelectTipoOperacao = onSelectTipoOperacaoFn;
        // vm.delete = deleteFn;

        vm.lista = lista;
        vm.pageChanged = pageChangedFn;

        //---

        function onRowClickFn( produto ) {
            $state.go('eventos.lancamentoestoqueCadastro', {
                locatario: vm.locatario,
                evento: vm.evento,
                produto: produto
            });
        }

        function onNewClickFn() {
            $state.go('eventos.lancamentoestoqueCadastro');
        }

        function lista() {
            
            var filter = "pageSize:" + vm.limit
            + ",pag:" + vm.page
            + ",orderField:dhInsert"
            + ",orderType:DESC";
            
            var periodo = getData();
            filter += "," + "dhInsert" + ">=" + periodo.dataInicio;
            filter += "," + "dhInsert" + "<=" + periodo.dataFim;
            
            Resource.lista(vm.evento.id, vm.tipoOperacao.id, filter).then(function(data) {
                vm.data = data.data;
            }, function(error) {
                vm.data = {
                    totalRegistros: 0,
                    data: []
                };
            });
        }

        function onSelectLocatarioFn() {
            vm.data = {
                totalRegistros: 0,
                data: []
            }
        }

        function onSelectTipoOperacaoFn() {
            lista();
        }

        function onSelectEventoFn() {
            lista();
        }

        function pageChangedFn (page, limit) {
            vm.page = page;
            vm.limit = limit;
            vm.lista();
        }

        function getData() {
            var today = new Date();

            var dataInicio;
            var dataFim = Util.formatDate(today) + ' 23:59:59';

            if( vm.periodo == 0 ) {
        
                dataInicio = Util.formatDate(today) + ' 00:00:00';
            
            } else if( vm.periodo == 1 ) {
                
                dataInicio = getDate( 15 );

            } else if( vm.periodo == 2 ) {

                dataInicio = getDate( 30 );
                
            } else if( vm.periodo == 3 ) {
                
                if( !vm.dataInicio ) {
                    return;
                } else {
                    dataInicio = Util.formatDate(vm.dataInicio) + ' ' + getTime(vm.horaInicio, vm.minutoInicio);
                }

                dataFim = Util.formatDate(vm.dataFim) + ' ' + getTime(vm.horaFim, vm.minutoFim);
            }

            return {
                dataInicio: dataInicio,
                dataFim: dataFim,
            };
            
            function getDate( less ) {
                var today = new Date()
                var priorDate = new Date().setDate(today.getDate() - less );

                return Util.formatDate(new Date(priorDate)) + ' 00:00:00';
            }
            
            function getTime(hour, minute) {
                var time = '';
                if (hour < 10) {
                    time = '0' + hour;
                } else {
                    time += hour;
                }
                time += ":";
                if (minute < 10) {
                    time += '0' + minute;
                } else {
                    time += minute;
                }
                if (minute == 59) {
                    time += ":59";
                } else {
                    time += ":00";
                }
                
                return time;
            }

        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.pages.eventos.importacaoprodutos', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {

        $stateProvider
            .state('eventos.importacaoprodutos', {
                url    : '/importacaoprodutos',
                templateUrl: 'app/main/pages/eventos/importacaoprodutos/index.html',
                controller : 'EventosImportacaoprodutosController as importacao'
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/eventos/importacaoprodutos');

        //---

        msNavigationServiceProvider.saveItem('eventos.importacaoprodutos', {
            title    : 'Importação de Produtos',
            icon     : 'icon-backup-restore',
            state    : ['eventos.importacaoprodutos'],
            translate: 'EVENTOS.IMPORTACAOPRODUTOS.NAV'
        });

    }
})();
(function () {
    'use strict';

    angular
        .module('app.pages.eventos.importacaoprodutos')
        .factory('EventosImportacaoprodutosResource', EventosImportacaoprodutosResource);

    EventosImportacaoprodutosResource.$inject = ['$http', 'BACKEND_URL'];
    
    function EventosImportacaoprodutosResource( Http, backendUrl) {

        var vm = {
            findAllByEventIdToImport: findAllByEventToImportFn,
            importProducts: importProductsFn
        };

        return vm;

        function findAllByEventToImportFn( locatario, eventId ) {
            var url = backendUrl + '/regprodutoevento/filter/import/' + locatario.regPessoa.id + '/' + eventId;
            return Http.get(url);
        }

        function importProductsFn( eventId, produtos ) {
            var url = backendUrl + '/regprodutoevento/importlist/' + eventId;
            return Http.post(url, produtos);
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.pages.eventos.importacaoprodutos')
        .controller('EventosImportacaoprodutosController', EventosImportacaoprodutosController);

    EventosImportacaoprodutosController.$inject = [
        'EventosImportacaoprodutosResource',
        'Util'
    ];

    function EventosImportacaoprodutosController( Resource, Util ) {
        var vm = this;

        var produtosSelecionados = [];

        vm.allChecked = false;

        vm.locatario = undefined;
        vm.evento = undefined;

        vm.produtos = [];

        //---

        vm.onSelectEvento = onSelectEventoFn;
        vm.onSelectLocatario = onSelectLocatarioFn;

        vm.allCheckedClick = allCheckedClickFn;
        vm.onImportarClick = onImportarClickFn;

        vm.onItemChange = onItemChangeFn;
        vm.filter = filter;

        //---

        function filter( item ) {
            if( !vm.search && vm.search !== 0 ) return true;

            if( contains(vm.search, item.idCodigoVenda.toString()) ||
                contains(vm.search, item.regProduto.dsDescricao) ||
                contains(vm.search, item.vlPreco.toString()) ||
                contains(vm.search, (item.fgImprimeCodigoBarras ? 'Sim' : 'Não')) ||
                contains(vm.search, (item.fgImprimeTicket ? 'Sim' : 'Não')) ||
                contains(vm.search, (item.fgSolicitaPreco ? 'Sim' : 'Não')) ||
                contains(vm.search, item.nrViasTicket.toString()) ) {
                return true;
            }

            return false;
        }

        function contains(search, content) {
            return ~content.toUpperCase().indexOf(search.toUpperCase());
        }

        function onItemChangeFn( produto ) {
            if( produto.checked ) {
                produtosSelecionados.push(produto);

                if( produtosSelecionados.length == vm.produtos.length ) {
                    vm.allChecked = true;
                }
            } else {
                var index = produtosSelecionados.indexOf( produto );
                produtosSelecionados.splice(index, 1);

                vm.allChecked = false;
            }
        }

        function onImportarClickFn() {
            if( !produtosSelecionados.length ) {
                return Util.showToastMessage('Selecione os produtos para importar');
            }

            var listProdutos = [];

            angular.forEach(produtosSelecionados, function(item) {
                delete item.checked;
                listProdutos.push(item);
            });

            Resource.importProducts( vm.evento.id, listProdutos ).then(function( data ) {
                Util.showToastMessage('Produtos importados com sucesso');

                carregarProdutos();

            }, function() {
                Util.showToastMessage('Erro ao importar produtos');
            });
        }

        function allCheckedClickFn() {
            angular.forEach(vm.produtos, function(item) {
                item.checked = !!vm.allChecked;
            });

            if( vm.allChecked ) {
                produtosSelecionados.push.apply(produtosSelecionados, vm.produtos);
            } else {
                produtosSelecionados = [];
            }
        }

        function onSelectEventoFn() {
            vm.produtos = [];

            carregarProdutos();
        }

        function onSelectLocatarioFn() { 
            vm.produtos = [];
        }

        function carregarProdutos() {
            Resource.findAllByEventIdToImport( vm.locatario, vm.evento.id ).then(function( data ) {
                vm.produtos = data.data;
                produtosSelecionados = [];
            });
        }

    }
})();

(function() {
  "use strict";

  angular
    .module("app.pages.eventos.grupoprodutos")
    .factory("EventosGrupoProdutosResource", EventosGrupoProdutosResource);

  EventosGrupoProdutosResource.$inject = ["$http", "BACKEND_URL"];

  function EventosGrupoProdutosResource(Http, backendUrl) {
    var vm = {
      saveOrUpdate: saveOrUpdateFn,
      findAllByIdIgreja: findAllByIdIgrejaFn
    };

    return vm;

    function saveOrUpdateFn(data) {
      return data.id ? update(data) : save(data);
    }

    function save(data) {
      return Http.post(backendUrl + "/reggrupoproduto", data);
    }

    function update(data) {
      return Http.put(backendUrl + "/reggrupoproduto", data);
    }

    function findAllByIdIgrejaFn(igrejaId) {
      return Http.get(
        backendUrl + "/reggrupoproduto/list/locatario/" + igrejaId
      );
    }
  }
})();

(function() {
  "use strict";

  angular
    .module("app.pages.eventos.grupoprodutos")
    .controller(
      "EventosGrupoProdutosController",
      EventosGrupoProdutosController
    );

  EventosGrupoProdutosController.$inject = [
    "EventosGrupoProdutosResource",
    "ServoTicketLocatariosResource",
    "Util",
    "$state"
  ];

  function EventosGrupoProdutosController(
    GrupoProdutosResource,
    LocatariosResource,
    Util,
    state
  ) {
    var vm = this;

    vm.locatarios = [];
    vm.grupos = [];
    vm.locatario = undefined;

    vm.onSelectLocatario = onSelectLocatarioFn;
    vm.novo = novoFn;
    vm.editar = editarFn;

    LocatariosResource.findAll().then(function(result) {
      vm.locatarios = result.data;
      var locatario = localStorage.getItem("locatario");

      if (locatario) {
        vm.locatario = JSON.parse(locatario);
        vm.onSelectLocatario();
      }
    });

    function onSelectLocatarioFn() {
      if (vm.locatario && vm.locatario.id) {
        GrupoProdutosResource.findAllByIdIgreja(vm.locatario.regPessoa.id).then(
          function(result) {
            vm.grupos = result.data;
          },
          function(error) {
            vm.grupos = [];
            Util.showToastMessage(
              "Falha ao carregar grupos de produtos do locatário selecionado."
            );
          }
        );
      }
    }

    function novoFn() {
      if (vm.locatario && vm.locatario.id) {
        localStorage.setItem("locatario", JSON.stringify(vm.locatario));
        state.go("eventos.grupoProdutosCadastro", { locatario: vm.locatario });
      }
    }

    function editarFn(grupo) {
      if (grupo && grupo.id) {
        localStorage.setItem("locatario", JSON.stringify(vm.locatario));
        state.go("eventos.grupoProdutosCadastro", {
          grupo: grupo,
          locatario: vm.locatario
        });
      }
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('app.pages.eventos.configuracao', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {

        $stateProvider
            .state('eventos.configuracao', {
                url    : '/configuracao',
                templateUrl: 'app/main/pages/eventos/configuracao/index.html',
                controller : 'EventosConfiguracaoController as configuracao'
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/eventos/configuracao');

        //---

        msNavigationServiceProvider.saveItem('eventos.configuracao', {
            title    : 'Configuração',
            icon     : 'icon-document',
            state    : ['eventos.configuracao'],
            translate: 'EVENTOS.CONFIGURACAO.NAV'
        });
    }
})();
(function () {
    'use strict';

    angular
        .module('app.pages.eventos.configuracao')
        .factory('EventosConfiguracaoResource', EventosConfiguracaoResource);

    EventosConfiguracaoResource.$inject = ['$http', 'BACKEND_URL'];
    
    function EventosConfiguracaoResource( Http, backendUrl) {

        var vm = {
            findByEventId: findByEventIdFn,
            atualizarCfgEvento: atualizarCfgEventoFn
        };

        return vm;

        function atualizarCfgEventoFn( configuracao ) {
            return Http.put(backendUrl + '/cfgevento', configuracao);
        }

        function findByEventIdFn( eventId ) {
            return Http.get(backendUrl + '/cfgevento/find/evento/' + eventId);
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.pages.eventos.configuracao')
        .controller('EventosConfiguracaoController', EventosConfiguracaoController);

    EventosConfiguracaoController.$inject = [
        'EventosConfiguracaoResource',
        'Util',
        '$scope'
    ];

    function EventosConfiguracaoController( Resource, Util, scope) {
        var vm = this;

        vm.configuracao = {
            regEvento: {
                regEventoLogo: {

                }
            }
        };

        vm.locatario = undefined;
        vm.evento = undefined;
        vm.logo = undefined;

        vm.onEventoChange = onEventoChangeFn;
        vm.onLocatarioChange = onLocatarioChangeFn;

        vm.salvar = salvarFn;

        scope.fileChanged = fileChangedFn;

        //---

        function salvarFn() {
            if( vm.configuracao.fgImprimeNomeEvento ) {
                if( !isValid('dsNomeEventoPOS', 'Nome do Evento POS')) return;
            }
            
            if( vm.configuracao.fgImprimeMensagem ) {
                if( !isValid('dsMensagemCupom', 'Mensagem de Rodapé', ' não pode ser vazia.')) return;
            }

            if(!vm.configuracao.vlTaxaCargaCartao ) {
                vm.configuracao.vlTaxaCargaCartao = '0.0';
            }

            if( !isNumberValid(vm.configuracao.vlTaxaCargaCartao) ) return; 

            if( vm.configuracao.tpCargaCartao != 0 && !vm.locatario.regPessoa.fgUtilizaPrePosPago ) {
                return Util.showToastMessage('Recurso de carga em cartão desabilitado.');
            }

            salvarConfiguracao();
        }

        function salvarConfiguracao() {            
            Resource.atualizarCfgEvento( vm.configuracao )
                .then(function() {
                    
                    Util.showToastMessage('Configuração salva com sucesso');
                    
                }, function(error) {
                    if (error.status === 400) {
                        Util.showToastMessage(error.data);
                    } else {
                        Util.showToastMessage('Erro ao salvar Configuração');
                    }
                });
        }

        function isValid(attr, name, emptyMessage) {
            var message = '';
            emptyMessage = emptyMessage || " não pode ser vazio.";
            
            if( !vm.configuracao[attr] ) {

                Util.showToastMessage(message = (name + emptyMessage));

            } else if( vm.configuracao[attr].length > 50 ) {

                Util.showToastMessage(message = (name + ' não pode conter mais que 50 caracteres.'));

            }
            
            if( message ) return false;
            
            return true;
        }

        function isNumberValid(value) {
            if (isNaN(value)) {
                Util.showToastMessage("Preço inválido.");    
                return false;    
            }

            return true;
        }
        
        function onEventoChangeFn() {
            carregarConfiguracao();
        }

        function onLocatarioChangeFn() {
            vm.configuracao = {};
        }

        function carregarConfiguracao() {
            Resource.findByEventId( vm.evento.id )
                .then(onSuccess, onError);

            function onSuccess( data ) {
                vm.configuracao = data.data;    

                if( !vm.configuracao.vlTaxaCargaCartao ) {
                    vm.configuracao.vlTaxaCargaCartao = '0.0';
                }

                if (vm.configuracao.regEvento.regEventoLogo.bnLogoEvento) {
                    convertLogo();
                } else {
                    vm.logo = undefined;
                }
            }

            function onError() {
                
            }
        }
        function fileChangedFn(el) {
            if (!el.files || !el.files.length) {
                return;
            }
            
            var file = el.files[0];
            if (file.size > (1024 * 200)) {
                return Util.showToastMessage('Imagem deve ser menor que 200kb');
            }

            var reader = new FileReader();
            reader.onload = function () {
                vm.configuracao.regEvento.regEventoLogo.bnLogoEvento = arrayBufferToBase64(reader.result);
                vm.configuracao.regEvento.regEventoLogo.alterado = true;

                convertLogo();

                scope.$apply();
            }
            
            reader.readAsArrayBuffer(file);
        }

        function convertLogo() {
            var blob = new Blob([base64ToArrayBuffer(vm.configuracao.regEvento.regEventoLogo.bnLogoEvento)], {type: 'image/bmp'});
            vm.logo = URL.createObjectURL(blob);
        }

        function arrayBufferToBase64( buffer ) {
            var binary = '';
            var bytes = new Uint8Array( buffer );
            var len = bytes.byteLength;
            for (var i = 0; i < len; i++) {
                binary += String.fromCharCode( bytes[ i ] );
            }
            return window.btoa( binary );
        }

        function base64ToArrayBuffer(base64) {
            var binaryString =  window.atob(base64);
            var binaryLen = binaryString.length;
            var bytes = new Uint8Array(binaryLen);
            for (var i = 0; i < binaryLen; i++)        {
                var ascii = binaryString.charCodeAt(i);
                bytes[i] = ascii;
            }
            return bytes;
        }

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.quick-panel', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider, msApiProvider)
    {
        // Translation
        $translatePartialLoaderProvider.addPart('app/quick-panel');

        // Api
        msApiProvider.register('quickPanel.activities', ['app/data/quick-panel/activities.json']);
        msApiProvider.register('quickPanel.contacts', ['app/data/quick-panel/contacts.json']);
        msApiProvider.register('quickPanel.events', ['app/data/quick-panel/events.json']);
        msApiProvider.register('quickPanel.notes', ['app/data/quick-panel/notes.json']);
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('ChatTabController', ChatTabController);

    /** @ngInject */
    function ChatTabController(msApi, $timeout)
    {
        var vm = this;

        // Data
        vm.chat = {};
        vm.chatActive = false;
        vm.replyMessage = '';

        msApi.request('quickPanel.contacts@get', {},
            // Success
            function (response)
            {
                vm.contacts = response.data;
            }
        );

        // Methods
        vm.toggleChat = toggleChat;
        vm.reply = reply;

        //////////

        function toggleChat(contact)
        {
            vm.chatActive = !vm.chatActive;

            if ( vm.chatActive )
            {
                vm.replyMessage = '';
                vm.chat.contact = contact;
                scrollToBottomOfChat(0);
            }
        }

        function reply()
        {
            if ( vm.replyMessage === '' )
            {
                return;
            }

            if ( !vm.chat.contact.dialog )
            {
                vm.chat.contact.dialog = [];
            }

            vm.chat.contact.dialog.push({
                who    : 'user',
                message: vm.replyMessage,
                time   : 'Just now'
            });

            vm.replyMessage = '';

            scrollToBottomOfChat(400);
        }

        function scrollToBottomOfChat(speed)
        {
            var chatDialog = angular.element('#chat-dialog');

            $timeout(function ()
            {
                chatDialog.animate({
                    scrollTop: chatDialog[0].scrollHeight
                }, speed);
            }, 0);

        }
    }

})();
(function () {
    'use strict';

    angular
        .module('app.pages.changepassword', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {

        $stateProvider
            .state('mudarsenha', {
                url    : '/mudarsenha',
                parent: 'app',
                views: {
                    'content@app': {
                        controller : 'ChangepasswordController as changepassword',
                        templateUrl: 'app/main/pages/changepassword/index.html'
                    }
                }
            });
    }
})();
(function () {
    'use strict';

    angular
        .module('app.pages.changepassword')
        .factory('ChangepasswordResource', ChangepasswordResource);

    ChangepasswordResource.$inject = ['$http', 'OAUTH_BASE_URL', 'api'];
    
    function ChangepasswordResource( Http, oauthUrl, api) {

        var vm = {
            updatePassword: updatePasswordFn
        };

        return vm;

        function updatePasswordFn( senhaAtual, novaSenha ) {
            var url = oauthUrl + '/usuario/alteracao/senha/logado';
            var token = api.getAccessToken();

            var data = {
                token: token,
                newPassword: novaSenha,
                oldPassword: senhaAtual
            };

            return Http.post(url, data);
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.pages.changepassword')
        .controller('ChangepasswordController', ChangepasswordController);

    ChangepasswordController.$inject = [
        'ChangepasswordResource',
        'Util',
        'HOME_PAGE_PATH',
        '$location'
    ];

    function ChangepasswordController( Resource, Util, homePage, $location ) {
        var vm = this;

        vm.senhaatual = '';
        vm.novasenha = '';
        vm.novasenha2 = '';

        vm.alterarSenha = alterarSenha;

        //---

        function alterarSenha() {
            if( !vm.senhaatual ) {
                return showMessage( 'Informe a senha atual', 'senhaatual' );
            }

            if( !vm.novasenha ) {
                return showMessage( 'Informe a nova senha', 'novasenha' );
            }

            if( !vm.novasenha2 ) {
                return showMessage( 'Repita a nova senha', 'novasenha2' );
            }

            if( vm.novasenha !== vm.novasenha2 ) {
                return showMessage( 'As senhas precisam ser iguais', 'novasenha' );
            }

            //---
            
            Resource
                .updatePassword(vm.senhaatual, vm.novasenha)
                .then( onSuccess, onError );

            function onSuccess() {
                showMessage('Senha alterada com sucesso');
                $location.path( homePage );
            }

            function onError(data) {
                showMessage(data.data.message);
            } 
        }

        //---

        function focus( elementId ) {
            document.querySelector( '#' + elementId ).focus();
        }

        function showMessage( message, elementId ) {
            Util.showToastMessage( message );

            if( elementId ) {
                 focus( elementId );
            }
        }
    }

})();

(function () {
    'use strict';

    angular.module('app.components.texto', []);

})();
(function () {
    'use strict';

    angular
        .module('app.components.texto')
        .directive('servoticketTexto', ServoticketTexto);

    ServoticketTexto.$inject = [
        'Util'
    ];
    
    function ServoticketTexto( Util ) {
        var directive = {
            restrict: 'A',
            link: linkFn
        };

        return directive;

        function linkFn( scope, element, attrs ) {
            var defaultMessage = 'Carácter inválido. Consulte ajuda!';

            element.on( 'input', onInputFn );

            function onInputFn() {
                var modelValue = element[0].value;

                if( modelValue ) {
                    var result = modelValue.match(/[a-zA-Z0-9\s@!#$%&*()?;:,/"+=.\-_]/g);

                    if( result == null || result.length < modelValue.length ) {
                        result = result || [];
                        Util.showToastMessage(attrs.servoticketText ? attrs.servoticketText : defaultMessage);
                    }

                    modelValue = result.join('');
                }

                element[0].value = modelValue;
            }
        
        }
    }

})();
(function () {
    'use strict';

    angular.module('app.components.header', []);

})();
(function ()
{
    'use strict';

    angular
        .module('app.components.header')
        .directive('servoticketHeader', servoticketHeader);

    /** @ngInject */
    function servoticketHeader() {
        var scope = {
            titulo: '@',
            subtitulo: '@',
            locatario: '=',
            evento: '=',
            onChangeLocatario: '&',
            onChangeEvento: '&'
        };

        var directive = {
            restrict: 'E',
            scope: scope,
            templateUrl: 'app/main/components/header/template.html',
            controller: servoticketHeaderController,
            controllerAs: 'header',
            bindToController: true
        };

        return directive;
    }

    servoticketHeaderController.$inject = [
        'ServoTicketEventosResource', 
        'ServoTicketLocatariosResource',
        '$timeout',
        'Util'
    ];

    function servoticketHeaderController( EventosResource, LocatariosResource, $timeout, Util ) {
        var vm = this, atualizarLocatario = true;

        vm.locatarios = [];
        vm.eventos = [];

        vm.onSelectEvento = onSelectEventoFn;
        vm.onSelectLocatario = onSelectLocatarioFn;

        vm.init = initFn;

        //---

        function initFn() {
            carregarLocatarios();
        }

        function onSelectEventoFn() {
            localStorage.setItem('evento', JSON.stringify(vm.evento));
            $timeout(vm.onChangeEvento);
        }

        function onSelectLocatarioFn( ) {
            localStorage.setItem('locatario', JSON.stringify(vm.locatario));
            $timeout(vm.onChangeLocatario);

            if ( atualizarLocatario ) {
                vm.evento = undefined;
                localStorage.removeItem('evento');

                carregarEventos( );
            } else {
                atualizarLocatario = true;
            }
        }

        // //---

        function carregarLocatarios() {
            LocatariosResource.findAll().then(function(data) {
                vm.locatarios = data.data;

                if( vm.locatarios.length === 1 ) {
                    vm.locatario = vm.locatarios[0];
                    localStorage.setItem('locatario', JSON.stringify(vm.locatario));
                    $timeout(vm.onChangeLocatario);
                    
                    atualizarLocatario = false;

                    carregarEventos();
                } else {
                    var locatario = localStorage.getItem('locatario');

                    if( locatario ) {
                        vm.locatario = JSON.parse(locatario);
                        
                        atualizarLocatario = false;

                        carregarEventos();
                    }
                }

            }, function() {
                Util.showToastMessage('Erro ao carregar locatários');
            }); 
        }

        function carregarEventos( ) {
            EventosResource.findAllByIdLocatario( vm.locatario.id ).then(function(data) {
                vm.eventos = data.data;
 
                if( vm.eventos.length === 1 ) {
                    vm.evento = vm.eventos[0];
                    localStorage.setItem('evento', JSON.stringify(vm.evento));
                    $timeout(vm.onChangeEvento);
                } else {
                    var evento = localStorage.getItem('evento');

                    if( evento ) {                
                        vm.evento = JSON.parse(evento);
                    } else {
                        vm.evento = undefined;
                    }
                }
            }, function() {
                Util.showToastMessage('Erro ao carregar eventos');
            });
        }
    }
})();
(function () {
    'use strict';

    angular.module('app.components.content', []);

})();
(function () {
    'use strict';

    angular
        .module('app.components.content')
        .directive('servoticketContent', servoticketContent);

    function servoticketContent() {
        var directive = {
            restrict: 'E',
            scope: false,
            templateUrl: 'app/main/components/content/template.html',
            transclude: true
        };

        return directive;
    }

})();
(function () {
    'use strict';

    angular.module('app.components.checkstrength', []);

})();
(function () {
    'use strict';

    angular.module('app.components.autofocus', []);

})();
(function () {
    'use strict';

    angular
        .module('app.components.autofocus')
        .directive('servoticketCheckstrength', ServoticketCheckstrength);

    ServoticketCheckstrength.$inject = [
        '$parse'
    ];

    function ServoticketCheckstrength( $parse ) {
        var directive = {
            restrict: 'A',
            link: linkFn,
            template: [
                '<li class="point"></li>',
                '<li class="point"></li>',
                '<li class="point"></li>',
                '<li class="point"></li>',
                '<li class="point"></li>'
            ].join('')
        };

        return directive;

        function linkFn( scope, element, attrs ) {
            var strength = {
                colors: ['#F00', '#F90', '#FF0', '#9F0', '#0F0'],
                mesureStrength: function (p) {
                    var _force = 0;                    
                    var _regex = /[$-/:-?{-~!"^_`\[\]]/g;
                                          
                    var _lowerLetters = /[a-z]+/.test(p);                    
                    var _upperLetters = /[A-Z]+/.test(p);
                    var _numbers = /[0-9]+/.test(p);
                    var _symbols = _regex.test(p);
                                          
                    var _flags = [_lowerLetters, _upperLetters, _numbers, _symbols];                    
                    var _passedMatches = $.grep(_flags, function (el) { return el === true; }).length;                                          
                    
                    _force += 2 * p.length + ((p.length >= 10) ? 1 : 0);
                    _force += _passedMatches * 10;
                        
                    // penality (short password)
                    _force = (p.length <= 6) ? Math.min(_force, 10) : _force;                                      
                    
                    // penality (poor variety of characters)
                    _force = (_passedMatches == 1) ? Math.min(_force, 10) : _force;
                    _force = (_passedMatches == 2) ? Math.min(_force, 20) : _force;
                    _force = (_passedMatches == 3) ? Math.min(_force, 40) : _force;
                    
                    return _force;

                },
                getColor: function (s) {
                    var idx = 0;
                    if (s <= 10) { idx = 0; }
                    else if (s <= 20) { idx = 1; }
                    else if (s <= 30) { idx = 2; }
                    else if (s <= 40) { idx = 3; }
                    else { idx = 4; }

                    return { idx: idx + 1, col: this.colors[idx] };
                }
            };

            scope.$watch(attrs.servoticketCheckstrength, function () {
                var value = $parse( attrs.servoticketCheckstrength )( scope ) || '';

                var c = strength.getColor(strength.mesureStrength( value ));
                element.css({ "display": "inline" });
                element.children('li')
                    .css({ "background": "#DDD" })
                    .slice(0, c.idx)
                    .css({ "background": c.col });
            });

        }
    }

})();

(function () {
    'use strict';

    angular
        .module('app.components.autofocus')
        .directive('servoticketAutofocus', ServoticketAutofocus);

    function ServoticketAutofocus( ) {
        var directive = {
            restrict: 'A',
            link: linkFn
        };

        return directive;

        function linkFn( scope, element, attrs ) {
            var DEFAULT_TIME = attrs.servoticketAutofocus || 200;
            
            setTimeout(setFocus, +DEFAULT_TIME);
            
            function setFocus() {
                var el = element[0];
                
                if( el.nodeName != 'INPUT' && el.nodeName != 'TEXTAREA' ) {
                    el = element[0].querySelector('input, textarea');
                }
                
                if( el ) el.focus();
            }
        }
    }

})();
(function () {
    'use strict';

    angular
        .module('app.main.auth.recuperar-senha', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.recuperar-senha', {
            url      : '/auth/redefine/:token',
            views    : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.recuperar-senha': {
                    templateUrl: 'app/main/auth/recuperar-senha/index.html',
                    controller : 'RecuperarSenhaController as vm'
                }
            },
            bodyClass: 'forgot-password',
            public: true
        });

    }
})();

(function () {
    'use strict';

    angular
        .module('app.main.auth.recuperar-senha')
        .factory('RecuperarSenhaResource', RecuperarSenhaResource);

    RecuperarSenhaResource.$inject = ['$http', 'OAUTH_BASE_URL', '$rootScope'];
    
    function RecuperarSenhaResource( Http, oauthUrl, $rootScope ) {

        var vm = {
           redefinirSenha: redefinirSenhaFn
        };

        return vm;

        function redefinirSenhaFn( senha, token ) {
            var url = oauthUrl + '/usuario/alteracao/senha/confirmacao';

            return Http.post(url, {
                token: token,
                password: senha,
                dominio: $rootScope.domainName
            });
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.main.auth.recuperar-senha')
        .controller('RecuperarSenhaController', RecuperarSenhaController);

    RecuperarSenhaController.$inject = ['RecuperarSenhaResource', 'Util', '$stateParams', '$location'];

    function RecuperarSenhaController(RecuperarSenhaResource, Util, $stateParams, $location) {
        var vm = this;

        vm.senha = '';
        vm.senha2 = '';

        vm.submit = submitFn;

        function submitFn() {
            if( vm.senha != vm.senha2 ) {
                return Util.showToastMessage('A senha e sua confirmação precisam ser iguais');
            }

            RecuperarSenhaResource.redefinirSenha( vm.senha, $stateParams.token )
                .success(function() {
                    Util.showToastMessage('Senha redefinida com sucesso');

                    goToLogin();
                })
                .error(function(error) {
                    if( error.message == 'TOKEN_INVALIDO' ) {
                        Util.showToastMessage('Token inválido');
                    } else {
                        Util.showToastMessage('Erro ao redefinir senha');
                    }

                    goToLogin();
                });
        }

        function goToLogin() {
            $location.path('/auth/login');
        }

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.main.auth.login', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        // State
        $stateProvider.state('app.login', {
            url      : '/auth/login',
            views    : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.login': {
                    templateUrl: 'app/main/auth/login/login.html',
                    controller : 'LoginController as vm'
                }
            },
            bodyClass: 'login-v2',
            public: true
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/auth/login');

    }
})();

(function () {
    'use strict';

    angular
        .module('app.main.auth.login')
        .controller('LoginController', LoginController);

    /** @ngInject */
    function LoginController($rootScope, authApi, util, api, CLIENT_ID, CLIENT_SECRET, HOME_PAGE_PATH, $location, $cookies, $mdToast, AppVersion) {
        var vm = this;
        $rootScope.version = AppVersion;

        // Data
        vm.form = {
            username: '',
            password: '',
            remember: true
        };

        // Methods
        vm.doLogin = doLogin;

        //////////

        (function init() {
            var username = $cookies.get('username');
            if (username)
                vm.form.username = username;
        })();

        function doLogin() {
            var data = util.buildFormUrlencodedParams({
                client_id: CLIENT_ID,
                client_secret: CLIENT_SECRET,
                grant_type: 'password',
                username: vm.form.username,
                password: vm.form.password
            });

            authApi.login.post(data, onSuccess, onError);

            function onError(response) {
                $mdToast.show($mdToast.simple().position('bottom right').textContent('Usuário ou senha inválido').hideDelay(3000));
            }

            function onSuccess(response) {
                localStorage.removeItem('evento');
                localStorage.removeItem('locatario');

                var expirationDate = new Date();
                expirationDate.setSeconds(response.expires_in);

                api.setAccessToken(response.access_token, expirationDate, vm.form.remember);
                api.setRefreshToken(response.refresh_token, expirationDate, vm.form.remember);

                authApi.perfilamento.get({
                    token: response.access_token
                }, function (data) {
                    $rootScope.setPerfilamento(data);

                    updateAcesso(authApi, $rootScope, data);

                    $location.path(HOME_PAGE_PATH);
                });

                if (vm.form.remember) {
                    $cookies.put('username', vm.form.username);
                } else {
                    $cookies.remove('username');
                }
            }
        }

    }

    function updateAcesso(authApi, $rootScope, userData) {
        const browser = getBrowserInfo();

        const model = {
            idRegUsuario: userData.idUsuario,
            aplicativo: {
                dsAplicacao: 'servoticket',
            },
            dhLogin: getCurrentDateTime(),
            dsVersaoApp: $rootScope.version,
            dsDevice: browser,
        };

        authApi.updateAcesso.post(model, function(response) {
            console.log('Acesso atualizado com sucesso:', response);
        }, function(error) {
            console.error('Erro ao atualizar o acesso:', error);
        });
    };

    function getBrowserInfo() {
        var userAgent = navigator.userAgent;
        var browserName, fullVersion;

        if (userAgent.indexOf("Firefox") > -1) {
            browserName = "Firefox";
            fullVersion = userAgent.substring(userAgent.indexOf("Firefox") + 8);
        } else if (userAgent.indexOf("Chrome") > -1) {
            browserName = "Chrome";
            fullVersion = userAgent.substring(userAgent.indexOf("Chrome") + 7);
        } else if (userAgent.indexOf("Safari") > -1) {
            browserName = "Safari";
            fullVersion = userAgent.substring(userAgent.indexOf("Safari") + 7);
        } else if (userAgent.indexOf("MSIE") > -1 || !!document.documentMode) {
            browserName = "Internet Explorer";
            fullVersion = userAgent.substring(userAgent.indexOf("MSIE") + 5);
        } else {
            browserName = "Unknown";
            fullVersion = "Unknown";
        }

        // Separar a versão do navegador da string completa
        fullVersion = fullVersion.split(' ')[0];

        return browserName + '/' + fullVersion;
    }

    function getCurrentDateTime() {
        var now = new Date();

        // Formatar como YYYY-MM-DD HH:mm:ss
        var year = now.getFullYear();
        var month = ('0' + (now.getMonth() + 1)).slice(-2); // Mês é zero-indexado
        var day = ('0' + now.getDate()).slice(-2);
        var hours = ('0' + now.getHours()).slice(-2);
        var minutes = ('0' + now.getMinutes()).slice(-2);
        var seconds = ('0' + now.getSeconds()).slice(-2);

        return year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds;
    };

})();

(function () {
    'use strict';

    angular
        .module('app.main.auth.forgot-password', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider) {
        // State
        $stateProvider.state('app.forgot-password', {
            url      : '/auth/forgot-password',
            views    : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.forgot-password': {
                    templateUrl: 'app/main/auth/forgot-password/index.html',
                    controller : 'ForgotPasswordController as vm'
                }
            },
            bodyClass: 'forgot-password',
            public: true
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/auth/forgot-password');

    }
})();

(function () {
    'use strict';

    angular
        .module('app.main.auth.forgot-password')
        .factory('AlterarSenhaResource', ChangepasswordResource);

    ChangepasswordResource.$inject = ['$http', 'OAUTH_BASE_URL', '$rootScope'];
    
    function ChangepasswordResource( Http, oauthUrl, $rootScope ) {

        var vm = {
            enviarLinkRedefinicao: enviarLinkRedefinicaoFn
        };

        return vm;

        function enviarLinkRedefinicaoFn( email ) {
            var url = oauthUrl + '/usuario/alteracao/senha/envio';

            return Http.post(url, {
                username: email,
                dominio: $rootScope.domainName
            });
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.main.auth.forgot-password')
        .controller('ForgotPasswordController', ForgotPasswordController);

    ForgotPasswordController.$inject = ['AlterarSenhaResource', 'Util'];

    function ForgotPasswordController(ChangepasswordResource, Util) {
        var vm = this;

        vm.username;
        vm.submit = submitFn;

        function submitFn() {
            ChangepasswordResource.enviarLinkRedefinicao( vm.username ).success(function() {
                Util.showToastMessage( 'Foi enviado um link para redefinição de senha no seu email.' );
            }).error(function() {
                 Util.showToastMessage( 'Erro ao enviar email' );
            });
        }

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core',
            [
                'ngAnimate',
                'ngAria',
                'ngCookies',
                'ngMessages',
                'ngResource',
                'ngSanitize',
                'ngMaterial',
                'pascalprecht.translate',
                'ui.router'
                
            ]);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsWidgetController', MsWidgetController)
        .directive('msWidget', msWidgetDirective)
        .directive('msWidgetFront', msWidgetFrontDirective)
        .directive('msWidgetBack', msWidgetBackDirective);

    /** @ngInject */
    function MsWidgetController($scope, $element)
    {
        var vm = this;

        // Data
        vm.flipped = false;

        // Methods
        vm.flip = flip;

        //////////

        /**
         * Flip the widget
         */
        function flip()
        {
            if ( !isFlippable() )
            {
                return;
            }

            // Toggle flipped status
            vm.flipped = !vm.flipped;

            // Toggle the 'flipped' class
            $element.toggleClass('flipped', vm.flipped);
        }

        /**
         * Check if widget is flippable
         *
         * @returns {boolean}
         */
        function isFlippable()
        {
            return (angular.isDefined($scope.flippable) && $scope.flippable === true);
        }
    }

    /** @ngInject */
    function msWidgetDirective()
    {
        return {
            restrict  : 'E',
            scope     : {
                flippable: '=?'
            },
            controller: 'MsWidgetController',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    //////////
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetFrontDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-front');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetBackDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-back');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsTimelineController', MsTimelineController)
        .directive('msTimeline', msTimelineDirective)
        .directive('msTimelineItem', msTimelineItemDirective);

    /** @ngInject */
    function MsTimelineController()
    {
        var vm = this;

        // Data
        vm.scrollEl = undefined;

        // Methods
        vm.setScrollEl = setScrollEl;
        vm.getScrollEl = getScrollEl;

        //////////

        /**
         * Set scroll element
         *
         * @param scrollEl
         */
        function setScrollEl(scrollEl)
        {
            vm.scrollEl = scrollEl;
        }

        /**
         * Get scroll element
         *
         * @returns {undefined|*}
         */
        function getScrollEl()
        {
            return vm.scrollEl;
        }
    }

    /** @ngInject */
    function msTimelineDirective()
    {
        return {
            scope     : {
                loadMore: '&?msTimelineLoadMore'
            },
            controller: 'MsTimelineController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-timeline');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    // Create an element for triggering the load more action and append it
                    var loadMoreEl = angular.element('<div class="ms-timeline-loader md-accent-bg md-whiteframe-4dp"><span class="spinner animate-rotate"></span></div>');
                    iElement.append(loadMoreEl);

                    // Grab the scrollable element and store it in the controller for general use
                    var scrollEl = angular.element('#content');
                    MsTimelineCtrl.setScrollEl(scrollEl);

                    // Threshold
                    var threshold = 144;

                    // Register onScroll event for the first time
                    registerOnScroll();

                    /**
                     * onScroll Event
                     */
                    function onScroll()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() + threshold > loadMoreEl.position().top )
                        {
                            // Show the loader
                            loadMoreEl.addClass('show');

                            // Unregister scroll event to prevent triggering the function over and over again
                            unregisterOnScroll();

                            // Trigger load more event
                            scope.loadMore().then(
                                // Success
                                function ()
                                {
                                    // Hide the loader
                                    loadMoreEl.removeClass('show');

                                    // Register the onScroll event again
                                    registerOnScroll();
                                },

                                // Error
                                function ()
                                {
                                    // Remove the loader completely
                                    loadMoreEl.remove();
                                }
                            );
                        }
                    }

                    /**
                     * onScroll event registerer
                     */
                    function registerOnScroll()
                    {
                        scrollEl.on('scroll', onScroll);
                    }

                    /**
                     * onScroll event unregisterer
                     */
                    function unregisterOnScroll()
                    {
                        scrollEl.off('scroll', onScroll);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        unregisterOnScroll();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msTimelineItemDirective($timeout, $q)
    {
        return {
            scope  : true,
            require: '^msTimeline',
            compile: function (tElement)
            {
                tElement.addClass('ms-timeline-item').addClass('hidden');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    var threshold = 72,
                        itemLoaded = false,
                        itemInViewport = false,
                        scrollEl = MsTimelineCtrl.getScrollEl();

                    //////////

                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Check if the timeline item has ms-card
                        if ( iElement.find('ms-card') )
                        {
                            // If the ms-card template loaded...
                            scope.$on('msCard::cardTemplateLoaded', function (event, args)
                            {
                                var cardEl = angular.element(args[0]);

                                // Test the card to see if there is any image on it
                                testForImage(cardEl).then(function ()
                                {
                                    $timeout(function ()
                                    {
                                        itemLoaded = true;
                                    });
                                });
                            });
                        }
                        else
                        {
                            // Test the element to see if there is any image on it
                            testForImage(iElement).then(function ()
                            {
                                $timeout(function ()
                                {
                                    itemLoaded = true;
                                });
                            });
                        }

                        // Check if the loaded element also in the viewport
                        scrollEl.on('scroll', testForVisibility);

                        // Test for visibility for the first time without waiting for the scroll event
                        testForVisibility();
                    }

                    // Item ready watcher
                    var itemReadyWatcher = scope.$watch(
                        function ()
                        {
                            return itemLoaded && itemInViewport;
                        },
                        function (current, old)
                        {
                            if ( angular.equals(current, old) )
                            {
                                return;
                            }

                            if ( current )
                            {
                                iElement.removeClass('hidden').addClass('animate');

                                // Unbind itemReadyWatcher
                                itemReadyWatcher();
                            }
                        }, true);

                    /**
                     * Test the given element for image
                     *
                     * @param element
                     * @returns promise
                     */
                    function testForImage(element)
                    {
                        var deferred = $q.defer(),
                            imgEl = element.find('img');

                        if ( imgEl.length > 0 )
                        {
                            imgEl.on('load', function ()
                            {
                                deferred.resolve('Image is loaded');
                            });
                        }
                        else
                        {
                            deferred.resolve('No images');
                        }

                        return deferred.promise;
                    }

                    /**
                     * Test the element for visibility
                     */
                    function testForVisibility()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() > iElement.position().top + threshold )
                        {
                            $timeout(function ()
                            {
                                itemInViewport = true;
                            });

                            // Unbind the scroll event
                            scrollEl.off('scroll', testForVisibility);
                        }
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsStepperController', MsStepperController)
        .directive('msStepper', msStepperDirective)
        .directive('msStepperStep', msStepperStepDirective);

    /** @ngInject */
    function MsStepperController($timeout)
    {
        var vm = this;

        // Data
        vm.mainForm = undefined;

        vm.steps = [];
        vm.currentStep = undefined;
        vm.currentStepNumber = 1;

        // Methods
        vm.registerMainForm = registerMainForm;
        vm.registerStep = registerStep;
        vm.setupSteps = setupSteps;
        vm.resetForm = resetForm;

        vm.setCurrentStep = setCurrentStep;

        vm.gotoStep = gotoStep;
        vm.gotoPreviousStep = gotoPreviousStep;
        vm.gotoNextStep = gotoNextStep;
        vm.gotoFirstStep = gotoFirstStep;
        vm.gotoLastStep = gotoLastStep;

        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.isStepCurrent = isStepCurrent;
        vm.isStepDisabled = isStepDisabled;
        vm.isStepOptional = isStepOptional;
        vm.isStepValid = isStepValid;
        vm.isStepNumberValid = isStepNumberValid;

        vm.isFormValid = isFormValid;

        //////////

        /**
         * Register the main form
         *
         * @param form
         */
        function registerMainForm(form)
        {
            vm.mainForm = form;
        }

        /**
         * Register a step
         *
         * @param element
         * @param scope
         * @param form
         */
        function registerStep(element, scope, form)
        {
            var step = {
                element   : element,
                scope     : scope,
                form      : form,
                stepNumber: scope.step || (vm.steps.length + 1),
                stepTitle : scope.stepTitle
            };

            // Push the step into steps array
            vm.steps.push(step);

            // Sort steps by stepNumber
            vm.steps.sort(function (a, b)
            {
                return a.stepNumber - b.stepNumber;
            });
        }

        /**
         * Setup steps for the first time
         */
        function setupSteps()
        {
            vm.setCurrentStep(vm.currentStepNumber);
        }

        /**
         * Reset steps and the main form
         */
        function resetForm()
        {
            // Timeout is required here because we need to
            // let form model to reset before setting the
            // statuses
            $timeout(function ()
            {
                // Reset all the steps
                for ( var x = 0; x < vm.steps.length; x++ )
                {
                    vm.steps[x].form.$setPristine();
                    vm.steps[x].form.$setUntouched();
                }

                // Reset the main form
                vm.mainForm.$setPristine();
                vm.mainForm.$setUntouched();

                // Go to first step
                gotoFirstStep();
            })
        }

        /**
         * Set current step
         *
         * @param stepNumber
         */
        function setCurrentStep(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return;
            }

            // Update the current step number
            vm.currentStepNumber = stepNumber;

            // Hide all steps
            for ( var i = 0; i < vm.steps.length; i++ )
            {
                vm.steps[i].element.hide();
            }

            // Show the current step
            vm.steps[vm.currentStepNumber - 1].element.show();
        }

        /**
         * Go to a step
         *
         * @param stepNumber
         */
        function gotoStep(stepNumber)
        {
            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the previous step
         */
        function gotoPreviousStep()
        {
            vm.setCurrentStep(vm.currentStepNumber - 1);
        }

        /**
         * Go to the next step
         */
        function gotoNextStep()
        {
            vm.setCurrentStep(vm.currentStepNumber + 1);
        }

        /**
         * Go to the first step
         */
        function gotoFirstStep()
        {
            vm.setCurrentStep(1);
        }

        /**
         * Go to the last step
         */
        function gotoLastStep()
        {
            vm.setCurrentStep(vm.steps.length);
        }

        /**
         * Check if the current step is the first step
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.currentStepNumber === 1;
        }

        /**
         * Check if the current step is the last step
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.currentStepNumber === vm.steps.length;
        }

        /**
         * Check if the given step is the current one
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepCurrent(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.currentStepNumber === stepNumber;
        }

        /**
         * Check if the given step should be disabled
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepDisabled(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            var disabled = false;

            for ( var i = 1; i < stepNumber; i++ )
            {
                if ( !isStepValid(i) )
                {
                    disabled = true;
                    break;
                }
            }

            return disabled;
        }

        /**
         * Check if the given step is optional
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepOptional(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.steps[stepNumber - 1].scope.optionalStep;
        }

        /**
         * Check if the given step is valid
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepValid(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            // If the step is optional, always return true
            if ( isStepOptional(stepNumber) )
            {
                return true;
            }

            return vm.steps[stepNumber - 1].form.$valid;
        }

        /**
         * Check if the given step number is a valid step number
         *
         * @param stepNumber
         * @returns {boolean}
         */
        function isStepNumberValid(stepNumber)
        {
            return !(stepNumber < 1 || stepNumber > vm.steps.length);
        }

        /**
         * Check if the entire form is valid
         *
         * @returns {boolean}
         */
        function isFormValid()
        {
            return vm.mainForm.$valid;
        }
    }

    /** @ngInject */
    function msStepperDirective()
    {
        return {
            restrict        : 'A',
            require         : ['form', 'msStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/horizontal/horizontal.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time
                    MsStepperCtrl.registerMainForm(FormCtrl);
                    MsStepperCtrl.setupSteps();
                };
            }
        }
    }

    /** @ngInject */
    function msStepperStepDirective()
    {
        return {
            restrict: 'E',
            require : ['form', '^msStepper'],
            priority: 1000,
            scope   : {
                step        : '=?',
                stepTitle   : '=?',
                optionalStep: '=?'
            },
            compile : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Hide the step by default
                    iElement.hide();
                };
            }
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSplashScreen', msSplashScreenDirective);

    /** @ngInject */
    function msSplashScreenDirective($animate)
    {
        return {
            restrict: 'E',
            link    : function (scope, iElement)
            {
                var splashScreenRemoveEvent = scope.$on('msSplashScreen::remove', function ()
                {
                    $animate.leave(iElement).then(function ()
                    {
                        // De-register scope event
                        splashScreenRemoveEvent();

                        // Null-ify everything else
                        scope = iElement = null;
                    });
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSidenavHelper', msSidenavHelperDirective);

    /** @ngInject */
    function msSidenavHelperDirective()
    {
        return {
            restrict: 'A',
            require : '^mdSidenav',
            link    : function (scope, iElement, iAttrs, MdSidenavCtrl)
            {
                // Watch md-sidenav open & locked open statuses
                // and add class to the ".page-layout" if only
                // the sidenav open and NOT locked open
                scope.$watch(function ()
                {
                    return MdSidenavCtrl.isOpen() && !MdSidenavCtrl.isLockedOpen();
                }, function (current)
                {
                    if ( angular.isUndefined(current) )
                    {
                        return;
                    }

                    iElement.parent().toggleClass('full-height', current);
                    angular.element('html').toggleClass('sidenav-open', current);
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSearchBar', msSearchBarDirective);

    /** @ngInject */
    function msSearchBarDirective($document)
    {
        return {
            restrict   : 'E',
            scope      : true,
            templateUrl: 'app/core/directives/ms-search-bar/ms-search-bar.html',
            compile    : function (tElement)
            {
                // Add class
                tElement.addClass('ms-search-bar');

                return function postLink(scope, iElement)
                {
                    var expanderEl,
                        collapserEl;

                    // Initialize
                    init();

                    function init()
                    {
                        expanderEl = iElement.find('#ms-search-bar-expander');
                        collapserEl = iElement.find('#ms-search-bar-collapser');

                        expanderEl.on('click', expand);
                        collapserEl.on('click', collapse);
                    }

                    /**
                     * Expand
                     */
                    function expand()
                    {
                        iElement.addClass('expanded');

                        // Esc key event
                        $document.on('keyup', escKeyEvent);
                    }

                    /**
                     * Collapse
                     */
                    function collapse()
                    {
                        iElement.removeClass('expanded');
                    }

                    /**
                     * Escape key event
                     *
                     * @param e
                     */
                    function escKeyEvent(e)
                    {
                        if ( e.keyCode === 27 )
                        {
                            collapse();
                            $document.off('keyup', escKeyEvent);
                        }
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msScrollConfig', msScrollConfigProvider)
        .directive('msScroll', msScrollDirective);

    /** @ngInject */
    function msScrollConfigProvider()
    {
        // Default configuration
        var defaultConfiguration = {
            wheelSpeed            : 1,
            wheelPropagation      : false,
            swipePropagation      : true,
            minScrollbarLength    : null,
            maxScrollbarLength    : null,
            useBothWheelAxes      : false,
            useKeyboard           : true,
            suppressScrollX       : false,
            suppressScrollY       : false,
            scrollXMarginOffset   : 0,
            scrollYMarginOffset   : 0,
            stopPropagationOnClick: true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig
            };

            return service;

            //////////

            /**
             * Return the config
             */
            function getConfig()
            {
                return defaultConfiguration;
            }
        };
    }

    /** @ngInject */
    function msScrollDirective($timeout, msScrollConfig, msUtils, fuseConfig)
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                // Do not replace scrollbars if
                // 'disableCustomScrollbars' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbars') )
                {
                    return;
                }

                // Do not replace scrollbars on mobile devices
                // if 'disableCustomScrollbarsOnMobile' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbarsOnMobile') && msUtils.isMobile() )
                {
                    return;
                }

                // Add class
                tElement.addClass('ms-scroll');

                return function postLink(scope, iElement, iAttrs)
                {
                    var options = {};

                    // If options supplied, evaluate the given
                    // value. This is because we don't want to
                    // have an isolated scope but still be able
                    // to use scope variables.
                    // We don't want an isolated scope because
                    // we should be able to use this everywhere
                    // especially with other directives
                    if ( iAttrs.msScroll )
                    {
                        options = scope.$eval(iAttrs.msScroll);
                    }

                    // Extend the given config with the ones from provider
                    options = angular.extend({}, msScrollConfig.getConfig(), options);

                    // Initialize the scrollbar
                    $timeout(function ()
                    {
                        PerfectScrollbar.initialize(iElement[0], options);
                    }, 0);

                    // Update the scrollbar on element mouseenter
                    iElement.on('mouseenter', updateScrollbar);

                    // Watch scrollHeight and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollHeight');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    // Watch scrollWidth and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollWidth');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    /**
                     * Update the scrollbar
                     */
                    function updateScrollbar()
                    {
                        PerfectScrollbar.update(iElement[0]);
                    }

                    // Cleanup on destroy
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('mouseenter');
                        PerfectScrollbar.destroy(iElement[0]);
                    });
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msResponsiveTable', msResponsiveTableDirective);

    /** @ngInject */
    function msResponsiveTableDirective()
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement)
            {
                // Wrap the table
                var wrapper = angular.element('<div class="ms-responsive-table-wrapper"></div>');
                iElement.after(wrapper);
                wrapper.append(iElement);

                //////////
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msRandomClass', msRandomClassDirective);

    /** @ngInject */
    function msRandomClassDirective()
    {
        return {
            restrict: 'A',
            scope   : {
                msRandomClass: '='
            },
            link    : function (scope, iElement)
            {
                var randomClass = scope.msRandomClass[Math.floor(Math.random() * (scope.msRandomClass.length))];
                iElement.addClass(randomClass);
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msNavigationService', msNavigationServiceProvider)
        .controller('MsNavigationController', MsNavigationController)
        // Vertical
        .directive('msNavigation', msNavigationDirective)
        .controller('MsNavigationNodeController', MsNavigationNodeController)
        .directive('msNavigationNode', msNavigationNodeDirective)
        .directive('msNavigationItem', msNavigationItemDirective)
        //Horizontal
        .directive('msNavigationHorizontal', msNavigationHorizontalDirective)
        .controller('MsNavigationHorizontalNodeController', MsNavigationHorizontalNodeController)
        .directive('msNavigationHorizontalNode', msNavigationHorizontalNodeDirective)
        .directive('msNavigationHorizontalItem', msNavigationHorizontalItemDirective);

    /** @ngInject */
    function msNavigationServiceProvider()
    {
        // Inject $log service
        var $log = angular.injector(['ng']).get('$log');

        // Navigation array
        var navigation = [];

        var service = this;

        // Methods
        service.saveItem = saveItem;
        service.deleteItem = deleteItem;
        service.sortByWeight = sortByWeight;

        //////////

        /**
         * Create or update the navigation item
         *
         * @param path
         * @param item
         */
        function saveItem(path, item)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            var parts = path.split('.');

            // Generate the object id from the parts
            var id = parts[parts.length - 1];

            // Get the parent item from the parts
            var parent = _findOrCreateParent(parts);

            // Decide if we are going to update or create
            var updateItem = false;

            for ( var i = 0; i < parent.length; i++ )
            {
                if ( parent[i]._id === id )
                {
                    updateItem = parent[i];

                    break;
                }
            }

            // Update
            if ( updateItem )
            {
                angular.extend(updateItem, item);

                // Add proper ui-sref
                updateItem.uisref = _getUiSref(updateItem);
            }
            // Create
            else
            {
                // Create an empty children array in the item
                item.children = [];

                // Add the default weight if not provided or if it's not a number
                if ( angular.isUndefined(item.weight) || !angular.isNumber(item.weight) )
                {
                    item.weight = 1;
                }

                // Add the item id
                item._id = id;

                // Add the item path
                item._path = path;

                // Add proper ui-sref
                item.uisref = _getUiSref(item);

                // Push the item into the array
                parent.push(item);
            }
        }

        /**
         * Delete navigation item
         *
         * @param path
         */
        function deleteItem(path)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            // Locate the item by using given path
            var item = navigation,
                parts = path.split('.');

            for ( var p = 0; p < parts.length; p++ )
            {
                var id = parts[p];

                for ( var i = 0; i < item.length; i++ )
                {
                    if ( item[i]._id === id )
                    {
                        // If we have a matching path,
                        // we have found our object:
                        // remove it.
                        if ( item[i]._path === path )
                        {
                            item.splice(i, 1);
                            return true;
                        }

                        // Otherwise grab the children of
                        // the current item and continue
                        item = item[i].children;
                        break;
                    }
                }
            }

            return false;
        }

        /**
         * Sort the navigation items by their weights
         *
         * @param parent
         */
        function sortByWeight(parent)
        {
            // If parent not provided, sort the root items
            if ( !parent )
            {
                parent = navigation;
                parent.sort(_byWeight);
            }

            // Sort the children
            for ( var i = 0; i < parent.length; i++ )
            {
                var children = parent[i].children;

                if ( children.length > 1 )
                {
                    children.sort(_byWeight);
                }

                if ( children.length > 0 )
                {
                    sortByWeight(children);
                }
            }
        }

        /* ----------------- */
        /* Private Functions */
        /* ----------------- */

        /**
         * Find or create parent
         *
         * @param parts
         * @returns {Array|Boolean}
         * @private
         */
        function _findOrCreateParent(parts)
        {
            // Store the main navigation
            var parent = navigation;

            // If it's going to be a root item
            // return the navigation itself
            if ( parts.length === 1 )
            {
                return parent;
            }

            // Remove the last element from the parts as
            // we don't need that to figure out the parent
            parts.pop();

            // Find and return the parent
            for ( var i = 0; i < parts.length; i++ )
            {
                var _id = parts[i],
                    createParent = true;

                for ( var p = 0; p < parent.length; p++ )
                {
                    if ( parent[p]._id === _id )
                    {
                        parent = parent[p].children;
                        createParent = false;

                        break;
                    }
                }

                // If there is no parent found, create one, push
                // it into the current parent and assign it as a
                // new parent
                if ( createParent )
                {
                    var item = {
                        _id     : _id,
                        _path   : parts.join('.'),
                        title   : _id,
                        weight  : 1,
                        children: []
                    };

                    parent.push(item);
                    parent = item.children;
                }
            }

            return parent;
        }

        /**
         * Sort by weight
         *
         * @param x
         * @param y
         * @returns {number}
         * @private
         */
        function _byWeight(x, y)
        {
            return parseInt(x.weight) - parseInt(y.weight);
        }

        /**
         * Setup the ui-sref using state & state parameters
         *
         * @param item
         * @returns {string}
         * @private
         */
        function _getUiSref(item)
        {
            var uisref = '';

            if ( angular.isDefined(item.state) )
            {
                uisref = item.state[0];

                if ( angular.isDefined(item.stateParams) && angular.isObject(item.stateParams) )
                {
                    uisref = uisref + '(' + angular.toJson(item.stateParams) + ')';
                }
            }

            return uisref;
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */

        this.$get = function ()
        {
            var activeItem = null,
                navigationScope = null,
                folded = null,
                foldedOpen = null;

            var service = {
                saveItem           : saveItem,
                deleteItem         : deleteItem,
                sort               : sortByWeight,
                clearNavigation    : clearNavigation,
                setActiveItem      : setActiveItem,
                getActiveItem      : getActiveItem,
                getNavigationObject: getNavigationObject,
                setNavigationScope : setNavigationScope,
                setFolded          : setFolded,
                getFolded          : getFolded,
                setFoldedOpen      : setFoldedOpen,
                getFoldedOpen      : getFoldedOpen,
                toggleFolded       : toggleFolded
            };

            return service;

            //////////

            /**
             * Clear the entire navigation
             */
            function clearNavigation()
            {
                // Clear the navigation array
                navigation = [];

                // Clear the vm.navigation from main controller
                if ( navigationScope )
                {
                    navigationScope.vm.navigation = [];
                }
            }

            /**
             * Set active item
             *
             * @param node
             * @param scope
             */
            function setActiveItem(node, scope)
            {
                activeItem = {
                    node : node,
                    scope: scope
                };
            }

            /**
             * Return active item
             */
            function getActiveItem()
            {
                return activeItem;
            }

            /**
             * Return navigation object
             *
             * @param root
             * @returns {Array}
             */
            function getNavigationObject(root)
            {
                if ( root )
                {
                    for ( var i = 0; i < navigation.length; i++ )
                    {
                        if ( navigation[i]._id === root )
                        {
                            return [navigation[i]];
                        }
                    }
                }

                return navigation;
            }

            /**
             * Store navigation's scope for later use
             *
             * @param scope
             */
            function setNavigationScope(scope)
            {
                navigationScope = scope;
            }

            /**
             * Set folded status
             *
             * @param status
             */
            function setFolded(status)
            {
                folded = status;
            }

            /**
             * Return folded status
             *
             * @returns {*}
             */
            function getFolded()
            {
                return folded;
            }

            /**
             * Set folded open status
             *
             * @param status
             */
            function setFoldedOpen(status)
            {
                foldedOpen = status;
            }

            /**
             * Return folded open status
             *
             * @returns {*}
             */
            function getFoldedOpen()
            {
                return foldedOpen;
            }


            /**
             * Toggle fold on stored navigation's scope
             */
            function toggleFolded()
            {
                navigationScope.toggleFolded();
            }
        };
    }

    /** @ngInject */
    function MsNavigationController($scope, msNavigationService)
    {
        var vm = this;

        // Data
        if ( $scope.root )
        {
            vm.navigation = msNavigationService.getNavigationObject($scope.root);
        }
        else
        {
            vm.navigation = msNavigationService.getNavigationObject();
        }

        // Methods
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Sort the navigation before doing anything else
            msNavigationService.sort();
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            angular.element('body').toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }
    }

    /** @ngInject */
    function msNavigationDirective($rootScope, $timeout, $mdSidenav, msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                folded: '=',
                root  : '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/vertical.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation');

                return function postLink(scope, iElement)
                {
                    var bodyEl = angular.element('body'),
                        foldExpanderEl = angular.element('<div id="ms-navigation-fold-expander"></div>'),
                        foldCollapserEl = angular.element('<div id="ms-navigation-fold-collapser"></div>'),
                        sidenav = $mdSidenav('navigation');

                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Set the folded status for the first time.
                        // First, we have to check if we have a folded
                        // status available in the service already. This
                        // will prevent navigation to act weird if we already
                        // set the fold status, remove the navigation and
                        // then re-initialize it, which happens if we
                        // change to a view without a navigation and then
                        // come back with history.back() function.

                        // If the service didn't initialize before, set
                        // the folded status from scope, otherwise we
                        // won't touch anything because the folded status
                        // already set in the service...
                        if ( msNavigationService.getFolded() === null )
                        {
                            msNavigationService.setFolded(scope.folded);
                        }

                        if ( msNavigationService.getFolded() )
                        {
                            // Collapse everything.
                            // This must be inside a $timeout because by the
                            // time we call this, the 'msNavigation::collapse'
                            // event listener is not registered yet. $timeout
                            // will ensure that it will be called after it is
                            // registered.
                            $timeout(function ()
                            {
                                $rootScope.$broadcast('msNavigation::collapse');
                            });

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                    }

                    // Sidenav locked open status watcher
                    scope.$watch(function ()
                    {
                        return sidenav.isLockedOpen();
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        var folded = msNavigationService.getFolded();

                        if ( folded )
                        {
                            if ( current )
                            {
                                // Collapse everything
                                $rootScope.$broadcast('msNavigation::collapse');
                            }
                            else
                            {
                                // Expand the active one and its parents
                                var activeItem = msNavigationService.getActiveItem();
                                if ( activeItem )
                                {
                                    activeItem.scope.$emit('msNavigation::stateMatched');
                                }
                            }
                        }
                    });

                    // Folded status watcher
                    scope.$watch('folded', function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        setFolded(current);
                    });

                    /**
                     * Set folded status
                     *
                     * @param folded
                     */
                    function setFolded(folded)
                    {
                        // Store folded status on the service for global access
                        msNavigationService.setFolded(folded);

                        if ( folded )
                        {
                            // Collapse everything
                            $rootScope.$broadcast('msNavigation::collapse');

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                        else
                        {
                            // Expand the active one and its parents
                            var activeItem = msNavigationService.getActiveItem();
                            if ( activeItem )
                            {
                                activeItem.scope.$emit('msNavigation::stateMatched');
                            }

                            // Remove body class
                            bodyEl.removeClass('ms-navigation-folded ms-navigation-folded-open');

                            // Remove fold collapser
                            removeFoldCollapser();
                        }
                    }

                    /**
                     * Set fold expander
                     */
                    function setFoldExpander()
                    {
                        iElement.parent().append(foldExpanderEl);

                        // Let everything settle for a moment
                        // before registering the event listener
                        $timeout(function ()
                        {
                            foldExpanderEl.on('mouseenter touchstart', onFoldExpanderHover);
                        });
                    }

                    /**
                     * Set fold collapser
                     */
                    function setFoldCollapser()
                    {
                        bodyEl.find('#main').append(foldCollapserEl);
                        foldCollapserEl.on('mouseenter touchstart', onFoldCollapserHover);
                    }

                    /**
                     * Remove fold collapser
                     */
                    function removeFoldCollapser()
                    {
                        foldCollapserEl.remove();
                    }

                    /**
                     * onHover event of foldExpander
                     */
                    function onFoldExpanderHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(true);

                        // Expand the active one and its parents
                        var activeItem = msNavigationService.getActiveItem();
                        if ( activeItem )
                        {
                            activeItem.scope.$emit('msNavigation::stateMatched');
                        }

                        // Add class to the body
                        bodyEl.addClass('ms-navigation-folded-open');

                        // Remove the fold opener
                        foldExpanderEl.remove();

                        // Set fold collapser
                        setFoldCollapser();
                    }

                    /**
                     * onHover event of foldCollapser
                     */
                    function onFoldCollapserHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(false);

                        // Collapse everything
                        $rootScope.$broadcast('msNavigation::collapse');

                        // Remove body class
                        bodyEl.removeClass('ms-navigation-folded-open');

                        // Remove the fold collapser
                        foldCollapserEl.remove();

                        // Set fold expander
                        setFoldExpander();
                    }

                    /**
                     * Public access for toggling folded status externally
                     */
                    scope.toggleFolded = function ()
                    {
                        var folded = msNavigationService.getFolded();

                        setFolded(!folded);
                    };

                    /**
                     * On $stateChangeStart
                     */
                    scope.$on('$stateChangeStart', function ()
                    {
                        // Close the sidenav
                        sidenav.close();

                        // If navigation is folded open, close it
                        if ( msNavigationService.getFolded() )
                        {
                            onFoldCollapserHover();
                        }
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        foldCollapserEl.off('mouseenter touchstart');
                        foldExpanderEl.off('mouseenter touchstart');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationNodeController($scope, $element, $rootScope, $animate, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.collapsed = undefined;
        vm.collapsable = undefined;
        vm.group = undefined;
        vm.animateHeightClass = 'animate-height';

        // Methods
        vm.toggleCollapsed = toggleCollapsed;
        vm.collapse = collapse;
        vm.expand = expand;
        vm.getClass = getClass;
        vm.isHidden = isHidden;

        //////////

        vm.getClass = function(node) {
            var active = msNavigationService.getActiveItem();

            if( active && node && active.node._id == node._id ) {
                return "active md-accent-bg";
            }
        }

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Is collapsable?
            if ( !vm.hasChildren || vm.group )
            {
                vm.collapsable = false;
            }
            else
            {
                vm.collapsable = !!(angular.isUndefined(vm.node.collapsable) || typeof vm.node.collapsable !== 'boolean' || vm.node.collapsable === true);
            }

            // Is collapsed?
            if ( !vm.collapsable )
            {
                vm.collapsed = false;
            }
            else
            {
                vm.collapsed = !!(angular.isUndefined(vm.node.collapsed) || typeof vm.node.collapsed !== 'boolean' || vm.node.collapsed === true);
            }


            for( var f in vm.node.state ) {
                var state = vm.node.state[f];

                // Expand all parents if we have a matching state or
                // the current state is a child of the node's state
                if ( state === $state.current.name || $state.includes(state) ){
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) ){
                        return;
                    }

                    $scope.$emit('msNavigation::stateMatched');

                    // Also store the current active menu item
                    msNavigationService.setActiveItem(vm.node, $scope);

                    break;
                }
            }
           

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Expand if the current scope is collapsable and is collapsed
                if ( vm.collapsable && vm.collapsed )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.collapsed = false;
                    });
                }
            });

            // Listen for collapse event
            $scope.$on('msNavigation::collapse', function (event, path)
            {
                if ( vm.collapsed || !vm.collapsable )
                {
                    return;
                }

                // If there is no path defined, collapse
                if ( angular.isUndefined(path) )
                {
                    vm.collapse();
                }
                // If there is a path defined, do not collapse
                // the items that are inside that path. This will
                // prevent parent items from collapsing
                else
                {
                    var givenPathParts = path.split('.'),
                        activePathParts = [];

                    var activeItem = msNavigationService.getActiveItem();
                    if ( activeItem )
                    {
                        activePathParts = activeItem.node._path.split('.');
                    }

                    // Test for given path
                    if ( givenPathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    // Test for active path
                    if ( activePathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    vm.collapse();
                }
            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function () {

                for( var f in vm.node.state ) {
                    var state = vm.node.state[f];
                    if ( state === $state.current.name ) {
                        // If state params are defined, make sure they are
                        // equal, otherwise do not set the active item
                        if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                        {
                            return;
                        }

                        // Update active item on state change
                        msNavigationService.setActiveItem(vm.node, $scope);

                        // Collapse everything except the one we're using
                        $rootScope.$broadcast('msNavigation::collapse', vm.node._path);

                        break;
                    }
                }
            });
        }

        /**
         * Toggle collapsed
         */
        function toggleCollapsed()
        {
            if ( vm.collapsed )
            {
                vm.expand();
            }
            else
            {
                vm.collapse();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Grab the element that we are going to collapse
            var collapseEl = vm.element.children('ul');

            // Grab the height
            var height = collapseEl[0].offsetHeight;

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = true;

                // Add collapsing class to the node
                vm.element.addClass('collapsing');

                // Animate the height
                $animate.animate(collapseEl,
                    {
                        'display': 'block',
                        'height' : height + 'px'
                    },
                    {
                        'height': '0px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        collapseEl.css({
                            'display': '',
                            'height' : ''
                        });

                        // Clear collapsing class from the node
                        vm.element.removeClass('collapsing');
                    }
                );

                // Broadcast the collapse event so child items can also be collapsed
                $scope.$broadcast('msNavigation::collapse');
            });
        }

        /**
         * Expand
         */
        function expand()
        {
            // Grab the element that we are going to expand
            var expandEl = vm.element.children('ul');

            // Move the element out of the dom flow and
            // make it block so we can get its height
            expandEl.css({
                'position'  : 'absolute',
                'visibility': 'hidden',
                'display'   : 'block',
                'height'    : 'auto'
            });

            // Grab the height
            var height = expandEl[0].offsetHeight;

            // Reset the style modifications
            expandEl.css({
                'position'  : '',
                'visibility': '',
                'display'   : '',
                'height'    : ''
            });

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = false;

                // Add expanding class to the node
                vm.element.addClass('expanding');

                // Animate the height
                $animate.animate(expandEl,
                    {
                        'display': 'block',
                        'height' : '0px'
                    },
                    {
                        'height': height + 'px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        expandEl.css({
                            'height': ''
                        });

                        // Clear expanding class from the node
                        vm.element.removeClass('expanding');
                    }
                );

                // If item expanded, broadcast the collapse event from rootScope so that the other expanded items
                // can be collapsed. This is necessary for keeping only one parent expanded at any time
                $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }

        /**
         * Check if node should be hidden
         *
         * @returns {boolean}
         */
        function isHidden()
        {
            if ( angular.isDefined(vm.node.hidden) && angular.isFunction(vm.node.hidden) )
            {
                return vm.node.hidden();
            }

            return false;
        }
    }

    /** @ngInject */
    function msNavigationNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationNode'
            },
            controller      : 'MsNavigationNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationItemDirective()
    {
        return {
            restrict: 'A',
            require : '^msNavigationNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // If the item is collapsable...
                    if ( MsNavigationNodeCtrl.collapsable )
                    {
                        iElement.on('click', MsNavigationNodeCtrl.toggleCollapsed);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalDirective(msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                root: '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/horizontal.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal');

                return function postLink(scope)
                {
                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationHorizontalNodeController($scope, $element, $rootScope, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.group = undefined;

        // Methods
        vm.getClass = getClass;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Is active
            vm.isActive = false;

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);


            for( var f in vm.node.state ) {
                var state = vm.node.state[f];
                // Mark all parents as active if we have a matching state
                // or the current state is a child of the node's state
                if ( state === $state.current.name || $state.includes(state) ) {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) ) {
                        return;
                    }

                    $scope.$emit('msNavigation::stateMatched');

                    // Also store the current active menu item
                    msNavigationService.setActiveItem(vm.node, $scope);

                    break;
                }
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Mark as active if has children
                if ( vm.hasChildren )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
            });

            // Listen for clearActive event
            $scope.$on('msNavigation::clearActive', function ()
            {
                if ( !vm.hasChildren )
                {
                    return;
                }

                var activePathParts = [];

                var activeItem = msNavigationService.getActiveItem();
                if ( activeItem )
                {
                    activePathParts = activeItem.node._path.split('.');
                }

                // Test for active path
                if ( activePathParts.indexOf(vm.node._id) > -1 )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
                else
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = false;
                    });
                }

            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                for( var f in vm.node.state) {
                    var state = vm.node.state[f];
                    if ( state === $state.current.name ) {
                        // If state params are defined, make sure they are
                        // equal, otherwise do not set the active item
                        if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) ){
                            return;
                        }

                        // Update active item on state change
                        msNavigationService.setActiveItem(vm.node, $scope);

                        // Clear all active states everything except the one we're using
                        $rootScope.$broadcast('msNavigation::clearActive');

                        break;
                    }
                }
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }
    }

    /** @ngInject */
    function msNavigationHorizontalNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationHorizontalNode'
            },
            controller      : 'MsNavigationHorizontalNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationHorizontalNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationHorizontalNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalItemDirective($mdMedia)
    {
        return {
            restrict: 'A',
            require : '^msNavigationHorizontalNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    iElement.on('click', onClick);

                    function onClick()
                    {
                        if ( !MsNavigationHorizontalNodeCtrl.hasChildren || $mdMedia('gt-md') )
                        {
                            return;
                        }

                        iElement.toggleClass('expanded');
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msNavFoldService', msNavFoldService)
        .directive('msNavIsFolded', msNavIsFoldedDirective)
        .controller('MsNavController', MsNavController)
        .directive('msNav', msNavDirective)
        .directive('msNavTitle', msNavTitleDirective)
        .directive('msNavButton', msNavButtonDirective)
        .directive('msNavToggle', msNavToggleDirective);

    /** @ngInject */
    function msNavFoldService()
    {
        var foldable = {};

        var service = {
            setFoldable    : setFoldable,
            isNavFoldedOpen: isNavFoldedOpen,
            toggleFold     : toggleFold,
            openFolded     : openFolded,
            closeFolded    : closeFolded
        };

        return service;

        //////////

        /**
         * Set the foldable
         *
         * @param scope
         * @param element
         */
        function setFoldable(scope, element)
        {
            foldable = {
                'scope'  : scope,
                'element': element
            };
        }

        /**
         * Is folded open
         */
        function isNavFoldedOpen()
        {
            return foldable.scope.isNavFoldedOpen();
        }

        /**
         * Toggle fold
         */
        function toggleFold()
        {
            foldable.scope.toggleFold();
        }

        /**
         * Open folded navigation
         */
        function openFolded()
        {
            foldable.scope.openFolded();
        }

        /**
         * Close folded navigation
         */
        function closeFolded()
        {
            foldable.scope.closeFolded();
        }
    }

    /** @ngInject */
    function msNavIsFoldedDirective($document, $rootScope, msNavFoldService)
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement, iAttrs)
            {
                var isFolded = (iAttrs.msNavIsFolded === 'true'),
                    isFoldedOpen = false,
                    body = angular.element($document[0].body),
                    openOverlay = angular.element('<div id="ms-nav-fold-open-overlay"></div>'),
                    closeOverlay = angular.element('<div id="ms-nav-fold-close-overlay"></div>'),
                    sidenavEl = iElement.parent();

                // Initialize the service
                msNavFoldService.setFoldable(scope, iElement, isFolded);

                // Set the fold status for the first time
                if ( isFolded )
                {
                    fold();
                }
                else
                {
                    unfold();
                }

                /**
                 * Is nav folded open
                 */
                function isNavFoldedOpen()
                {
                    return isFoldedOpen;
                }

                /**
                 * Toggle fold
                 */
                function toggleFold()
                {
                    isFolded = !isFolded;

                    if ( isFolded )
                    {
                        fold();
                    }
                    else
                    {
                        unfold();
                    }
                }

                /**
                 * Fold the navigation
                 */
                function fold()
                {
                    // Add classes
                    body.addClass('ms-nav-folded');

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    // Append the openOverlay to the element
                    sidenavEl.append(openOverlay);

                    // Event listeners
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Open folded navigation
                 */
                function openFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    body.addClass('ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Remove open overlay
                    sidenavEl.find(openOverlay).remove();

                    // Append close overlay and bind its events
                    sidenavEl.parent().append(closeOverlay);
                    closeOverlay.on('mouseenter touchstart', function (event)
                    {
                        closeFolded(event);
                        isFoldedOpen = false;
                    });
                }

                /**
                 * Close folded navigation
                 */
                function closeFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    body.removeClass('ms-nav-folded-open');

                    // Remove close overlay
                    sidenavEl.parent().find(closeOverlay).remove();

                    // Append open overlay and bind its events
                    sidenavEl.append(openOverlay);
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Unfold the navigation
                 */
                function unfold()
                {
                    body.removeClass('ms-nav-folded ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    iElement.off('mouseenter mouseleave');
                }

                // Expose functions to the scope
                scope.toggleFold = toggleFold;
                scope.openFolded = openFolded;
                scope.closeFolded = closeFolded;
                scope.isNavFoldedOpen = isNavFoldedOpen;

                // Cleanup
                scope.$on('$destroy', function ()
                {
                    openOverlay.off('mouseenter touchstart');
                    closeOverlay.off('mouseenter touchstart');
                    iElement.off('mouseenter mouseleave');
                });
            }
        };
    }


    /** @ngInject */
    function MsNavController()
    {
        var vm = this,
            disabled = false,
            toggleItems = [],
            lockedItems = [];

        // Data

        // Methods
        vm.isDisabled = isDisabled;
        vm.enable = enable;
        vm.disable = disable;
        vm.setToggleItem = setToggleItem;
        vm.getLockedItems = getLockedItems;
        vm.setLockedItem = setLockedItem;
        vm.clearLockedItems = clearLockedItems;

        //////////

        /**
         * Is navigation disabled
         *
         * @returns {boolean}
         */
        function isDisabled()
        {
            return disabled;
        }

        /**
         * Disable the navigation
         */
        function disable()
        {
            disabled = true;
        }

        /**
         * Enable the navigation
         */
        function enable()
        {
            disabled = false;
        }

        /**
         * Set toggle item
         *
         * @param element
         * @param scope
         */
        function setToggleItem(element, scope)
        {
            toggleItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Get locked items
         *
         * @returns {Array}
         */
        function getLockedItems()
        {
            return lockedItems;
        }

        /**
         * Set locked item
         *
         * @param element
         * @param scope
         */
        function setLockedItem(element, scope)
        {
            lockedItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Clear locked items list
         */
        function clearLockedItems()
        {
            lockedItems = [];
        }
    }

    /** @ngInject */
    function msNavDirective($rootScope, $mdComponentRegistry, msNavFoldService)
    {
        return {
            restrict  : 'E',
            scope     : {},
            controller: 'MsNavController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-nav');

                return function postLink(scope)
                {
                    // Update toggle status according to the ui-router current state
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Update toggles on state changes
                    var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
                    {
                        $rootScope.$broadcast('msNav::expandMatchingToggles');

                        // Close navigation sidenav on stateChangeSuccess
                        $mdComponentRegistry.when('navigation').then(function (navigation)
                        {
                            navigation.close();

                            if ( msNavFoldService.isNavFoldedOpen() )
                            {
                                msNavFoldService.closeFolded();
                            }
                        });
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        stateChangeSuccessEvent();
                    })
                };
            }
        };
    }

    /** @ngInject */
    function msNavTitleDirective()
    {
        return {
            restrict: 'A',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-title');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavButtonDirective()
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-button');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavToggleDirective($rootScope, $q, $animate, $state)
    {
        return {
            restrict: 'A',
            require : '^msNav',
            scope   : true,
            compile : function (tElement, tAttrs)
            {
                tElement.addClass('ms-nav-toggle');

                // Add collapsed attr
                if ( angular.isUndefined(tAttrs.collapsed) )
                {
                    tAttrs.collapsed = true;
                }

                tElement.attr('collapsed', tAttrs.collapsed);

                return function postLink(scope, iElement, iAttrs, MsNavCtrl)
                {
                    var classes = {
                        expanded         : 'expanded',
                        expandAnimation  : 'expand-animation',
                        collapseAnimation: 'collapse-animation'
                    };

                    // Store all related states
                    var links = iElement.find('a');
                    var states = [];
                    var regExp = /\(.*\)/g;

                    angular.forEach(links, function (link)
                    {
                        var state = angular.element(link).attr('ui-sref');

                        if ( angular.isUndefined(state) )
                        {
                            return;
                        }

                        // Remove any parameter definition from the state name before storing it
                        state = state.replace(regExp, '');

                        states.push(state);
                    });

                    // Store toggle-able element and its scope in the main nav controller
                    MsNavCtrl.setToggleItem(iElement, scope);

                    // Click handler
                    iElement.children('.ms-nav-button').on('click', toggle);

                    // Toggle function
                    function toggle()
                    {
                        // If navigation is disabled, do nothing...
                        if ( MsNavCtrl.isDisabled() )
                        {
                            return;
                        }

                        // Disable the entire navigation to prevent spamming
                        MsNavCtrl.disable();

                        if ( isCollapsed() )
                        {
                            // Clear the locked items list
                            MsNavCtrl.clearLockedItems();

                            // Emit pushToLockedList event
                            scope.$emit('msNav::pushToLockedList');

                            // Collapse everything but locked items
                            $rootScope.$broadcast('msNav::collapse');

                            // Expand and then...
                            expand().then(function ()
                            {
                                // Enable the entire navigation after animations completed
                                MsNavCtrl.enable();
                            });
                        }
                        else
                        {
                            // Collapse with all children
                            scope.$broadcast('msNav::forceCollapse');
                        }
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.children('.ms-nav-button').off('click');
                    });

                    /*---------------------*/
                    /* Scope Events        */
                    /*---------------------*/

                    /**
                     * Collapse everything but locked items
                     */
                    scope.$on('msNav::collapse', function ()
                    {
                        // Only collapse toggles that are not locked
                        var lockedItems = MsNavCtrl.getLockedItems();
                        var locked = false;

                        angular.forEach(lockedItems, function (lockedItem)
                        {
                            if ( angular.equals(lockedItem.scope, scope) )
                            {
                                locked = true;
                            }
                        });

                        if ( locked )
                        {
                            return;
                        }

                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Collapse everything
                     */
                    scope.$on('msNav::forceCollapse', function ()
                    {
                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Expand toggles that match with the current states
                     */
                    scope.$on('msNav::expandMatchingToggles', function ()
                    {
                        var currentState = $state.current.name;
                        var shouldExpand = false;

                        angular.forEach(states, function (state)
                        {
                            if ( currentState === state )
                            {
                                shouldExpand = true;
                            }
                        });

                        if ( shouldExpand )
                        {
                            expand();
                        }
                        else
                        {
                            collapse();
                        }
                    });

                    /**
                     * Add toggle to the locked list
                     */
                    scope.$on('msNav::pushToLockedList', function ()
                    {
                        // Set expanded item on main nav controller
                        MsNavCtrl.setLockedItem(iElement, scope);
                    });

                    /*---------------------*/
                    /* Internal functions  */
                    /*---------------------*/

                    /**
                     * Is element collapsed
                     *
                     * @returns {bool}
                     */
                    function isCollapsed()
                    {
                        return iElement.attr('collapsed') === 'true';
                    }

                    /**
                     * Is element expanded
                     *
                     * @returns {bool}
                     */
                    function isExpanded()
                    {
                        return !isCollapsed();
                    }

                    /**
                     * Expand the toggle
                     *
                     * @returns $promise
                     */
                    function expand()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already expanded, do nothing..
                        if ( isExpanded() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', false);

                        // Grab the element to expand
                        var elementToExpand = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Move the element out of the dom flow and
                        // make it block so we can get its height
                        elementToExpand.css({
                            'position'  : 'absolute',
                            'visibility': 'hidden',
                            'display'   : 'block',
                            'height'    : 'auto'
                        });

                        // Grab the height
                        var height = elementToExpand[0].offsetHeight;

                        // Reset the style modifications
                        elementToExpand.css({
                            'position'  : '',
                            'visibility': '',
                            'display'   : '',
                            'height'    : ''
                        });

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToExpand,
                                {
                                    'display': 'block',
                                    'height' : '0px'
                                },
                                {
                                    'height': height + 'px'
                                },
                                classes.expandAnimation
                            ).then(
                                function ()
                                {
                                    // Add expanded class
                                    elementToExpand.addClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToExpand.css({'height': ''});

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }

                    /**
                     * Collapse the toggle
                     *
                     * @returns $promise
                     */
                    function collapse()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already collapsed, do nothing..
                        if ( isCollapsed() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', true);

                        // Grab the element to collapse
                        var elementToCollapse = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Grab the height
                        var height = elementToCollapse[0].offsetHeight;

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToCollapse,
                                {
                                    'height': height + 'px'
                                },
                                {
                                    'height': '0px'
                                },
                                classes.collapseAnimation
                            ).then(
                                function ()
                                {
                                    // Remove expanded class
                                    elementToCollapse.removeClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToCollapse.css({
                                        'display': '',
                                        'height' : ''
                                    });

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msMaterialColorPicker', msMaterialColorPicker);

    /** @ngInject */
    function msMaterialColorPicker($mdMenu, $mdColorPalette, fuseGenerator)
    {
        return {
            require    : 'ngModel',
            restrict   : 'E',
            scope      : {
                ngModel    : '=',
                msModelType: '@?'
            },
            templateUrl: 'app/core/directives/ms-material-color-picker/ms-material-color-picker.html',
            link       : function ($scope, element, attrs, ngModel)
            {
                // Material Color Palette
                $scope.palettes = $mdColorPalette;
                $scope.selectedPalette = false;
                $scope.selectedHues = false;

                /**
                 * ModelType: 'obj', 'class'(default)
                 * @type {string|string}
                 */
                $scope.msModelType = $scope.msModelType || 'class';

                /**
                 * Initialize / Watch model changes
                 */
                $scope.$watch('ngModel', setSelectedColor);

                /**
                 * Activate Hue Selection
                 * @param palette
                 * @param hues
                 */
                $scope.activateHueSelection = function (palette, hues)
                {
                    $scope.selectedPalette = palette;
                    $scope.selectedHues = hues;
                };

                /**
                 * Select Color
                 * @type {selectColor}
                 */
                $scope.selectColor = function (palette, hue)
                {
                    // Update Selected Color
                    updateSelectedColor(palette, hue);

                    // Update Model Value
                    updateModel();

                    // Hide The picker
                    $mdMenu.hide();
                };

                $scope.removeColor = function ()
                {

                    $scope.selectedColor = {
                        palette: '',
                        hue    : '',
                        class  : ''
                    };

                    $scope.activateHueSelection(false, false);

                    updateModel();
                };

                /**
                 * Set SelectedColor by model type
                 */
                function setSelectedColor()
                {
                    if ( !ngModel.$viewValue || ngModel.$viewValue === '' )
                    {
                        return;
                    }

                    var palette, hue;

                    // If ModelType Class
                    if ( $scope.msModelType === 'class' )
                    {
                        var color = ngModel.$viewValue.split('-');
                        if ( color.length >= 5 )
                        {
                            palette = color[1] + '-' + color[2];
                            hue = color[3];
                        }
                        else
                        {
                            palette = color[1];
                            hue = color[2];
                        }
                    }
                    // If ModelType Object
                    else if ( $scope.msModelType === 'obj' )
                    {
                        palette = ngModel.$viewValue.palette;
                        hue = ngModel.$viewValue.hue || 500;
                    }

                    // Update Selected Color
                    updateSelectedColor(palette, hue);
                }


                /**
                 * Update Selected Color
                 * @param palette
                 * @param hue
                 */
                function updateSelectedColor(palette, hue)
                {
                    $scope.selectedColor = {
                        palette     : palette,
                        hue         : hue,
                        class       : 'md-' + palette + '-' + hue + '-bg',
                        bgColorValue: fuseGenerator.rgba($scope.palettes[palette][hue].value),
                        fgColorValue: fuseGenerator.rgba($scope.palettes[palette][hue].contrast)
                    };

                    // If Model object not Equals the selectedColor update it
                    // it can be happen when the model only have pallete and hue values
                    if ( $scope.msModelType === 'obj' && !angular.equals($scope.selectedColor, ngModel.$viewValue) )
                    {
                        // Update Model Value
                        updateModel();
                    }

                    $scope.activateHueSelection(palette, $scope.palettes[palette]);
                }

                /**
                 * Update Model Value by model type
                 */
                function updateModel()
                {
                    if ( $scope.msModelType === 'class' )
                    {
                        ngModel.$setViewValue($scope.selectedColor.class);
                    }
                    else if ( $scope.msModelType === 'obj' )
                    {
                        ngModel.$setViewValue($scope.selectedColor);
                    }
                }
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsFormWizardController', MsFormWizardController)
        .directive('msFormWizard', msFormWizardDirective)
        .directive('msFormWizardForm', msFormWizardFormDirective);

    /** @ngInject */
    function MsFormWizardController()
    {
        var vm = this;

        // Data
        vm.forms = [];
        vm.selectedIndex = 0;

        // Methods
        vm.registerForm = registerForm;

        vm.previousStep = previousStep;
        vm.nextStep = nextStep;
        vm.firstStep = firstStep;
        vm.lastStep = lastStep;

        vm.totalSteps = totalSteps;
        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.currentStepInvalid = currentStepInvalid;
        vm.previousStepInvalid = previousStepInvalid;
        vm.formsIncomplete = formsIncomplete;
        vm.resetForm = resetForm;

        //////////

        /**
         * Register form
         *
         * @param form
         */
        function registerForm(form)
        {
            vm.forms.push(form);
        }

        /**
         * Go to previous step
         */
        function previousStep()
        {
            if ( isFirstStep() )
            {
                return;
            }

            vm.selectedIndex--;
        }

        /**
         * Go to next step
         */
        function nextStep()
        {
            if ( isLastStep() )
            {
                return;
            }

            vm.selectedIndex++;
        }

        /**
         * Go to first step
         */
        function firstStep()
        {
            vm.selectedIndex = 0;
        }

        /**
         * Go to last step
         */
        function lastStep()
        {
            vm.selectedIndex = totalSteps() - 1;
        }

        /**
         * Return total steps
         *
         * @returns {int}
         */
        function totalSteps()
        {
            return vm.forms.length;
        }

        /**
         * Is first step?
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.selectedIndex === 0;
        }

        /**
         * Is last step?
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.selectedIndex === totalSteps() - 1;
        }

        /**
         * Is current step invalid?
         *
         * @returns {boolean}
         */
        function currentStepInvalid()
        {
            return angular.isDefined(vm.forms[vm.selectedIndex]) && vm.forms[vm.selectedIndex].$invalid;
        }

        /**
         * Is previous step invalid?
         *
         * @returns {boolean}
         */
        function previousStepInvalid()
        {
            return vm.selectedIndex > 0 && angular.isDefined(vm.forms[vm.selectedIndex - 1]) && vm.forms[vm.selectedIndex - 1].$invalid;
        }

        /**
         * Check if there is any incomplete forms
         *
         * @returns {boolean}
         */
        function formsIncomplete()
        {
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                if ( vm.forms[x].$invalid )
                {
                    return true;
                }
            }

            return false;
        }

        /**
         * Reset form
         */
        function resetForm()
        {
            // Go back to the first step
            vm.selectedIndex = 0;

            // Make sure all the forms are back in the $pristine & $untouched status
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                vm.forms[x].$setPristine();
                vm.forms[x].$setUntouched();
            }
        }
    }

    /** @ngInject */
    function msFormWizardDirective()
    {
        return {
            restrict  : 'E',
            scope     : true,
            controller: 'MsFormWizardController as msWizard',
            compile   : function (tElement)
            {
                tElement.addClass('ms-form-wizard');

                return function postLink()
                {

                };
            }
        }

    }

    /** @ngInject */
    function msFormWizardFormDirective()
    {
        return {
            restrict: 'A',
            require : ['form', '^msFormWizard'],
            compile : function (tElement)
            {
                tElement.addClass('ms-form-wizard-form');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var formCtrl = ctrls[0],
                        MsFormWizardCtrl = ctrls[1];

                    MsFormWizardCtrl.registerForm(formCtrl);
                }
            }
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msDatepickerFixConfig', msDatepickerFixConfigProvider)
        .directive('msDatepickerFix', msDatepickerFix);

    /** @ngInject */
    function msDatepickerFixConfigProvider()
    {

        // Default configuration
        var defaultConfiguration = {
            // To view
            formatter: function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return val === '' ? val : new Date(val);
            },
            // To model
            parser   : function (val)
            {
                if ( !val )
                {
                    return '';
                }
                var offset = moment(val).utcOffset();
                var date = new Date(moment(val).add(offset, 'm'));
                return date;
            }
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            return defaultConfiguration;
        };
    }

    /** @ngInject */
    function msDatepickerFix(msDatepickerFixConfig)
    {
        return {
            require: 'ngModel',
            link   : function (scope, elem, attrs, ngModel)
            {
                ngModel.$formatters.unshift(msDatepickerFixConfig.formatter); // to view
                ngModel.$parsers.unshift(msDatepickerFixConfig.parser); // to model
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msCard', msCardDirective);

    /** @ngInject */
    function msCardDirective()
    {
        return {
            restrict: 'E',
            scope   : {
                templatePath: '=template',
                card        : '=ngModel',
                vm          : '=viewModel'
            },
            template: '<div class="ms-card-content-wrapper" ng-include="templatePath" onload="cardTemplateLoaded()"></div>',
            compile : function (tElement)
            {
                // Add class
                tElement.addClass('ms-card');

                return function postLink(scope, iElement)
                {
                    // Methods
                    scope.cardTemplateLoaded = cardTemplateLoaded;

                    //////////

                    /**
                     * Emit cardTemplateLoaded event
                     */
                    function cardTemplateLoaded()
                    {
                        scope.$emit('msCard::cardTemplateLoaded', iElement);
                    }
                };
            }
        };
    }
})();
(function () {
    'use strict';

    angular.module('app.components', [
        
        'app.components.header',
        'app.components.content',
        'app.components.texto',
        'app.components.autofocus',
        'app.components.checkstrength'

    ]);

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('fuseTheming', fuseThemingProvider);

    /** @ngInject */
    function fuseThemingProvider()
    {
        // Inject Cookies Service
        var $cookies;

        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Inject $log service
        var $log = angular.injector(['ng']).get('$log');

        var registeredPalettes,
            registeredThemes;

        // Methods
        this.setRegisteredPalettes = setRegisteredPalettes;
        this.setRegisteredThemes = setRegisteredThemes;

        //////////

        /**
         * Set registered palettes
         *
         * @param _registeredPalettes
         */
        function setRegisteredPalettes(_registeredPalettes)
        {
            registeredPalettes = _registeredPalettes;
        }

        /**
         * Set registered themes
         *
         * @param _registeredThemes
         */
        function setRegisteredThemes(_registeredThemes)
        {
            registeredThemes = _registeredThemes;
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getRegisteredPalettes: getRegisteredPalettes,
                getRegisteredThemes  : getRegisteredThemes,
                setActiveTheme       : setActiveTheme,
                setThemesList        : setThemesList,
                themes               : {
                    list  : {},
                    active: {
                        'name' : '',
                        'theme': {}
                    }
                }
            };

            return service;

            //////////

            /**
             * Get registered palettes
             *
             * @returns {*}
             */
            function getRegisteredPalettes()
            {
                return registeredPalettes;
            }

            /**
             * Get registered themes
             *
             * @returns {*}
             */
            function getRegisteredThemes()
            {
                return registeredThemes;
            }

            /**
             * Set active theme
             *
             * @param themeName
             */
            function setActiveTheme(themeName)
            {
                // If theme does not exist, fallback to the default theme
                if ( angular.isUndefined(service.themes.list[themeName]) )
                {
                    // If there is no theme called "default"...
                    if ( angular.isUndefined(service.themes.list.default) )
                    {
                        $log.error('You must have at least one theme named "default"');
                        return;
                    }

                    $log.warn('The theme "' + themeName + '" does not exist! Falling back to the "default" theme.');

                    // Otherwise set theme to default theme
                    service.themes.active.name = 'default';
                    service.themes.active.theme = service.themes.list.default;
                    $cookies.put('selectedTheme', service.themes.active.name);

                    return;
                }

                service.themes.active.name = themeName;
                service.themes.active.theme = service.themes.list[themeName];
                $cookies.put('selectedTheme', themeName);
            }

            /**
             * Set available themes list
             *
             * @param themeList
             */
            function setThemesList(themeList)
            {
                service.themes.list = themeList;
            }
        };
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($mdThemingProvider, fusePalettes, fuseThemes, fuseThemingProvider)
    {
        // Inject Cookies Service
        var $cookies;
        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Check if custom theme exist in cookies
        var customTheme = $cookies.getObject('customTheme');
        if ( customTheme )
        {
            fuseThemes['custom'] = customTheme;
        }

        $mdThemingProvider.alwaysWatchTheme(true);

        // Define custom palettes
        angular.forEach(fusePalettes, function (palette)
        {
            $mdThemingProvider.definePalette(palette.name, palette.options);
        });

        // Register custom themes
        angular.forEach(fuseThemes, function (theme, themeName)
        {
            $mdThemingProvider.theme(themeName)
                .primaryPalette(theme.primary.name, theme.primary.hues)
                .accentPalette(theme.accent.name, theme.accent.hues)
                .warnPalette(theme.warn.name, theme.warn.hues)
                .backgroundPalette(theme.background.name, theme.background.hues);
        });

        // Store generated PALETTES and THEMES objects from $mdThemingProvider
        // in our custom provider, so we can inject them into other areas
        fuseThemingProvider.setRegisteredPalettes($mdThemingProvider._PALETTES);
        fuseThemingProvider.setRegisteredThemes($mdThemingProvider._THEMES);
    }

})();
(function ()
{
    'use strict';

    var fuseThemes = {
        'default'  : {
            primary   : {
                name: 'fuse-pale-blue',
                hues: {
                    'default': '700',
                    'hue-1'  : '500',
                    'hue-2'  : '600',
                    'hue-3'  : '400'
                }
            },
            accent    : {
                name: 'light-blue',
                hues: {
                    'default': '600',
                    'hue-1'  : '400',
                    'hue-2'  : '700',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {name: 'red'},
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : '100',
                    'hue-2'  : '50',
                    'hue-3'  : '300'
                }
            }
        },
        'pink': {
            primary   : {
                name: 'blue-grey',
                hues: {
                    'default': '800',
                    'hue-1'  : '600',
                    'hue-2'  : '400',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'pink',
                hues: {
                    'default': '400',
                    'hue-1'  : '300',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {name: 'blue'},
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : '100',
                    'hue-2'  : '50',
                    'hue-3'  : '300'
                }
            }
        },
        'teal'     : {
            primary   : {
                name: 'fuse-blue',
                hues: {
                    'default': '900',
                    'hue-1'  : '600',
                    'hue-2'  : '500',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'teal',
                hues: {
                    'default': '500',
                    'hue-1'  : '400',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {name: 'deep-orange'},
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : '100',
                    'hue-2'  : '50',
                    'hue-3'  : '300'
                }
            }
        }
    };

    angular
        .module('app.core')
        .constant('fuseThemes', fuseThemes);
})();
(function () {
    'use strict';

    var fusePalettes = [
        {
            name: 'fuse-blue',
            options: {
                '50': '#ebf1fa',
                '100': '#c2d4ef',
                '200': '#9ab8e5',
                '300': '#78a0dc',
                '400': '#5688d3',
                '500': '#3470ca',
                '600': '#2e62b1',
                '700': '#275498',
                '800': '#21467e',
                '900': '#1a3865',
                'A100': '#c2d4ef',
                'A200': '#9ab8e5',
                'A400': '#5688d3',
                'A700': '#275498',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
        {
            name: 'fuse-pale-blue',
            options: {
                '50': '#ececee',
                '100': '#c5c6cb',
                '200': '#9ea1a9',
                '300': '#7d818c',
                '400': '#5c616f',
                '500': '#3c4252',
                '600': '#353a48',
                '700': '#2d323e',
                '800': '#262933',
                '900': '#1e2129',
                'A100': '#c5c6cb',
                'A200': '#9ea1a9',
                'A400': '#5c616f',
                'A700': '#2d323e',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        }
    ];

    angular
        .module('app.core')
        .constant('fusePalettes', fusePalettes);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('fuseGenerator', fuseGeneratorService);

    /** @ngInject */
    function fuseGeneratorService($cookies, $log, fuseTheming)
    {
        // Storage for simplified themes object
        var themes = {};

        var service = {
            generate: generate,
            rgba    : rgba
        };

        return service;

        //////////

        /**
         * Generate less variables for each theme from theme's
         * palette by using material color naming conventions
         */
        function generate()
        {
            var registeredThemes = fuseTheming.getRegisteredThemes();
            var registeredPalettes = fuseTheming.getRegisteredPalettes();

            // First, create a simplified object that stores
            // all registered themes and their colors

            // Iterate through registered themes
            angular.forEach(registeredThemes, function (registeredTheme)
            {
                themes[registeredTheme.name] = {};

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(registeredTheme.colors, function (colorType, colorTypeName)
                {
                    themes[registeredTheme.name][colorTypeName] = {
                        'name'  : colorType.name,
                        'levels': {
                            'default': {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues.default].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 4)
                            },
                            'hue1'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 4)
                            },
                            'hue2'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 4)
                            },
                            'hue3'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 4)
                            }
                        }
                    };
                });
            });

            // Process themes one more time and then store them in the service for external use
            processAndStoreThemes(themes);

            // Iterate through simplified themes
            // object and create style variables
            var styleVars = {};

            // Iterate through registered themes
            angular.forEach(themes, function (theme, themeName)
            {
                styleVars = {};
                styleVars['@themeName'] = themeName;

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorTypes, colorTypeName)
                {
                    // Iterate through color levels (default, hue1, hue2 & hue3)
                    angular.forEach(colorTypes.levels, function (colors, colorLevelName)
                    {
                        // Iterate through color name (color, contrast1, contrast2, contrast3 & contrast4)
                        angular.forEach(colors, function (color, colorName)
                        {
                            styleVars['@' + colorTypeName + ucfirst(colorLevelName) + ucfirst(colorName)] = color;
                        });
                    });
                });

                // Render styles
                render(styleVars);
            });
        }

        // ---------------------------
        //  INTERNAL HELPER FUNCTIONS
        // ---------------------------

        /**
         * Process and store themes for global use
         *
         * @param _themes
         */
        function processAndStoreThemes(_themes)
        {
            // Here we will go through every registered theme one more time
            // and try to simplify their objects as much as possible for
            // easier access to their properties.
            var themes = angular.copy(_themes);

            // Iterate through themes
            angular.forEach(themes, function (theme)
            {
                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorType, colorTypeName)
                {
                    theme[colorTypeName] = colorType.levels;
                    theme[colorTypeName].color = colorType.levels.default.color;
                    theme[colorTypeName].contrast1 = colorType.levels.default.contrast1;
                    theme[colorTypeName].contrast2 = colorType.levels.default.contrast2;
                    theme[colorTypeName].contrast3 = colorType.levels.default.contrast3;
                    theme[colorTypeName].contrast4 = colorType.levels.default.contrast4;
                    delete theme[colorTypeName].default;
                });
            });

            // Store themes and set selected theme for the first time
            fuseTheming.setThemesList(themes);

            // Remember selected theme.
            var selectedTheme = $cookies.get('selectedTheme');

            if ( selectedTheme )
            {
                fuseTheming.setActiveTheme(selectedTheme);
            }
            else
            {
                fuseTheming.setActiveTheme('default');
            }
        }


        /**
         * Render css files
         *
         * @param styleVars
         */
        function render(styleVars)
        {
            var cssTemplate = '[md-theme="@themeName"] a {\n    color: @accentDefaultColor;\n}\n\n[md-theme="@themeName"] .secondary-text,\n[md-theme="@themeName"] .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .hint-text,\n[md-theme="@themeName"] .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .fade-text,\n[md-theme="@themeName"] .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Primary */\n[md-theme="@themeName"] .md-primary-bg {\n    background-color: @primaryDefaultColor;\n    color: @primaryDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg .secondary-text,\n[md-theme="@themeName"] .md-primary-bg .icon {\n    color: @primaryDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg .hint-text,\n[md-theme="@themeName"] .md-primary-bg .disabled-text {\n    color: @primaryDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg .fade-text,\n[md-theme="@themeName"] .md-primary-bg .divider {\n    color: @primaryDefaultContrast4;\n}\n\n/* Primary, Hue-1 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 {\n    background-color: @primaryHue1Color;\n    color: @primaryHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .icon {\n    color: @primaryHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .disabled-text {\n    color: @primaryHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .divider {\n    color: @primaryHue1Contrast4;\n}\n\n/* Primary, Hue-2 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 {\n    background-color: @primaryHue2Color;\n    color: @primaryHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .icon {\n    color: @primaryHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .disabled-text {\n    color: @primaryHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .divider {\n    color: @primaryHue2Contrast4;\n}\n\n/* Primary, Hue-3 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 {\n    background-color: @primaryHue3Color;\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .icon {\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .disabled-text {\n    color: @primaryHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .divider {\n    color: @primaryHue3Contrast4;\n}\n\n/* Primary foreground */\n[md-theme="@themeName"] .md-primary-fg {\n    color: @primaryDefaultColor !important;\n}\n\n/* Primary foreground, Hue-1 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-1 {\n    color: @primaryHue1Color !important;\n}\n\n/* Primary foreground, Hue-2 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-2 {\n    color: @primaryHue2Color !important;\n}\n\n/* Primary foreground, Hue-3 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-3 {\n    color: @primaryHue3Color !important;\n}\n\n\n/* Accent */\n[md-theme="@themeName"] .md-accent-bg {\n    background-color: @accentDefaultColor;\n    color: @accentDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg .secondary-text,\n[md-theme="@themeName"] .md-accent-bg .icon {\n    color: @accentDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg .hint-text,\n[md-theme="@themeName"] .md-accent-bg .disabled-text {\n    color: @accentDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg .fade-text,\n[md-theme="@themeName"] .md-accent-bg .divider {\n    color: @accentDefaultContrast4;\n}\n\n/* Accent, Hue-1 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 {\n    background-color: @accentHue1Color;\n    color: @accentHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .icon {\n    color: @accentHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .disabled-text {\n    color: @accentHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .divider {\n    color: @accentHue1Contrast4;\n}\n\n/* Accent, Hue-2 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 {\n    background-color: @accentHue2Color;\n    color: @accentHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .icon {\n    color: @accentHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .disabled-text {\n    color: @accentHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .divider {\n    color: @accentHue2Contrast4;\n}\n\n/* Accent, Hue-3 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 {\n    background-color: @accentHue3Color;\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .icon {\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .disabled-text {\n    color: @accentHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .divider {\n    color: @accentHue3Contrast4;\n}\n\n/* Accent foreground */\n[md-theme="@themeName"] .md-accent-fg {\n    color: @accentDefaultColor !important;\n}\n\n/* Accent foreground, Hue-1 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-1 {\n    color: @accentHue1Color !important;\n}\n\n/* Accent foreground, Hue-2 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-2 {\n    color: @accentHue2Color !important;\n}\n\n/* Accent foreground, Hue-3 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-3 {\n    color: @accentHue3Color !important;\n}\n\n\n/* Warn */\n[md-theme="@themeName"] .md-warn-bg {\n    background-color: @warnDefaultColor;\n    color: @warnDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg .secondary-text,\n[md-theme="@themeName"] .md-warn-bg .icon {\n    color: @warnDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg .hint-text,\n[md-theme="@themeName"] .md-warn-bg .disabled-text {\n    color: @warnDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg .fade-text,\n[md-theme="@themeName"] .md-warn-bg .divider {\n    color: @warnDefaultContrast4;\n}\n\n/* Warn, Hue-1 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 {\n    background-color: @warnHue1Color;\n    color: @warnHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .icon {\n    color: @warnHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .disabled-text {\n    color: @warnHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .divider {\n    color: @warnHue1Contrast4;\n}\n\n/* Warn, Hue-2 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 {\n    background-color: @warnHue2Color;\n    color: @warnHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .icon {\n    color: @warnHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .disabled-text {\n    color: @warnHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .divider {\n    color: @warnHue2Contrast4;\n}\n\n/* Warn, Hue-3 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 {\n    background-color: @warnHue3Color;\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .icon {\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .disabled-text {\n    color: @warnHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .divider {\n    color: @warnHue3Contrast4;\n}\n\n/* Warn foreground */\n[md-theme="@themeName"] .md-warn-fg {\n    color: @warnDefaultColor !important;\n}\n\n/* Warn foreground, Hue-1 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-1 {\n    color: @warnHue1Color !important;\n}\n\n/* Warn foreground, Hue-2 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-2 {\n    color: @warnHue2Color !important;\n}\n\n/* Warn foreground, Hue-3 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-3 {\n    color: @warnHue3Color !important;\n}\n\n/* Background */\n[md-theme="@themeName"] .md-background-bg {\n    background-color: @backgroundDefaultColor;\n    color: @backgroundDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg .secondary-text,\n[md-theme="@themeName"] .md-background-bg .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg .hint-text,\n[md-theme="@themeName"] .md-background-bg .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg .fade-text,\n[md-theme="@themeName"] .md-background-bg .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Background, Hue-1 */\n[md-theme="@themeName"] .md-background-bg.md-hue-1 {\n    background-color: @backgroundHue1Color;\n    color: @backgroundHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .icon {\n    color: @backgroundHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .disabled-text {\n    color: @backgroundHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .divider {\n    color: @backgroundHue1Contrast4;\n}\n\n/* Background, Hue-2 */\n[md-theme="@themeName"] .md-background-bg.md-hue-2 {\n    background-color: @backgroundHue2Color;\n    color: @backgroundHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .icon {\n    color: @backgroundHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .disabled-text {\n    color: @backgroundHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .divider {\n    color: @backgroundHue2Contrast4;\n}\n\n/* Background, Hue-3 */\n[md-theme="@themeName"] .md-background-bg.md-hue-3 {\n    background-color: @backgroundHue3Color;\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .icon {\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .disabled-text {\n    color: @backgroundHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .divider {\n    color: @backgroundHue3Contrast4;\n}\n\n/* Background foreground */\n[md-theme="@themeName"] .md-background-fg {\n    color: @backgroundDefaultColor !important;\n}\n\n/* Background foreground, Hue-1 */\n[md-theme="@themeName"] .md-background-fg.md-hue-1 {\n    color: @backgroundHue1Color !important;\n}\n\n/* Background foreground, Hue-2 */\n[md-theme="@themeName"] .md-background-fg.md-hue-2 {\n    color: @backgroundHue2Color !important;\n}\n\n/* Background foreground, Hue-3 */\n[md-theme="@themeName"] .md-background-fg.md-hue-3 {\n    color: @backgroundHue3Color !important;\n}';

            var regex = new RegExp(Object.keys(styleVars).join('|'), 'gi');
            var css = cssTemplate.replace(regex, function (matched)
            {
                return styleVars[matched];
            });

            var headEl = angular.element('head');
            var styleEl = angular.element('<style type="text/css"></style>');
            styleEl.html(css);
            headEl.append(styleEl);
        }

        /**
         * Convert color array to rgb/rgba
         * Also apply contrasts if needed
         *
         * @param color
         * @param _contrastLevel
         * @returns {string}
         */
        function rgba(color, _contrastLevel)
        {
            var contrastLevel = _contrastLevel || false;

            // Convert 255,255,255,0.XX to 255,255,255
            // According to Google's Material design specs, white primary
            // text must have opacity of 1 and we will fix that here
            // because Angular Material doesn't care about that spec
            if ( color.length === 4 && color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color.splice(3, 4);
            }

            // If contrast level provided, apply it to the current color
            if ( contrastLevel )
            {
                color = applyContrast(color, contrastLevel);
            }

            // Convert color array to color string (rgb/rgba)
            if ( color.length === 3 )
            {
                return 'rgb(' + color.join(',') + ')';
            }
            else if ( color.length === 4 )
            {
                return 'rgba(' + color.join(',') + ')';
            }
            else
            {
                $log.error('Invalid number of arguments supplied in the color array: ' + color.length + '\n' + 'The array must have 3 or 4 colors.');
            }
        }

        /**
         * Apply given contrast level to the given color
         *
         * @param color
         * @param contrastLevel
         */
        function applyContrast(color, contrastLevel)
        {
            var contrastLevels = {
                'white': {
                    '1': '1',
                    '2': '0.7',
                    '3': '0.3',
                    '4': '0.12'
                },
                'black': {
                    '1': '0.87',
                    '2': '0.54',
                    '3': '0.26',
                    '4': '0.12'
                }
            };

            // If white
            if ( color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color[3] = contrastLevels.white[contrastLevel];
            }
            // If black
            else if ( color[0] === 0 && color[1] === 0, color[2] === 0 )
            {
                color[3] = contrastLevels.black[contrastLevel];
            }

            return color;
        }

        /**
         * Uppercase first
         */
        function ucfirst(string)
        {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsThemeOptionsController', MsThemeOptionsController)
        .directive('msThemeOptions', msThemeOptions);

    /** @ngInject */
    function MsThemeOptionsController($cookies, fuseTheming)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;
        vm.layoutMode = 'wide';
        vm.layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

        // Methods
        vm.setActiveTheme = setActiveTheme;
        vm.updateLayoutMode = updateLayoutMode;
        vm.updateLayoutStyle = updateLayoutStyle;

        //////////

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            // Set active theme
            fuseTheming.setActiveTheme(themeName);
        }

        /**
         * Update layout mode
         */
        function updateLayoutMode()
        {
            var bodyEl = angular.element('body');

            // Update class on body element
            bodyEl.toggleClass('boxed', (vm.layoutMode === 'boxed'));
        }

        /**
         * Update layout style
         */
        function updateLayoutStyle()
        {
            // Update the cookie
            $cookies.put('layoutStyle', vm.layoutStyle);

            // Reload the page to apply the changes
            location.reload();
        }
    }

    /** @ngInject */
    function msThemeOptions()
    {
        return {
            restrict   : 'E',
            scope      : {
                panelOpen: '=?'
            },
            controller : 'MsThemeOptionsController as vm',
            templateUrl: 'app/core/theme-options/theme-options.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-theme-options');

                return function postLink(scope, iElement)
                {
                    var bodyEl = angular.element('body'),
                        backdropEl = angular.element('<div class="ms-theme-options-backdrop"></div>');

                    // Panel open status
                    scope.panelOpen = scope.panelOpen || false;

                    /**
                     * Toggle options panel
                     */
                    function toggleOptionsPanel()
                    {
                        if ( scope.panelOpen )
                        {
                            closeOptionsPanel();
                        }
                        else
                        {
                            openOptionsPanel();
                        }
                    }

                    function openOptionsPanel()
                    {
                        // Set panelOpen status
                        scope.panelOpen = true;

                        // Add open class
                        iElement.addClass('open');

                        // Append the backdrop
                        bodyEl.append(backdropEl);

                        // Register the event
                        backdropEl.on('click touch', closeOptionsPanel);
                    }

                    /**
                     * Close options panel
                     */
                    function closeOptionsPanel()
                    {
                        // Set panelOpen status
                        scope.panelOpen = false;

                        // Remove open class
                        iElement.removeClass('open');

                        // De-register the event
                        backdropEl.off('click touch', closeOptionsPanel);

                        // Remove the backdrop
                        backdropEl.remove();
                    }

                    // Expose the toggle function
                    scope.toggleOptionsPanel = toggleOptionsPanel;
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msUtils', msUtils);

    /** @ngInject */
    function msUtils($window)
    {
        // Private variables
        var mobileDetect = new MobileDetect($window.navigator.userAgent),
            browserInfo = null;

        var service = {
            exists       : exists,
            detectBrowser: detectBrowser,
            guidGenerator: guidGenerator,
            isMobile     : isMobile,
            toggleInArray: toggleInArray
        };

        return service;

        //////////

        /**
         * Check if item exists in a list
         *
         * @param item
         * @param list
         * @returns {boolean}
         */
        function exists(item, list)
        {
            return list.indexOf(item) > -1;
        }

        /**
         * Returns browser information
         * from user agent data
         *
         * Found at http://www.quirksmode.org/js/detect.html
         * but modified and updated to fit for our needs
         */
        function detectBrowser()
        {
            // If we already tested, do not test again
            if ( browserInfo )
            {
                return browserInfo;
            }

            var browserData = [
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Edge',
                    versionSearch: 'Edge',
                    identity     : 'Edge'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Chrome',
                    identity : 'Chrome'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'OmniWeb',
                    versionSearch: 'OmniWeb/',
                    identity     : 'OmniWeb'
                },
                {
                    string       : $window.navigator.vendor,
                    subString    : 'Apple',
                    versionSearch: 'Version',
                    identity     : 'Safari'
                },
                {
                    prop    : $window.opera,
                    identity: 'Opera'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'iCab',
                    identity : 'iCab'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'KDE',
                    identity : 'Konqueror'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Firefox',
                    identity : 'Firefox'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'Camino',
                    identity : 'Camino'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Netscape',
                    identity : 'Netscape'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'MSIE',
                    identity     : 'Explorer',
                    versionSearch: 'MSIE'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Trident/7',
                    identity     : 'Explorer',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Gecko',
                    identity     : 'Mozilla',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Mozilla',
                    identity     : 'Netscape',
                    versionSearch: 'Mozilla'
                }
            ];

            var osData = [
                {
                    string   : $window.navigator.platform,
                    subString: 'Win',
                    identity : 'Windows'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Mac',
                    identity : 'Mac'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Linux',
                    identity : 'Linux'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPhone',
                    identity : 'iPhone'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPod',
                    identity : 'iPod'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPad',
                    identity : 'iPad'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Android',
                    identity : 'Android'
                }
            ];

            var versionSearchString = '';

            function searchString(data)
            {
                for ( var i = 0; i < data.length; i++ )
                {
                    var dataString = data[i].string;
                    var dataProp = data[i].prop;

                    versionSearchString = data[i].versionSearch || data[i].identity;

                    if ( dataString )
                    {
                        if ( dataString.indexOf(data[i].subString) !== -1 )
                        {
                            return data[i].identity;

                        }
                    }
                    else if ( dataProp )
                    {
                        return data[i].identity;
                    }
                }
            }

            function searchVersion(dataString)
            {
                var index = dataString.indexOf(versionSearchString);

                if ( index === -1 )
                {
                    return;
                }

                return parseInt(dataString.substring(index + versionSearchString.length + 1));
            }

            var browser = searchString(browserData) || 'unknown-browser';
            var version = searchVersion($window.navigator.userAgent) || searchVersion($window.navigator.appVersion) || 'unknown-version';
            var os = searchString(osData) || 'unknown-os';

            // Prepare and store the object
            browser = browser.toLowerCase();
            version = browser + '-' + version;
            os = os.toLowerCase();

            browserInfo = {
                browser: browser,
                version: version,
                os     : os
            };

            return browserInfo;
        }

        /**
         * Generates a globally unique id
         *
         * @returns {*}
         */
        function guidGenerator()
        {
            var S4 = function ()
            {
                return (((1 + Math.random()) * 0x10000) || 0).toString(16).substring(1);
            };
            return (S4() + S4() + S4() + S4() + S4() + S4());
        }

        /**
         * Return if current device is a
         * mobile device or not
         */
        function isMobile()
        {
            return mobileDetect.mobile();
        }

        /**
         * Toggle in array (push or splice)
         *
         * @param item
         * @param array
         */
        function toggleInArray(item, array)
        {
            if ( array.indexOf(item) === -1 )
            {
                array.push(item);
            }
            else
            {
                array.splice(array.indexOf(item), 1);
            }
        }
    }
}());
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msApi', msApiProvider);

    /** @ngInject **/
    function msApiProvider()
    {
        /* ----------------- */
        /* Provider          */
        /* ----------------- */
        var provider = this;

        // Inject required services
        var $log = angular.injector(['ng']).get('$log'),
            $resource = angular.injector(['ngResource']).get('$resource');

        // Data
        var baseUrl = '';
        var api = [];

        // Methods
        provider.setBaseUrl = setBaseUrl;
        provider.getBaseUrl = getBaseUrl;
        provider.getApiObject = getApiObject;
        provider.register = register;

        //////////

        /**
         * Set base url for API endpoints
         *
         * @param url {string}
         */
        function setBaseUrl(url)
        {
            baseUrl = url;
        }

        /**
         * Return the base url
         *
         * @returns {string}
         */
        function getBaseUrl()
        {
            return baseUrl;
        }

        /**
         * Return the api object
         *
         * @returns {object}
         */
        function getApiObject()
        {
            return api;
        }

        /**
         * Register API endpoint
         *
         * @param key
         * @param resource
         */
        function register(key, resource)
        {
            if ( !angular.isString(key) )
            {
                $log.error('"path" must be a string (eg. `dashboard.project`)');
                return;
            }

            if ( !angular.isArray(resource) )
            {
                $log.error('"resource" must be an array and it must follow $resource definition');
                return;
            }

            // Prepare the resource object
            var resourceObj = {
                url          : baseUrl + (resource[0] || ''),
                paramDefaults: resource[1] || [],
                actions      : resource[2] || [],
                options      : resource[3] || {}
            };

            // Assign the resource
            api[key] = $resource(resourceObj.url, resourceObj.paramDefaults, resourceObj.actions, resourceObj.options);
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */
        this.$get = function ($q, $log)
        {
            // Data

            // Methods
            var service = {
                setBaseUrl: setBaseUrl,
                getBaseUrl: getBaseUrl,
                register  : register,
                resolve   : resolve,
                request   : request
            };

            return service;

            //////////

            /**
             * Resolve an API endpoint
             *
             * @param action {string}
             * @param parameters {object}
             * @returns {promise|boolean}
             */
            function resolve(action, parameters)
            {
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    apiObject[method](params,

                        // Success
                        function (response)
                        {
                            deferred.resolve(response);
                        },

                        // Error
                        function (response)
                        {
                            deferred.reject(response);
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }

            /**
             * Make a request to an API endpoint
             *
             * @param action {string}
             * @param [parameters] {object}
             * @param [success] {function}
             * @param [error] {function}
             *
             * @returns {promise|boolean}
             */
            function request(action, parameters, success, error)
            {
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    apiObject[method](params,

                        // SUCCESS
                        function (response)
                        {
                            // Resolve the promise
                            deferred.resolve(response);

                            // Call the success function if there is one
                            if ( angular.isDefined(success) && angular.isFunction(success) )
                            {
                                success(response);
                            }
                        },

                        // ERROR
                        function (response)
                        {
                            // Reject the promise
                            deferred.reject(response);

                            // Call the error function if there is one
                            if ( angular.isDefined(error) && angular.isFunction(error) )
                            {
                                error(response);
                            }
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('downloadService', downloadService);

    /** @ngInject */
    function downloadService($q, $log, api)
    {
        var service = {
            download: download
        };

        return service;

        //////////
        /**
         * Download file
         * @param action
         * @param parameters
         */
        function download(fileName, content)
        {
            saveByteArray(fileName, base64ToArrayBuffer(content));
        }
        
        /**
         * Transforma base64 em bytes;
         */
        function base64ToArrayBuffer(base64) {
            var binaryString =  window.atob(base64);
            var binaryLen = binaryString.length;
            var bytes = new Uint8Array(binaryLen);
            for (var i = 0; i < binaryLen; i++)        {
                var ascii = binaryString.charCodeAt(i);
                bytes[i] = ascii;
            }
            return bytes;
        }

        /**
         * Realiza o download do array de bytes passado.
         */
        function saveByteArray(fileName, byte) {
            var timeNow = new Date();
            var month = timeNow.getMonth() + 1;

            var blob = new Blob([byte], {type: getType(fileName)});
            
            var link = document.createElement('a');
            var url = window.URL.createObjectURL(blob);
            link.href = url; 
            link.download = fileName;
            
            document.body.appendChild(link);
            
            link.click();
            
            setTimeout(function() {
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            }, 0);
        }
        
        /**
         * Retorna o mimetype conforme o tipo do arquivo (pdf ou xlsx)
         */
        function getType(fileName) {
            var type = fileName.substring(fileName.lastIndexOf('.') + 1);
            if (type === 'pdf') {
                return 'application/pdf';
            }
            if (type === 'xlsx') {
                return 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
            }
            
            return "octet/stream";
        }

    }
    
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('apiResolver', apiResolverService);

    /** @ngInject */
    function apiResolverService($q, $log, api)
    {
        var service = {
            resolve: resolve
        };

        return service;

        //////////
        /**
         * Resolve api
         * @param action
         * @param parameters
         */
        function resolve(action, parameters)
        {
            var actionParts = action.split('@'),
                resource = actionParts[0],
                method = actionParts[1],
                params = parameters || {};

            if ( !resource || !method )
            {
                $log.error('apiResolver.resolve requires correct action parameter (ResourceName@methodName)');
                return false;
            }

            // Create a new deferred object
            var deferred = $q.defer();

            // Get the correct api object from api service
            var apiObject = getApiObject(resource);

            if ( !apiObject )
            {
                $log.error('Resource "' + resource + '" is not defined in the api service!');
                deferred.reject('Resource "' + resource + '" is not defined in the api service!');
            }
            else
            {
                apiObject[method](params,

                    // Success
                    function (response)
                    {
                        deferred.resolve(response);
                    },

                    // Error
                    function (response)
                    {
                        deferred.reject(response);
                    }
                );
            }

            // Return the promise
            return deferred.promise;
        }

        /**
         * Get correct api object
         *
         * @param resource
         * @returns {*}
         */
        function getApiObject(resource)
        {
            // Split the resource in case if we have a dot notated object
            var resourceParts = resource.split('.'),
                apiObject = api;

            // Loop through the resource parts and go all the way through
            // the api object and return the correct one
            for ( var l = 0; l < resourceParts.length; l++ )
            {
                if ( angular.isUndefined(apiObject[resourceParts[l]]) )
                {
                    $log.error('Resource part "' + resourceParts[l] + '" is not defined!');
                    apiObject = false;
                    break;
                }

                apiObject = apiObject[resourceParts[l]];
            }

            if ( !apiObject )
            {
                return false;
            }

            return apiObject;
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByTags', filterByTags)
        .filter('filterSingleByTags', filterSingleByTags);

    /** @ngInject */
    function filterByTags()
    {
        return function (items, tags)
        {
            if ( items.length === 0 || tags.length === 0 )
            {
                return items;
            }

            var filtered = [];

            items.forEach(function (item)
            {
                var match = tags.every(function (tag)
                {
                    var tagExists = false;

                    item.tags.forEach(function (itemTag)
                    {
                        if ( itemTag.name === tag.name )
                        {
                            tagExists = true;
                            return;
                        }
                    });

                    return tagExists;
                });

                if ( match )
                {
                    filtered.push(item);
                }
            });

            return filtered;
        };
    }

    /** @ngInject */
    function filterSingleByTags()
    {
        return function (itemTags, tags)
        {
            if ( itemTags.length === 0 || tags.length === 0 )
            {
                return;
            }

            if ( itemTags.length < tags.length )
            {
                return [];
            }

            var filtered = [];

            var match = tags.every(function (tag)
            {
                var tagExists = false;

                itemTags.forEach(function (itemTag)
                {
                    if ( itemTag.name === tag.name )
                    {
                        tagExists = true;
                        return;
                    }
                });

                return tagExists;
            });

            if ( match )
            {
                filtered.push(itemTags);
            }

            return filtered;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('toTrusted', toTrustedFilter)
        .filter('htmlToPlaintext', htmlToPlainTextFilter)
        .filter('nospace', nospaceFilter)
        .filter('humanizeDoc', humanizeDocFilter);

    /** @ngInject */
    function toTrustedFilter($sce)
    {
        return function (value)
        {
            return $sce.trustAsHtml(value);
        };
    }

    /** @ngInject */
    function htmlToPlainTextFilter()
    {
        return function (text)
        {
            return String(text).replace(/<[^>]+>/gm, '');
        };
    }

    /** @ngInject */
    function nospaceFilter()
    {
        return function (value)
        {
            return (!value) ? '' : value.replace(/ /g, '');
        };
    }

    /** @ngInject */
    function humanizeDocFilter()
    {
        return function (doc)
        {
            if ( !doc )
            {
                return;
            }
            if ( doc.type === 'directive' )
            {
                return doc.name.replace(/([A-Z])/g, function ($1)
                {
                    return '-' + $1.toLowerCase();
                });
            }
            return doc.label || doc.name;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('hljs', hljsDirective);

    /** @ngInject */
    function hljsDirective($timeout, $q, $interpolate)
    {
        return {
            restrict: 'EA',
            compile : function (tElement, tAttrs)
            {
                var code;
                //No attribute? code is the content
                if ( !tAttrs.code )
                {
                    code = tElement.html();
                    tElement.empty();
                }

                return function (scope, iElement, iAttrs)
                {
                    if ( iAttrs.code )
                    {
                        // Attribute? code is the evaluation
                        code = scope.$eval(iAttrs.code);
                    }
                    var shouldInterpolate = scope.$eval(iAttrs.shouldInterpolate);

                    $q.when(code).then(function (code)
                    {
                        if ( code )
                        {
                            if ( shouldInterpolate )
                            {
                                code = $interpolate(code)(scope);
                            }

                            var contentParent = angular.element(
                                '<pre><code class="highlight" ng-non-bindable></code></pre>'
                            );

                            iElement.append(contentParent);

                            // Defer highlighting 1-frame to prevent GA interference...
                            $timeout(function ()
                            {
                                render(code, contentParent);
                            }, 34, false);
                        }
                    });

                    function render(contents, parent)
                    {
                        var codeElement = parent.find('code');
                        var lines = contents.split('\n');

                        // Remove empty lines
                        lines = lines.filter(function (line)
                        {
                            return line.trim().length;
                        });

                        // Make it so each line starts at 0 whitespace
                        var firstLineWhitespace = lines[0].match(/^\s*/)[0];
                        var startingWhitespaceRegex = new RegExp('^' + firstLineWhitespace);

                        lines = lines.map(function (line)
                        {
                            return line
                                .replace(startingWhitespaceRegex, '')
                                .replace(/\s+$/, '');
                        });

                        var highlightedCode = hljs.highlight(iAttrs.language || iAttrs.lang, lines.join('\n'), true);
                        highlightedCode.value = highlightedCode.value
                            .replace(/=<span class="hljs-value">""<\/span>/gi, '')
                            .replace('<head>', '')
                            .replace('<head/>', '');
                        codeElement.append(highlightedCode.value).addClass('highlight');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('fuseConfig', fuseConfigProvider);

    /** @ngInject */
    function fuseConfigProvider()
    {
        // Default configuration
        var fuseConfiguration = {
            'disableCustomScrollbars'        : false,
            'disableMdInkRippleOnMobile'     : true,
            'disableCustomScrollbarsOnMobile': true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            fuseConfiguration = angular.extend({}, fuseConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig,
                setConfig: setConfig
            };

            return service;

            //////////

            /**
             * Returns a config value
             */
            function getConfig(configName)
            {
                if ( angular.isUndefined(fuseConfiguration[configName]) )
                {
                    return false;
                }

                return fuseConfiguration[configName];
            }

            /**
             * Creates or updates config object
             *
             * @param configName
             * @param configValue
             */
            function setConfig(configName, configValue)
            {
                fuseConfiguration[configName] = configValue;
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.util', []);
})();

(function ()
{
    'use strict';

    angular
        .module('app.util')
        .factory('util', utilService);

    /** @ngInject */
    function utilService()
    {
      var vm = {};

      vm.buildFormUrlencodedParams = function(data)
      {
          var params = '';

          for (var key in data) {
              params += key + '=' + data[key] + '&';
          }

          return params.substring(0, params.length - 1);
      };

      return vm;

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.toolbar', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider)
    {
        $translatePartialLoaderProvider.addPart('app/toolbar');
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.toolbar')
        .controller('ToolbarController', ToolbarController);

    /** @ngInject */
    function ToolbarController($rootScope, $mdSidenav, $translate, $mdToast, $state, api)
    {
        var vm = this;

        // Data
        $rootScope.global = {
            search: ''
        };

        vm.bodyEl = angular.element('body');

        // Methods
        vm.toggleSidenav = toggleSidenav;
        vm.logout = logout;
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Logout Function
         */
        function logout()
        {
            $state.go('app.login');
            api.removeAccessToken();
            api.removeRefreshToken();
            localStorage.removeItem('perfilamento');
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            vm.bodyEl.toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('QuickPanelController', QuickPanelController);

    /** @ngInject */
    function QuickPanelController(msApi)
    {
        var vm = this;

        // Data
        vm.date = new Date();
        vm.settings = {
            notify: true,
            cloud : false,
            retro : true
        };

        msApi.request('quickPanel.activities@get', {},
            // Success
            function (response)
            {
                vm.activities = response.data;
            }
        );

        msApi.request('quickPanel.events@get', {},
            // Success
            function (response)
            {
                vm.events = response.data;
            }
        );

        msApi.request('quickPanel.notes@get', {},
            // Success
            function (response)
            {
                vm.notes = response.data;
            }
        );

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation', [])
        .config(config);

    /** @ngInject */
    function config() {
        
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation')
        .controller('NavigationController', NavigationController);

    /** @ngInject */
    function NavigationController($scope)
    {
        var vm = this;

        // Data
        vm.bodyEl = angular.element('body');
        vm.folded = false;
        vm.msScrollOptions = {
            suppressScrollX: true
        };

        // Methods
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;

        //////////

        /**
         * Toggle folded status
         */
        function toggleMsNavigationFolded()
        {
            vm.folded = !vm.folded;
        }

        // Close the mobile menu on $stateChangeSuccess
        $scope.$on('$stateChangeSuccess', function ()
        {
            vm.bodyEl.removeClass('ms-navigation-horizontal-mobile-menu-active');
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.main.util', [])
        .factory('Util', UtilFactory);

    UtilFactory.$inject = [
        '$mdToast'
    ];
        
    function UtilFactory( $mdToast ) {
        var vm = {
            showToastMessage: showToastMessageFn,
            formatDate: formatDateFn
        };

        return vm;

        //---

        function showToastMessageFn(message) {
            var toast = $mdToast
                .simple()
                .textContent(message)
                .position('bottom right');

            $mdToast.show(toast);
        }

        //---

        function formatDateFn(date) {
            if (!date || isNaN(date.getTime())) {
                return null;
            }

            return date.getFullYear() 
                + '-' + fill(date.getMonth() + 1) 
                + '-' + fill(date.getDate());
        }

        function fill(value) {
            if (value < 10) {
                return '0' + value;
            }
            return value.toString();
        }

    }

    //---



    angular
        .module('app.main.util')
        .filter('monetario', MonetarioFilter);

        function MonetarioFilter() {

            return function(input) {
                var valor = input.toFixed(2).split('.');

                var output = '';
                var count = 0;

                for(var i = valor[0].length - 1; i >= 0 ; i--) {
                    count++;

                    output += valor[0][i];

                    if( count == 3 ) {
                        count = 0;

                        if( (i - 1) >= 0 ) {
                            output += '.';
                        }
                    }
                }

                return output.split('').reverse().join('') + ',' + valor[1];
            }
        }
})();
(function ()
{
    'use strict';

    angular
        .module('app.main', [

            'app.main.util',
            'app.components',
            'app.pages',
            'app.main.auth'

    	]);

})();

(function ()
{
    'use strict';

    angular
        .module('app.main')
        .controller('MainController', MainController);

    /** @ngInject */
    function MainController($scope, $rootScope)
    {
        // Data

        //////////

        // Remove the splash screen
        $scope.$on('$viewContentAnimationEnded', function (event)
        {
            if ( event.targetScope.$id === $scope.$id )
            {
                $rootScope.$broadcast('msSplashScreen::remove');
            }
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .run(runBlock);

    /** @ngInject */
    function runBlock(msUtils, fuseGenerator, fuseConfig, $rootScope) {

        /**
         * Generate extra classes based on registered themes so we
         * can use same colors with non-angular-material elements
         */
        fuseGenerator.generate();

        /**
         * Disable md-ink-ripple effects on mobile
         * if 'disableMdInkRippleOnMobile' config enabled
         */
        if ( fuseConfig.getConfig('disableMdInkRippleOnMobile') && msUtils.isMobile() )
        {
            var bodyEl = angular.element('body');
            bodyEl.attr('md-no-ink', true);
        }

        /**
         * Put isMobile() to the html as a class
         */
        if ( msUtils.isMobile() )
        {
            angular.element('html').addClass('is-mobile');
        }

        /**
         * Put browser information to the html as a class
         */
        var browserInfo = msUtils.detectBrowser();
        if ( browserInfo )
        {
            var htmlClass = browserInfo.browser + ' ' + browserInfo.version + ' ' + browserInfo.os;
            angular.element('html').addClass(htmlClass);
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($mdThemingProvider, $mdDateLocaleProvider, $ariaProvider, $logProvider, msScrollConfigProvider, $translateProvider, fuseConfigProvider) {
        // Enable debug logging
        $logProvider.debugEnabled(true);

        $mdDateLocaleProvider.formatDate = function(date) {
            return moment(date).format('DD/MM/YYYY');
        };
        
        $mdDateLocaleProvider.parseDate = function(dateString) {
            var m = moment(dateString, 'DD/MM/YYYY', true);
            return m.isValid() ? m.toDate() : new Date(NaN);
        };

        $mdDateLocaleProvider.months = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'];
        $mdDateLocaleProvider.shortMonths = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'];
        $mdDateLocaleProvider.days = ['Domingo', 'Segunda - Feira', 'Terça - Feira', 'Quarta - Feira', 'Quinta - Feira', 'Sexta - Feira', 'Sábado' ];
        $mdDateLocaleProvider.shortDays = ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'];

        // toastr configuration
        toastr.options.timeOut = 3000;
        toastr.options.positionClass = 'toast-top-right';
        toastr.options.preventDuplicates = true;
        toastr.options.progressBar = true;

        // angular-translate configuration
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: '{part}/i18n/{lang}.json'
        });
        $translateProvider.preferredLanguage('en');
        $translateProvider.useSanitizeValueStrategy('sanitize');

        // var defaultTheme = $mdThemingProvider.extendPalette('default', {
        //     '700': '00B0DB',
        //    '50': '#ececee',
        //         '100': '#c5c6cb',
        //         '200': '#9ea1a9',
        //         '300': '#7d818c',
        //         '400': '#5c616f',
        //         '500': '#3c4252',
        //         '600': '#353a48',
        //         // '700': '#2d323e',
        //         '800': '#262933',
        //         '900': '#1e2129',
        //         'A100': '#c5c6cb',
        //         'A200': '#9ea1a9',
        //         'A400': '#5c616f',
        //         'A700': '#2d323e',
        //         'contrastDefaultColor': 'light',
        //         'contrastDarkColors': '50 100 200 A100',
        //         'contrastStrongLightColors': '300 400'
        // });
        
        // $mdThemingProvider.definePalette('defaultTheme', defaultTheme);
        // $mdThemingProvider.theme('default').primaryPalette('defaultTheme');

        // $mdThemingProvider.setDefaultTheme('default');
        
        
        /*eslint-disable */

        // ng-aria configuration
        $ariaProvider.config({
            tabindex: false
        });

        // Fuse theme configurations
        fuseConfigProvider.config({
            'disableCustomScrollbars'        : false,
            'disableCustomScrollbarsOnMobile': true,
            'disableMdInkRippleOnMobile'     : true
        });

        // msScroll configuration
        msScrollConfigProvider.config({
            wheelPropagation: true
        });

        /*eslint-enable */
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.api', []);

})();

(function ()
{
	'use strict';

	angular
		.module('app.api')
		.factory('api', apiService);

	/** @ngInject */
	function apiService($cookies, $location, LOGIN_PAGE_PATH) {
		// Data
		var vm = {};

		// Methods
		vm.setAccessToken     = setAccessToken;
		vm.setRefreshToken    = setRefreshToken;
		vm.getAccessToken     = getAccessToken;
		vm.getRefreshToken    = getRefreshToken;
		vm.removeAccessToken  = removeAccessToken;
		vm.removeRefreshToken = removeRefreshToken;
		vm.getHeaders         = getHeaders;

		//---

		return vm;

		//---

		function setAccessToken(value, expirationDate, persistir) {
			sessionStorage.setItem('access_token', value);

			if( persistir ) {
				$cookies.put('access_token', value, {
					expires: expirationDate
				});
			}
		}

		function setRefreshToken(value, expirationDate, persistir) {
			sessionStorage.setItem('refresh_token', value);

			if( persistir ) {
				$cookies.put('refresh_token', value, {
					expires: expirationDate
				});
			}
		}

		function getAccessToken() {
			var accessToken = sessionStorage.getItem('access_token');

			if( accessToken ) {
				return accessToken;
			}
				
			accessToken = $cookies.get('access_token');

			if( accessToken ) {
				return accessToken;
			} else {
				if( $location.path() != LOGIN_PAGE_PATH && !~$location.path().indexOf('/auth/redefine') ) {
					$location.url( LOGIN_PAGE_PATH );
				}
			}
		}

		function getRefreshToken() {
			var refreshToken = sessionStorage.getItem('refresh_token');

			if( refreshToken ) {
				return refreshToken;
			} else {
				return $cookies.get('refresh_token');	
			}
		}

		function removeAccessToken() {
			sessionStorage.removeItem('access_token');
			$cookies.remove('access_token');
		}

		function removeRefreshToken() {
			sessionStorage.removeItem('refresh_token');
			$cookies.remove('refresh_token');
		}

		function getHeaders() {
			var headers = {};
			headers['Content-Type']  = 'application/json';
			headers['Authorization'] = 'Bearer ' + vm.getAccessToken();
			return headers;
		}
	}
})();

(function ()
{
    'use strict';

    angular
        .module('app.api')
        .factory('authApi', authApi);

    /** @ngInject */
    function authApi($resource, OAUTH_URL, PERFILAMENTO_URL) {
        var api = {};

        api.login = $resource(OAUTH_URL, {}, {
        	post: {
        		method: 'POST',
        		headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        	}
        });

        api.perfilamento = $resource(PERFILAMENTO_URL);

        api.refreshToken = api.login;

        api.updateAcesso = $resource(OAUTH_URL + '/update', {}, {
            post: {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' }
            }
        });

        return api;
    }
})();

(function ()
{
    'use strict';

    /**
     * Main module of the Servo Ticket
     */
    angular
        .module('servoTicket', [

            // Core
            'app.core',

            // Navigation
            'app.navigation',

            // Toolbar
            'app.toolbar',

            // Quick panel
            'app.quick-panel',

            // Util
            'app.util',

            // Api
            'app.api',

            // Main
            'app.main'

        ]);
})();

(function () {
    'use strict';

    angular
        .module('servoTicket')
        .run(runBlock);

    /** @ngInject */
    function runBlock($rootScope, $timeout, $state, util, CLIENT_ID, CLIENT_SECRET, api, authApi, $cookies) {
        // Activate loading indicator
        var stateChangeStartEvent = $rootScope.$on('$stateChangeStart', function () {
            $rootScope.loadingProgress = true;
        });

        // De-activate loading indicator
        var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function () {
            $timeout(function () {
                $rootScope.loadingProgress = false;
            });
        });

        // Store state in the root scope for easy access
        $rootScope.state = $state;

        // Cleanup
        $rootScope.$on('$destroy', function () {
            stateChangeStartEvent();
            stateChangeSuccessEvent();
        });

        if (api.getRefreshToken()) {
            refreshToken();
        }

        /**
         * Pega o nome do domínio digitado no endereço para saber determinar o caminho
         * das imagens e afins. Tenta buscar pela segunda parte da string, 
         * ex: admin.servoticket.com.br deve resultar em servoticket;
         * admin.servoticket.com deve resultar em servoticket;
         * Caso a URL não tenha pontos, ex: localhost, deve resultar somente em localhost.
        */
        var domains = window.location.hostname.split(".");
        if (domains.length > 1) {
            $rootScope.domainName = domains[1].toLowerCase();
        } else {
            $rootScope.domainName = domains[0].toLowerCase();
        }
        $rootScope.staticResourcesURL = "https://static.servoticket.com.br/" + $rootScope.domainName;

        /**
         * Busca o título a partir da organização que o usuário está logado, se ele ainda não tiver logado
         * coloca um título padrão.
         */
        $rootScope.pageTitle = "Acesso ao Sistema";

        $rootScope.setPerfilamento = setPerfilamentoFn;

        var perfilamento = localStorage.getItem('perfilamento');

        if (perfilamento) {
            $rootScope.setPerfilamento(JSON.parse(perfilamento));
        }

        function refreshToken() {
            var data = util.buildFormUrlencodedParams({
                client_id: CLIENT_ID,
                client_secret: CLIENT_SECRET,
                grant_type: 'refresh_token',
                refresh_token: api.getRefreshToken()
            });

            authApi.refreshToken.post(data, onSuccess);

            function onSuccess(response) {
                var expirationDate = new Date();
                expirationDate.setSeconds(response.expires_in);
                api.setAccessToken(response.access_token, expirationDate, !!$cookies.get('access_token'));
                api.setRefreshToken(response.refresh_token, expirationDate, !!$cookies.get('refresh_token'));

                authApi.perfilamento.get({
                    token: response.access_token
                }, function (data) {
                    $rootScope.setPerfilamento(data);
                });
            }
        }

        function setPerfilamentoFn(perfilamento) {
            $rootScope.perfilamento = perfilamento;
            localStorage.setItem('perfilamento', JSON.stringify(perfilamento));

            if (perfilamento.cfgOrganizacao) {
                for (var i = 0; i < perfilamento.cfgOrganizacao.length; i++) {
                    var org = perfilamento.cfgOrganizacao[i];
                    if (org.dsDominioSite.toLowerCase() === $rootScope.domainName) {
                        $rootScope.pageTitle = org.dsTituloPagina;
                        break;
                    }
                }
            }
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('servoTicket')
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider, $locationProvider)
    {
        $locationProvider.html5Mode(true);

        $urlRouterProvider.otherwise('/auth/login');

        /**
         * Layout Style Switcher
         *
         * This code is here for demonstration purposes.
         * If you don't need to switch between the layout
         * styles like in the demo, you can set one manually by
         * typing the template urls into the `State definitions`
         * area and remove this code
         */
        // Inject $cookies
        var $cookies;

        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Get active layout
        var layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

        var layouts = {
            verticalNavigation  : {
                main      : 'app/core/layouts/vertical-navigation.html',
                toolbar   : 'app/toolbar/layouts/vertical-navigation/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
            },
            horizontalNavigation: {
                main      : 'app/core/layouts/horizontal-navigation.html',
                toolbar   : 'app/toolbar/layouts/horizontal-navigation/toolbar.html',
                navigation: 'app/navigation/layouts/horizontal-navigation/navigation.html'
            },
            contentOnly         : {
                main      : 'app/core/layouts/content-only.html',
                toolbar   : '',
                navigation: ''
            },
            contentWithToolbar  : {
                main      : 'app/core/layouts/content-with-toolbar.html',
                toolbar   : 'app/toolbar/layouts/content-with-toolbar/toolbar.html',
                navigation: ''
            }
        };
        // END - Layout Style Switcher

        // State definitions
        $stateProvider
            .state('app', {
                abstract: true,
                views   : {
                    'main@'         : {
                        templateUrl: layouts[layoutStyle].main,
                        controller : 'MainController as vm'
                    },
                    'toolbar@app'   : {
                        templateUrl: layouts[layoutStyle].toolbar,
                        controller : 'ToolbarController as vm'
                    },
                    'navigation@app': {
                        templateUrl: layouts[layoutStyle].navigation,
                        controller : 'NavigationController as vm'
                    },
                    'quickPanel@app': {
                        templateUrl: 'app/quick-panel/quick-panel.html',
                        controller : 'QuickPanelController as vm'
                    }
                }
            });
    }

})();

(function ()
{
    'use strict';

    angular
        .module('servoTicket')
        .config(configBlock);

    /** @ngInject */
    function configBlock($httpProvider) {
        $httpProvider.interceptors.push(interceptor);
    }
    
    /** @ngInject */
    function interceptor($rootScope, api) {
      return {
       'request': function(config) {
           config.headers['Authorization'] = 'Bearer ' + api.getAccessToken();
           config.headers['Domain'] = $rootScope.domainName;

           return config;
        }
      };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('servoTicket')
        .controller('IndexController', IndexController);

    /** @ngInject */
    function IndexController(fuseTheming)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('servoTicket')
        .constant('HOME_PAGE_PATH', '/eventos/produtos')
        .constant('LOGIN_PAGE_PATH', '/auth/login')
        .constant('CLIENT_ID', 'servoticket')
        .constant('CLIENT_SECRET', 'servoticket')
        .constant('OAUTH_BASE_URL', 'https://tstoauth.servofiel.com.br/api')
        .constant('OAUTH_URL', 'https://tstoauth.servofiel.com.br/api/login')
        .constant('PERFILAMENTO_URL', 'https://tstoauth.servofiel.com.br/api/perfilamento/:token')
        .constant('BACKEND_URL', 'https://tstapi.servoticket.com.br/ticket/api');
})();

(function ()
{
    'use strict';

    angular
        .module('servoTicket')
        .constant('AppVersion', '1.3.0')
        .config(config);

    /** @ngInject */
    function config()
    {
        // Put your custom configurations here
    }

})();

(function () {
    'use strict';

    var module = angular.module('app.pages.sistema', [

        'app.pages.sistema.ajuda',
        'app.pages.sistema.arquivoupload'

    ]); 

    module.config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {

        $translatePartialLoaderProvider.addPart('app/main/pages/sistema');

        $stateProvider
            .state('sistema', {
                url: '/sistema',
                parent: 'app',
                views: {
                    'content@app': {
                        template: '<ui-view></ui-view>'
                    }
                }
            });

        msNavigationServiceProvider.saveItem('sistema', {
            title : 'Sistema',
            group : true,
            translate: 'SISTEMA.NAV',
            weight: 1
        });
    }

})();

(function () {
    'use strict';

    var module = angular.module('app.pages.servoticket', [

        'app.pages.servoticket.usuarios',
        'app.pages.servoticket.locatarios',
        'app.pages.servoticket.eventos',
        'app.pages.servoticket.pos'

    ]); 

    // module.config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {

        $translatePartialLoaderProvider.addPart('app/main/pages/servoticket');

        $stateProvider
            .state('servoticket', {
                url: '/servoticket',
                parent: 'app',
                views: {
                    'content@app': {
                        template: '<ui-view></ui-view>'
                    }
                }
            });

        msNavigationServiceProvider.saveItem('servoticket', {
            title : 'ServoTicket',
            group : true,
            translate: 'SERVOTICKET.NAV',
            weight: 1
        });
    }

})();

(function () {
    'use strict';

    var module = angular.module('app.pages.relatorios', [

        'app.pages.relatorios.vendasprodutos',
        'app.pages.relatorios.movimentacaofinanceira',
        'app.pages.relatorios.cargaprepago',
        'app.pages.relatorios.consumoprepago',
        'app.pages.relatorios.saldoestoque'

    ]); 

    module.config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {

        $translatePartialLoaderProvider.addPart('app/main/pages/relatorios');

        $stateProvider
            .state('relatorios', {
                url: '/relatorios',
                parent: 'app',
                views: {
                    'content@app': {
                        template: '<ui-view></ui-view>'
                    }
                }
            });

        msNavigationServiceProvider.saveItem('relatorios', {
            title : 'Relatórios',
            group : true,
            weight: 1,
            translate: 'RELATORIOS.NAV'
        });
    }

})();

(function () {
    'use strict';

    var module = angular.module('app.pages.eventos', [

        'app.pages.eventos.configuracao',
        'app.pages.eventos.grupoprodutos',
        'app.pages.eventos.produtos',
        'app.pages.eventos.importacaoprodutos',
        'app.pages.eventos.usuarios',
        'app.pages.eventos.lancamentoestoque'

    ]); 

    module.config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {

        $translatePartialLoaderProvider.addPart('app/main/pages/eventos');

        $stateProvider
            .state('eventos', {
                url: '/eventos',
                parent: 'app',
                views: {
                    'content@app': {
                        template: '<ui-view></ui-view>'
                    }
                }
            });

        msNavigationServiceProvider.saveItem('eventos', {
            title : 'Eventos',
            group : true,
            translate: 'EVENTOS.NAV',
            weight: 1
        });
    }

})();

(function () {
    'use strict';

    var module = angular.module('app.pages.cadastros', [

        'app.pages.cadastros.evento'

    ]); 

    module.config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {

        $translatePartialLoaderProvider.addPart('app/main/pages/cadastros');

        $stateProvider
            .state('cadastros', {
                url: '/cadastro',
                parent: 'app'
            });

        msNavigationServiceProvider.saveItem('cadastros', {
            title : 'Cadastros',
            group : true,
            translate: 'CADASTROS.NAV',
            weight: 1,
            // hidden: checkProfile
        });
    }

    function checkProfile() {
        var perfilamento = localStorage.getItem('perfilamento');
        
        if (perfilamento) {
            perfilamento = JSON.parse(perfilamento);
            if (perfilamento.tpPerfil) {
                return perfilamento.tpPerfil.toUpperCase() === 'CLIENTE';
            }
        }

        return false;
    }

})();

(function () {
    'use strict';

    angular
        .module('app.pages', [

            'app.pages.changepassword',
            'app.pages.servoticket',
            'app.pages.cadastros',
            'app.pages.eventos',
            'app.pages.relatorios',
            'app.pages.sistema'

        ]);
        
})();
(function ()
{
    'use strict';

    angular
        .module('app.main.auth', [

            // Login
            'app.main.auth.login',

            // Forgot passord
            'app.main.auth.forgot-password',

            'app.main.auth.recuperar-senha'

        ]).run(runBlock);

    /** @ngInject */
    function runBlock($rootScope, authApi, api, util, CLIENT_ID, CLIENT_SECRET, HOME_PAGE_PATH, $location)
    {
        var token = api.getRefreshToken();

        if (token) {

            var data = util.buildFormUrlencodedParams({
                client_id: CLIENT_ID,
                client_secret: CLIENT_SECRET,
                grant_type: 'refresh_token',
                refresh_token: token
            });

            authApi.refreshToken.post(data,

                // Success
                function(response)
                {
                    var expirationDate = new Date();
                    expirationDate.setSeconds(response.expires_in);
                    api.setAccessToken(response.access_token, expirationDate);
                    api.setRefreshToken(response.refresh_token, expirationDate);
                    $location.path(HOME_PAGE_PATH);
                },

                // Error
                function(response)
                {
                    goToLoginPage();
                }
            );

        } else {
            if( !~$location.path().indexOf('/auth/redefine') ) {
                goToLoginPage();
            }
        }

        $rootScope.$on('$stateChangeStart', function(event, toState)
        {
            if (!toState.public) {
                if (!api.getAccessToken() || !api.getRefreshToken()) {
                    event.preventDefault();
                    goToLoginPage();
                }
            }
        });

        function goToLoginPage()
        {
            var loginPage = '/auth/login';
            if ($location.path() !== loginPage) {
                $location.path(loginPage);
            }
        }
    }

})();

angular.module("servoTicket").run(["$templateCache", function($templateCache) {$templateCache.put("app/quick-panel/quick-panel.html","<md-content><md-tabs md-no-pagination md-swipe-content md-stretch-tabs=\"always\"><md-tab><md-tab-label \ntranslate=\"QUICKPANEL.TODAY\">TODAY</md-tab-label><md-tab-body><md-content class=\"today-tab scrollable\" ms-scroll \nng-include=\"\'app/quick-panel/tabs/today/today-tab.html\'\"></md-content></md-tab-body></md-tab><md-tab><md-tab-label \ntranslate=\"QUICKPANEL.CHAT\">CHAT</md-tab-label><md-tab-body><md-content class=\"chat-tab scrollable\" ms-scroll \nng-include=\"\'app/quick-panel/tabs/chat/chat-tab.html\'\" ng-controller=\"ChatTabController as vm\"></md-content>\n</md-tab-body></md-tab><md-tab><md-tab-label translate=\"QUICKPANEL.ACTIVITY\">ACTIVITY</md-tab-label><md-tab-body>\n<md-content class=\"activity-tab scrollable\" ms-scroll ng-include=\"\'app/quick-panel/tabs/activity/activity-tab.html\'\">\n</md-content></md-tab-body></md-tab></md-tabs></md-content>");
$templateCache.put("app/core/layouts/content-only.html","<div id=\"layout-content-only\" class=\"template-layout\" layout=\"column\" flex><md-content id=\"content\" \nclass=\"animate-slide-up md-background md-hue-1\" ui-view=\"content\" flex></md-content></div>");
$templateCache.put("app/core/layouts/content-with-toolbar.html","<div id=\"layout-content-with-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-background md-hue-1\" ui-view=\"content\" flex></md-content></div>");
$templateCache.put("app/core/layouts/horizontal-navigation.html","<div id=\"layout-horizontal-navigation\" class=\"template-layout\" layout=\"column\" flex><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar\" ui-view=\"toolbar\"></md-toolbar><div id=\"horizontal-navigation\" class=\"md-whiteframe-1dp\" \nui-view=\"navigation\"></div><div id=\"content-container\" flex layout=\"column\"><md-content id=\"content\" \nclass=\"animate-slide-up md-background md-hue-1\" ms-scroll ui-view=\"content\" flex></md-content></div><md-sidenav \nid=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll \nui-view=\"quickPanel\"></md-sidenav></div>");
$templateCache.put("app/core/layouts/vertical-navigation.html","<div id=\"layout-vertical-navigation\" class=\"template-layout\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" \nclass=\"md-primary-bg\" md-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll \nui-view=\"navigation\"></md-sidenav><div id=\"content-container\" flex layout=\"column\"><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-background md-hue-1\" ms-scroll ui-view=\"content\" flex></md-content></div><md-sidenav \nid=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll \nui-view=\"quickPanel\"></md-sidenav></div>");
$templateCache.put("app/core/theme-options/theme-options.html","<div class=\"ms-theme-options-panel\" layout=\"row\" layout-align=\"start start\"><div \nclass=\"ms-theme-options-panel-button md-primary-bg\" ng-click=\"toggleOptionsPanel()\"><md-icon md-font-icon=\"icon-cog\" \nclass=\"white-text\"></md-icon></div><div class=\"ms-theme-options-list\" layout=\"column\"><div class=\"theme-option\"><div \nclass=\"option-title\">Layout Style:</div><md-radio-group layout=\"column\" ng-model=\"vm.layoutStyle\" \nng-change=\"vm.updateLayoutStyle()\"><md-radio-button value=\"verticalNavigation\">Vertical Navigation</md-radio-button>\n<md-radio-button value=\"horizontalNavigation\">Horizontal Navigation</md-radio-button><md-radio-button \nvalue=\"contentOnly\">Content Only</md-radio-button><md-radio-button value=\"contentWithToolbar\">Content with Toolbar\n</md-radio-button></md-radio-group></div><md-divider></md-divider><div class=\"theme-option\"><div class=\"option-title\">\nLayout Mode:</div><md-radio-group layout=\"row\" layout-align=\"start center\" ng-model=\"vm.layoutMode\" \nng-change=\"vm.updateLayoutMode()\"><md-radio-button value=\"boxed\">Boxed</md-radio-button><md-radio-button value=\"wide\">\nWide</md-radio-button></md-radio-group></div><md-divider></md-divider><div class=\"theme-option\"><div \nclass=\"option-title\">Color Palette:</div><md-menu-item ng-repeat=\"(themeName, theme) in vm.themes.list\" class=\"theme\">\n<md-button class=\"md-raised theme-button\" aria-label=\"{{themeName}}\" ng-click=\"vm.setActiveTheme(themeName)\" \nng-style=\"{\'background-color\': theme.primary.color,\'border-color\': theme.accent.color,\'color\': theme.primary.contrast1}\" \nng-class=\"themeName\"><span><md-icon ng-style=\"{\'color\': theme.primary.contrast1}\" md-font-icon=\"icon-palette\">\n</md-icon><span>{{themeName}}</span></span></md-button></md-menu-item></div></div></div>");
$templateCache.put("app/core/directives/ms-material-color-picker/ms-material-color-picker.html","<md-menu md-position-mode=\"target-right target\"><md-button aria-label=\"Row Color\" md-menu-origin \nng-click=\"$mdOpenMenu($event)\" ng-class=\"selectedColor.class\"><span ng-show=\"selectedColor.palette\">\n{{selectedColor.palette}} {{selectedColor.hue}} </span><span ng-show=\"!selectedColor.palette\">Select Color</span>\n</md-button><md-menu-content class=\"ms-material-color-picker-menu-content\" layout-column><header \nng-class=\"selectedColor.class || \'md-accent-bg\'\" class=\"md-whiteframe-4dp\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button md-prevent-menu-close ng-click=\"activateHueSelection(false,false)\" \nclass=\"md-icon-button\" ng-class=\"{\'hidden\':!selectedPalette}\" aria-label=\"Palette\"><md-icon \nmd-font-icon=\"icon-arrow-left\" class=\"s20\"></md-icon></md-button><span ng-if=\"selectedColor.palette\">\n{{selectedColor.palette}} {{selectedColor.hue}} </span><span ng-if=\"!selectedColor.palette\">Select Color</span>\n<md-button class=\"remove-color-button md-icon-button\" ng-click=\"removeColor()\" aria-label=\"Remove Color\"><md-icon \nmd-font-icon=\"icon-delete\" class=\"s20\"></md-icon></md-button></header><div class=\"colors\" ms-scroll><div \nng-if=\"!selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" ng-class=\"\'md-\'+palette+\'-500-bg\'\" \nng-repeat=\"(palette, hues) in palettes\" ng-click=\"activateHueSelection(palette,hues)\" layout=\"row\" \nlayout-align=\"start end\" md-prevent-menu-close md-ink-ripple><span class=\"label\">{{palette}}</span></div></div><div \nng-if=\"selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" ng-class=\"\'md-\'+selectedPalette+\'-\'+hue+\'-bg\'\" \nng-repeat=\"(hue, values) in selectedHues\" ng-click=\"selectColor(selectedPalette,hue)\" layout=\"row\" \nlayout-align=\"start end\" md-ink-ripple><span class=\"label\">{{hue}} </span><i \nng-if=\"selectedPalette == selectedColor.palette && hue == selectedColor.hue\" class=\"s16 icon-check\"></i></div></div>\n</div></md-menu-content></md-menu>");
$templateCache.put("app/core/directives/ms-search-bar/ms-search-bar.html","<div flex layout=\"row\" layout-align=\"start center\"><label for=\"ms-search-bar-input\"><md-icon \nid=\"ms-search-bar-expander\" md-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon><md-icon \nid=\"ms-search-bar-collapser\" md-font-icon=\"icon-close\" class=\"icon s24\"></md-icon></label><input \nid=\"ms-search-bar-input\" type=\"text\" ng-model=\"global.search\" placeholder=\"Search\" translate \ntranslate-attr-placeholder=\"TOOLBAR.SEARCH\" flex></div>");
$templateCache.put("app/main/auth/forgot-password/index.html","<div id=\"forgot-password\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"forgot-password-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><div id=\"forgot-password-form\" class=\"md-whiteframe-8dp\"><div \nclass=\"logo\"><img style=\"width: 128px;height: 128px\" ng-src=\"{{staticResourcesURL}}/logo.png\" alt=\"\"></div><div \nclass=\"title\" translate=\"FORGOTPASSWORD.TITLE\">Recupere sua senha</div><form name=\"forgotPasswordForm\" novalidate>\n<md-input-container class=\"md-block\" md-no-float><input type=\"email\" name=\"email\" ng-model=\"vm.username\" \nplaceholder=\"Email address\" translate translate-attr-placeholder=\"FORGOTPASSWORD.EMAIL_ADRESS\" \nng-pattern=\"/^.+@.+\\..+$/\" required><div ng-messages=\"forgotPasswordForm.email.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span translate=\"FORGOTPASSWORD.ERRORS.EMAIL_REQUIRED\">\nCampo email é obrigatório</span></div><div ng-message=\"pattern\"><span \ntranslate=\"FORGOTPASSWORD.ERRORS.EMAIL_MUST_VALID\">Email inválido</span></div></div></md-input-container><md-button \ntype=\"button\" class=\"md-raised md-accent submit-button\" aria-label=\"RESET MY PASSWORD\" \nng-disabled=\"forgotPasswordForm.$invalid || forgotPasswordForm.$pristine\" translate=\"FORGOTPASSWORD.SEND_RESET_LINK\" \ntranslate-attr-aria-label=\"FORGOTPASSWORD.SEND_RESET_LINK\" ng-click=\"vm.submit()\">Enviar link de redefinição\n</md-button></form><div class=\"login\" layout=\"row\" layout-align=\"center center\"><a class=\"link\" ui-sref=\"app.login\" \ntranslate=\"FORGOTPASSWORD.GO_BACK\">Voltar para o login</a></div></div></div></div>");
$templateCache.put("app/main/auth/login/login.html","<div id=\"login-v2\" layout=\"row\" layout-align=\"start\"><div id=\"login-v2-intro\" flex hide show-gt-sm><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"logo\"><img style=\"width: 128px;height: 128px\" \nng-src=\"{{staticResourcesURL}}/logo.png\" alt=\"\"></div><div class=\"title\" translate=\"LOGIN.INTRO_TITLE\" \nstyle=\"margin-left: 25px\">Bem-vindo!</div></div></div><div id=\"login-v2-form-wrapper\" \nclass=\"flex-scrollable md-whiteframe-8dp\" ms-scroll><div id=\"login-v2-form\"><div class=\"logo\" hide-gt-sm><img \nstyle=\"width: 128px;height: 128px\" ng-src=\"{{staticResourcesURL}}/logo.png\" alt=\"\"></div><div class=\"title\" \ntranslate=\"LOGIN.TITLE\">Faça login na sua conta</div><form name=\"loginForm\" ng-submit=\"vm.doLogin()\" novalidate>\n<md-input-container class=\"md-block\" md-no-float><input type=\"email\" name=\"username\" ng-model=\"vm.form.username\" \nplaceholder=\"Email\" translate translate-attr-placeholder=\"LOGIN.EMAIL\" ng-pattern=\"/^.+@.+\\..+$/\" required><div \nng-messages=\"loginForm.username.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"LOGIN.ERRORS.EMAIL_REQUIRED\">Campo email é obrigatório</span></div><div ng-message=\"pattern\"><span \ntranslate=\"LOGIN.ERRORS.EMAIL_MUST_VALID\">Email inválido</span></div></div></md-input-container><md-input-container \nclass=\"md-block\" md-no-float><input type=\"password\" name=\"password\" ng-model=\"vm.form.password\" placeholder=\"Password\" \ntranslate translate-attr-placeholder=\"LOGIN.PASSWORD\" required><div ng-messages=\"loginForm.password.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"LOGIN.ERRORS.PASSWORD_REQUIRED\">Campo senha é obrigatório\n</span></div></div></md-input-container><div class=\"remember-forgot-password\" layout=\"row\" layout-sm=\"column\" \nlayout-align=\"space-between center\"><md-checkbox class=\"remember-me\" ng-model=\"vm.form.remember\" \naria-label=\"Remember Me\"><span translate=\"LOGIN.REMEMBER_ME\">Permanecer conectado</span></md-checkbox><a \nui-sref=\"app.forgot-password\" class=\"forgot-password md-accent-color\" translate=\"LOGIN.FORGOT_PASSWORD\">\nEsqueceu sua senha?</a></div><md-button type=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"LOG IN\" \nng-disabled=\"loginForm.$invalid || loginForm.$pristine\" translate=\"LOGIN.LOG_IN\" \ntranslate-attr-aria-label=\"LOGIN.LOG_IN\">ENTRAR</md-button></form></div></div></div>");
$templateCache.put("app/main/auth/recuperar-senha/index.html","<div id=\"forgot-password\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"forgot-password-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><div id=\"forgot-password-form\" class=\"md-whiteframe-8dp\"><div \nclass=\"logo\"><img style=\"width: 128px;height: 128px\" ng-src=\"{{staticResourcesURL}}/logo.png\" alt=\"\"></div><div \nclass=\"title\">Redefinir senha</div><form name=\"forgotPasswordForm\" novalidate><div layout=\"row\" \nlayout-align=\"start center\"><md-input-container class=\"md-block\" md-no-float style=\"width: 100%\"><input \ntype=\"password\" name=\"senha\" ng-model=\"vm.senha\" placeholder=\"Senha\" required><div \nng-messages=\"forgotPasswordForm.senha.$error\"><div ng-message=\"required\"><span>Campo senha é obrigatório</span></div>\n</div></md-input-container><ul ng-show=\"vm.senha\" style=\"width: 170px\" id=\"strength\" \nservoticket-checkstrength=\"vm.senha\"></ul></div><md-input-container class=\"md-block\" md-no-float><input \ntype=\"password\" name=\"senha2\" ng-model=\"vm.senha2\" placeholder=\"Confirmação de senha\" required><div \nng-messages=\"forgotPasswordForm.senha2.$error\"><div ng-message=\"required\"><span>Confirmação de senha é obrigatória\n</span></div></div></md-input-container><md-button type=\"button\" class=\"md-raised md-accent submit-button\" \naria-label=\"Redefinir senha\" ng-disabled=\"forgotPasswordForm.$invalid || forgotPasswordForm.$pristine\" \nng-click=\"vm.submit()\">Redefinir Senha</md-button></form><div class=\"login\" layout=\"row\" layout-align=\"center center\">\n<a class=\"link\" ui-sref=\"app.login\">Voltar para o login</a></div></div></div></div>");
$templateCache.put("app/main/components/content/template.html","<div style=\"margin: 16px\"><ng-transclude></ng-transclude></div>");
$templateCache.put("app/main/components/header/template.html","<div ng-init=\"header.init()\" layout=\"column\"><div layout=\"row\" layout-align=\"space-between center\" layout-padding><h1>\n{{header.titulo}}</h1><div layout=\"row\" layout-align=\"end center\" flex><md-select flex=\"50\" placeholder=\"Locatário\" \nng-show=\"header.locatarios.length > 1\" ng-model=\"header.locatario\" ng-change=\"header.onSelectLocatario()\"><md-option \nng-selected=\"locatario.id == header.locatario.id\" ng-value=\"locatario\" ng-repeat=\"locatario in header.locatarios\">\n{{locatario.regPessoa.id}} - {{locatario.regPessoa.dsNome}} - {{locatario.regPessoa.dsCidade}} - {{locatario.regPessoa.sgEstado}}\n</md-option></md-select><span layout-padding></span><md-select flex=\"40\" placeholder=\"Evento\" ng-model=\"header.evento\" \nng-disabled=\"!header.locatario\" ng-change=\"header.onSelectEvento()\"><md-option \nng-selected=\"evento.id == header.evento.id\" ng-value=\"evento\" ng-repeat=\"evento in header.eventos\">\n{{evento.id}} - {{evento.dsEvento}}</md-option></md-select></div></div><div style=\"padding-left: 16px\"><h2 \nstyle=\"margin-top: -18px; margin-bottom: 16px\">{{header.subtitulo}}</h2></div></div>");
$templateCache.put("app/main/pages/changepassword/index.html","<div layout=\"row\" layout-align=\"start center\" layout-padding style=\"background: #fff\"><h1>Mudar senha</h1></div>\n<md-divider></md-divider><servoticket-content layout=\"column\" layout-padding><div layout=\"row\"><md-input-container \nflex=\"20\"><label>Senha atual</label><input id=\"senhaatual\" type=\"password\" ng-model=\"changepassword.senhaatual\" \nservoticket-autofocus></md-input-container></div><div layout=\"row\" layout-align=\"start center\"><md-input-container \nflex=\"20\"><label>Nova senha</label><input id=\"novasenha\" type=\"password\" ng-model=\"changepassword.novasenha\" \nname=\"changepassword\" id=\"changepassword\"></md-input-container><ul ng-show=\"changepassword.novasenha\" id=\"strength\" \nservoticket-checkstrength=\"changepassword.novasenha\"></ul></div><div layout=\"row\"><md-input-container flex=\"20\"><label>\nRepita a nova senha</label><input id=\"novasenha2\" type=\"password\" ng-model=\"changepassword.novasenha2\">\n</md-input-container></div></servoticket-content><md-button ng-click=\"changepassword.alterarSenha()\" \nclass=\"md-accent md-fab md-fab-bottom-right\">+</md-button>");
$templateCache.put("app/navigation/layouts/horizontal-navigation/navigation.html","<div layout=\"row\" layout-align=\"start center\"><ms-navigation-horizontal></ms-navigation-horizontal></div>");
$templateCache.put("app/quick-panel/tabs/activity/activity-tab.html","<md-list class=\"friends\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.FRIENDS\">Friends</span>\n</md-subheader><md-list-item class=\"friend md-3-line\" ng-repeat=\"friend in vm.activities.friends\"><img \nng-src=\"{{friend.avatar}}\" class=\"md-avatar\" alt=\"{{friend.name}}\"><div class=\"status {{friend.status}}\"></div><div \nng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div><div \nclass=\"md-list-item-text\"><h3 class=\"message\">{{friend.message}}</h3><p class=\"time\">{{friend.time}}</p></div>\n</md-list-item></md-list><md-divider></md-divider><md-list class=\"servers\"><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"QUICKPANEL.APP_SERVERS\">Application Servers</span></md-subheader><md-list-item class=\"server md-3-line\" \nng-repeat=\"server in vm.activities.servers\"><md-icon md-font-icon=\"icon-checkbox-blank-circle\" class=\"s16 status\" \nng-class=\"server.status\"></md-icon><div class=\"md-list-item-text\"><h3>{{server.location}}</h3><p>{{server.detail}}</p>\n</div></md-list-item></md-list><md-divider></md-divider><md-list class=\"stats\"><md-subheader class=\"md-no-sticky\"><span\n translate=\"QUICKPANEL.USER_STATS\">User Stats</span></md-subheader><md-list-item class=\"stat md-2-line\" \nng-repeat=\"stat in vm.activities.stats\"><div class=\"md-list-item-text\"><span>\n{{stat.title}} ({{stat.current}} / {{stat.total}})</span><md-progress-linear ng-class=\"stat.status\" \nmd-mode=\"determinate\" value=\"{{stat.percent}}\"></md-progress-linear></div></md-list-item></md-list>");
$templateCache.put("app/navigation/layouts/vertical-navigation/navigation.html","<md-toolbar class=\"navigation-header md-whiteframe-1dp\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"logo\" layout=\"row\" layout-align=\"start center\"><img style=\"width: 32px;height: 32px; background: transparent\" \nng-src=\"{{staticResourcesURL}}/logo.png\" class=\"logo-image\"> <span class=\"logo-text\">{{ pageTitle }}</span></div>\n<md-icon class=\"fold-toggle s18\" md-font-icon=\"icon-backburger\" hide show-gt-sm \nng-click=\"vm.toggleMsNavigationFolded()\"></md-icon></md-toolbar><ms-navigation class=\"scrollable\" folded=\"vm.folded\" \nms-scroll=\"vm.msScrollOptions\"></ms-navigation>");
$templateCache.put("app/quick-panel/tabs/chat/chat-tab.html","<div class=\"main animate-slide-left\" ng-hide=\"vm.chatActive\"><md-list class=\"recent\"><md-subheader \nclass=\"md-no-sticky\"><span translate=\"QUICKPANEL.RECENT\">Recent</span></md-subheader><md-list-item \nclass=\"contact md-3-line\" ng-repeat=\"contact in vm.contacts.recent\" ng-click=\"vm.toggleChat(contact)\"><img \nng-src=\"{{contact.avatar}}\" class=\"md-avatar\" alt=\"{{contact.name}}\"><div class=\"status {{contact.status}}\"></div><div \nng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div><div \nclass=\"md-list-item-text\"><h3>{{contact.name}}</h3><p class=\"last-message\">{{contact.lastMessage}}</p></div>\n</md-list-item></md-list><md-divider></md-divider><md-list class=\"all\"><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"QUICKPANEL.START_NEW_CHAT\">Start New Chat</span></md-subheader><md-list-item class=\"contact\" \nng-repeat=\"contact in vm.contacts.all\" ng-click=\"vm.toggleChat(contact)\"><img ng-src=\"{{contact.avatar}}\" \nclass=\"md-avatar\" alt=\"{{contact.name}}\"><div class=\"status {{contact.status}}\"></div><div class=\"md-list-item-text\">\n<h3>{{contact.name}}</h3></div></md-list-item></md-list><md-divider></md-divider></div><div \nclass=\"chat animate-slide-right\" ng-show=\"vm.chatActive\" layout=\"column\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button\" ng-click=\"vm.toggleChat()\" aria-label=\"Back\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.BACK\"><md-icon md-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button><h4>\n<span>{{vm.chat.contact.name}}</span></h4></div><div layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"md-icon-button\" aria-label=\"Call\" translate translate-attr-aria-label=\"QUICKPANEL.CALL\"><md-icon \nmd-font-icon=\"icon-phone\"></md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"More\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button></div>\n</div></md-toolbar><md-content flex layout-paddings ms-scroll id=\"chat-dialog\"><div layout=\"row\" \nng-repeat=\"dialog in vm.chat.contact.dialog\" class=\"md-padding message-row\" ng-class=\"dialog.who\"><img \nng-if=\"dialog.who ===\'contact\'\" ng-src=\"{{vm.chat.contact.avatar}}\" class=\"avatar\" alt=\"{{vm.chat.contact.name}}\"> <img\n ng-if=\"dialog.who ===\'user\'\" class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><div class=\"bubble\" flex><div \nclass=\"message\">{{dialog.message}}</div><div class=\"time secondary-text\">{{dialog.time}}</div></div></div></md-content>\n<form ng-submit=\"vm.reply()\" layout=\"row\" class=\"reply\" layout-align=\"start center\"><textarea \nng-keyup=\"$event.keyCode == 13 ? vm.reply() : null\" flex ng-model=\"vm.replyMessage\" \nplaceholder=\"Type and hit enter to send message\" translate translate-attr-placeholder=\"QUICKPANEL.REPLY_PLACEHOLDER\">\n</textarea><md-button class=\"md-fab\" type=\"submit\" aria-label=\"Send message\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.SEND_MESSAGE\"><md-icon md-font-icon=\"icon-send\"></md-icon></md-button></form>\n</div>");
$templateCache.put("app/quick-panel/tabs/today/today-tab.html","<md-list class=\"date\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.TODAY\">Today</span></md-subheader>\n<md-list-item class=\"md-display-1 md-2-line\" layout=\"column\" layout-align=\"start start\"><div class=\"secondary-text\">\n<div>{{vm.date | date:\'EEEE\'}}</div><div layout=\"row\" layout-align=\"start start\"><span>{{vm.date | date:\'d\'}}</span> \n<span class=\"md-subhead\">th</span> <span>{{vm.date | date:\'MMMM\'}}</span></div></div></md-list-item></md-list>\n<md-divider></md-divider><md-list><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.EVENTS\">Events</span>\n</md-subheader><md-list-item class=\"md-2-line\" ng-repeat=\"event in vm.events\" ng-click=\"dummyFunction()\"><div \nclass=\"md-list-item-text\"><h3>{{event.title}}</h3><p>{{event.detail}}</p></div></md-list-item></md-list><md-divider>\n</md-divider><md-list><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.NOTES\">Notes</span></md-subheader>\n<md-list-item class=\"md-2-line\" ng-repeat=\"note in vm.notes\" ng-click=\"dummyFunction()\"><div class=\"md-list-item-text\">\n<h3>{{note.title}}</h3><p>{{note.detail}}</p></div></md-list-item></md-list><md-divider></md-divider><md-list>\n<md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.QUICK_SETTINGS\">Quick Settings</span></md-subheader>\n<md-list-item><h3 translate=\"QUICKPANEL.NOTIFICATIONS\">Notifications</h3><md-switch class=\"md-secondary\" \nng-model=\"vm.settings.notify\" aria-label=\"Notifications\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.NOTIFICATIONS\"></md-switch></md-list-item><md-list-item><h3 \ntranslate=\"QUICKPANEL.CLOUD_SYNC\">Cloud Sync</h3><md-switch class=\"md-secondary\" ng-model=\"vm.settings.cloud\" \naria-label=\"Cloud Sync\" translate translate-attr-aria-label=\"QUICKPANEL.CLOUD_SYNC\"></md-switch></md-list-item>\n<md-list-item><h3 translate=\"QUICKPANEL.RETRO_THRUSTERS\">Retro Thrusters</h3><md-switch class=\"md-secondary md-warn\" \nng-model=\"vm.settings.retro\" aria-label=\"Retro Thrusters\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.RETRO_THRUSTERS\"></md-switch></md-list-item></md-list>");
$templateCache.put("app/toolbar/layouts/content-with-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div>\n<md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"64\"></md-progress-circular></div><div layout=\"row\" layout-align=\"start center\"><div \nclass=\"toolbar-separator\"></div><ms-search-bar></ms-search-bar><div class=\"toolbar-separator\"></div><md-menu-bar \nid=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"User settings\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" \nsrc=\"assets/images/avatars/profile.jpg\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\"></md-icon></div><span class=\"username\" hide-xs>\nJohn Doe</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-xs></md-icon></div></md-button>\n<md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" ui-sref=\"app.pages_profile\"><md-icon \nmd-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile</md-button></md-menu-item><md-menu-item \nclass=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" class=\"icon\"></md-icon><md-button>Inbox\n</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu id=\"user-status-menu\"><md-button \nng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">{{vm.userStatus.title}}</md-button>\n<md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" ng-class=\"{\'selected\': status === vm.userStatus}\" \nng-repeat=\"status in vm.userStatusOptions\"><md-icon md-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-bar><div class=\"toolbar-separator\"></div><md-menu id=\"language-menu\" \nmd-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" layout-align=\"center center\"><img \nclass=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">\n{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n<div class=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/horizontal-navigation/toolbar.html","<div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div \nclass=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div>\n<md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"64\"></md-progress-circular></div><div layout=\"row\" layout-align=\"start center\"><ms-search-bar>\n</ms-search-bar><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" \nsrc=\"assets/images/avatars/profile.jpg\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\"></md-icon></div><span class=\"username\" hide-xs>\nJohn Doe</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-xs></md-icon></div></md-button>\n<md-menu-content width=\"3\"><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" class=\"icon\"></md-icon>\n<md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar><md-button\n id=\"quick-panel-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'quick-panel\')\" \naria-label=\"Toggle quick panel\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon \nmd-font-icon=\"icon-format-list-bulleted\" class=\"icon\"></md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><md-button \nid=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button></div><div layout=\"row\" layout-align=\"start center\">\n<md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"username\" hide-xs>{{$root.perfilamento.dsNomeUsuario}}\n</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-xs></md-icon></div></md-button><md-menu-content \nwidth=\"3\"><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-email-secure\" class=\"icon\"></md-icon><md-button \nui-sref=\"mudarsenha\">Mudar senha</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-bar></div></div>");
$templateCache.put("app/core/directives/ms-navigation/templates/horizontal.html","<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><ul \nclass=\"horizontal\"><li ng-repeat=\"node in vm.navigation\" ms-navigation-horizontal-node=\"node\" \nng-class=\"{\'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-horizontal-nested.html\'\"></li></ul><script \ntype=\"text/ng-template\" id=\"navigation-horizontal-nested.html\">\n<div ms-navigation-horizontal-item layout=\"row\" ng-if=\"!vm.isHidden()\">\r\n\r\n        <div class=\"ms-navigation-horizontal-button\" ng-if=\"!node.uisref && node.title\"\r\n             ng-class=\"{\'active md-accent-bg\': vm.isActive}\">\r\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\r\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\r\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\r\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\r\n        </div>\r\n\r\n        <a class=\"ms-navigation-horizontal-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\r\n           ng-class=\"{\'active md-accent-bg\': vm.isActive}\"\r\n           ng-if=\"node.uisref && node.title\">\r\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\r\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\r\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\r\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\r\n        </a>\r\n\r\n    </div>\r\n\r\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\r\n        <li ng-repeat=\"node in node.children\" ms-navigation-horizontal-node=\"node\"\r\n            ng-class=\"{\'has-children\': vm.hasChildren}\"\r\n            ng-include=\"\'navigation-horizontal-nested.html\'\"></li>\r\n    </ul>\n</script>");
$templateCache.put("app/core/directives/ms-navigation/templates/vertical.html","<ul><li ng-repeat=\"node in vm.navigation\" ms-navigation-node=\"node\" \nng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-nested.html\'\"></li></ul>\n<script type=\"text/ng-template\" id=\"navigation-nested.html\">\n<div ms-navigation-item layout=\"row\" ng-if=\"!vm.isHidden()\">\r\n\r\n        <div class=\"ms-navigation-button\" ng-if=\"!node.uisref && node.title\">\r\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\r\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\r\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\r\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\r\n        </div>\r\n\r\n        <a class=\"ms-navigation-button {{vm.getClass(node)}}\" ui-sref=\"{{node.uisref}}\" \r\n           ng-if=\"node.uisref && node.title\">\r\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\r\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\r\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\r\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\r\n        </a>\r\n\r\n    </div>\r\n\r\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\r\n        <li ng-repeat=\"node in node.children\" ms-navigation-node=\"node\"\r\n            ng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\"\r\n            ng-include=\"\'navigation-nested.html\'\"></li>\r\n    </ul>\n</script>");
$templateCache.put("app/main/pages/eventos/configuracao/index.html","<servoticket-header titulo=\"Configuração\" locatario=\"configuracao.locatario\" evento=\"configuracao.evento\" \non-change-evento=\"configuracao.onEventoChange()\" on-change-locatario=\"configuracao.onLocatarioChange()\">\n</servoticket-header><md-divider></md-divider><servoticket-content layout=\"column\" layout-padding><div layout=\"row\" \nlayout-align=\"start start\" layout-padding><div layout=\"column\" flex><div layout=\"row\"><md-switch ng-true-value=\"1\" \nng-false-value=\"0\" ng-disabled=\"!configuracao.evento\" ng-model=\"configuracao.configuracao.fgImprimeNomeEvento\">\nImprime Nome do Evento</md-switch></div><div layout=\"row\"><md-input-container flex=\"80\"><label>\nNome do Evento POS ({{configuracao.configuracao.dsNomeEventoPOS.length}} / 50)</label><input \nng-disabled=\"!configuracao.evento\" maxlength=\"50\" ng-model=\"configuracao.configuracao.dsNomeEventoPOS\" \nservoticket-texto></md-input-container></div><div layout=\"row\"><md-switch ng-true-value=\"1\" ng-false-value=\"0\" \nng-disabled=\"!configuracao.evento\" ng-model=\"configuracao.configuracao.fgEmiteCupom\">Imprime Resumo Venda</md-switch>\n<md-switch ng-true-value=\"1\" ng-false-value=\"0\" ng-disabled=\"!configuracao.evento\" \nng-model=\"configuracao.configuracao.fgImprimeLogo\">Imprime Logo</md-switch></div><div layout=\"row\"><md-switch \nng-true-value=\"1\" ng-false-value=\"0\" ng-disabled=\"!configuracao.evento\" \nng-model=\"configuracao.configuracao.fgImprimeMensagem\">Imprime Mensagem Rodapé</md-switch></div><div layout=\"row\">\n<md-input-container flex=\"80\"><label>Mensagem de Rodapé ({{configuracao.configuracao.dsMensagemCupom.length}} / 50)\n</label><input ng-disabled=\"!configuracao.evento\" maxlength=\"50\" ng-model=\"configuracao.configuracao.dsMensagemCupom\" \nservoticket-texto></md-input-container></div></div><span style=\"width: 80px\"></span><div layout=\"column\" flex \nlayout-align=\"start stretch\"><div layout=\"row\" layout-align=\"start start\" flex><div layout=\"column\" flex \nlayout-align=\"center start\"><img ng-src=\"{{ configuracao.logo }}\" style=\"max-height: 100px\" ng-if=\"configuracao.logo\">\n<md-icon ng-if=\"!configuracao.logo\" md-font-icon=\"icon-file-image-box\" class=\"s140\"></md-icon></div><span \nstyle=\"width: 20px\"></span><div layout=\"column\" flex layout-align=\"end stretch\"><label>Largura máxima de 384px</label>\n<label>Imagem BMP monocromática</label><input name=\"file\" id=\"file\" type=\"file\" \nstyle=\"width: 0.1px; height: 0.1px; opacity: 0; overflow: hidden\" accept=\"image/bmp\" \nonchange=\"angular.element(this).scope().fileChanged(this)\" ng-disabled=\"!configuracao.evento\"><label for=\"file\" \nclass=\"md-button md-raised md-primary md-accent\" ng-disabled=\"!configuracao.evento\">Selecionar Logo</label></div></div>\n<span style=\"height: 30px\"></span><md-input-container><label>Largura do Logo (Pixels)</label><input \nname=\"nrLarguraLogo\" type=\"number\" min=\"0\" max=\"384\" required ng-model=\"configuracao.configuracao.nrLarguraLogo\" \nng-disabled=\"!configuracao.evento\"></md-input-container></div></div><md-button ng-disabled=\"!configuracao.evento\" \nng-click=\"configuracao.salvar()\" class=\"md-accent md-fab md-fab-bottom-right\">+</md-button></servoticket-content>");
$templateCache.put("app/main/pages/eventos/grupoprodutos/index.html","<servoticket-content layout=\"column\" layout-padding><div layout=\"row\" layout-align=\"start center\" flex><span \nlayout-margin style=\"font-size:16px; margin-right: 10px\">Locatário:</span><md-select flex=\"60\" placeholder=\"Locatário\" \nng-model=\"ctrl.locatario\" ng-change=\"ctrl.onSelectLocatario()\"><md-option \nng-selected=\"locatario.id == ctrl.locatario.id\" ng-value=\"locatario\" ng-repeat=\"locatario in ctrl.locatarios\">\n{{locatario.regPessoa.id}} - {{locatario.regPessoa.dsNome}} - {{locatario.regPessoa.dsCidade}} - {{locatario.regPessoa.sgEstado}}\n</md-option></md-select></div><md-divider></md-divider><div style=\"background: #fff\"><table \nclass=\"results simple clickable\" ms-responsive-table><thead><tr><th>Nome do grupo</th></tr></thead><tbody><tr \nclass=\"result-item\" ng-repeat=\"grupo in ctrl.grupos\" ng-click=\"ctrl.editar(grupo);\"><td>{{grupo.dsNomeGrupo}}</td></tr>\n</tbody></table></div><md-button ng-disabled=\"!ctrl.locatario\" ng-click=\"ctrl.novo()\" \nclass=\"md-accent md-fab md-fab-bottom-right\">+</md-button></servoticket-content>");
$templateCache.put("app/main/pages/eventos/importacaoprodutos/index.html","<servoticket-header titulo=\"Importação de Produtos\" subtitulo=\"Importar produtos de outros eventos para o selecionado\" \nlocatario=\"importacao.locatario\" evento=\"importacao.evento\" on-change-evento=\"importacao.onSelectEvento()\" \non-change-locatario=\"importacao.onSelectLocatario()\"></servoticket-header><md-divider></md-divider>\n<servoticket-content><div layout=\"row\" layout-align=\"space-between center\" style=\"background: #fff\" layout-padding><div\n layout=\"row\" flex layout-align=\"start center\"><span layout-margin style=\"font-size:16px\">Filtrar:</span>\n<md-input-container flex=\"40\" style=\"margin:0; margin-bottom: -22px\"><input aria-label=\"Pesquisa\" \nng-disabled=\"!importacao.evento\" ng-model=\"importacao.search\"></md-input-container></div></div><md-divider>\n</md-divider><div style=\"background: #fff\"><table class=\"results simple clickable\" ms-responsive-table><thead><tr><th>\n<md-switch ng-disabled=\"!importacao.evento\" ng-model=\"importacao.allChecked\" aria-label=\"Marcar todos\" \nng-change=\"importacao.allCheckedClick()\"></md-switch></th><th>Ordem da Lista na Máquina</th><th>Descrição</th><th>Valor\n</th><th>Controla Estoque</th><th>Imprime Ticket</th><th>Solicita Preço na Venda</th><th>Número de Vias</th></tr>\n</thead><tbody><tr class=\"result-item\" ng-repeat=\"produto in importacao.produtos | filter:importacao.filter\" \nng-click=\"produto.checked = !produto.checked; importacao.onItemChange(produto);\"><td><md-switch \nng-model=\"produto.checked\" aria-label=\"Checked\" ng-click=\"produto.checked = !produto.checked;\"></md-switch></td><td>\n{{produto.idCodigoVenda}}</td><td>{{produto.regProduto.dsDescricao}}</td><td>{{produto.vlPreco | currency: \'R$ \'}}</td>\n<td>{{produto.fgEstoque ? \'Sim\' : \'Não\'}}</td><td>{{produto.fgImprimeTicket ? \'Sim\' : \'Não\'}}</td><td>\n{{produto.fgSolicitaPreco ? \'Sim\' : \'Não\'}}</td><td>{{produto.nrViasTicket}}</td></tr></tbody></table></div>\n</servoticket-content><md-button ng-disabled=\"!importacao.evento\" ng-click=\"importacao.onImportarClick()\" \nclass=\"md-accent md-fab md-fab-bottom-right\">+</md-button>");
$templateCache.put("app/main/pages/eventos/lancamentoestoque/index.html","<servoticket-header titulo=\"Lançamento de Estoque\" subtitulo=\"\" locatario=\"lancamentoestoque.locatario\" \nevento=\"lancamentoestoque.evento\" on-change-evento=\"lancamentoestoque.onSelectEvento()\" \non-change-locatario=\"lancamentoestoque.onSelectLocatario()\"></servoticket-header><md-divider></md-divider>\n<servoticket-content><div layout=\"row\" layout-align=\"space-between center\" style=\"background: #fff\" layout-padding><div\n layout=\"row\" flex layout-align=\"start center\"><span layout-margin style=\"font-size: 16px\">Período:</span><md-select \nng-model=\"lancamentoestoque.periodo\" ng-change=\"lancamentoestoque.lista()\" \nstyle=\"margin-bottom: 10px; margin-top: 5px\"><md-option value=\"{{$index}}\" class=\"md-primary\" \nng-repeat=\"periodo in lancamentoestoque.periodoItens\">{{periodo}}</md-option></md-select><div layout=\"column\" \nng-show=\"lancamentoestoque.periodo == 3\" layout-align=\"start center\" style=\"margin-left: 15px\"><div layout=\"row\" \nlayout-align=\"start center\"><span style=\"margin-right: 10px\">De:</span><md-datepicker md-open-on-focus \nng-change=\"lancamentoestoque.lista()\" ng-model=\"lancamentoestoque.dataInicio\" md-placeholder=\"Data início\">\n</md-datepicker><md-select ng-model=\"lancamentoestoque.horaInicio\" ng-change=\"lancamentoestoque.lista()\" \nstyle=\"margin: 0px 10px 0px 10px\"><md-option value=\"{{ $index }}\" class=\"md-primary\" \nng-repeat=\"hora in [].constructor(24) track by $index\">{{$index}}h</md-option></md-select><md-select \nng-model=\"lancamentoestoque.minutoInicio\" ng-change=\"lancamentoestoque.lista()\" style=\"margin: 0px 10px 0px 10px\">\n<md-option value=\"{{ minuto }}\" class=\"md-primary\" ng-repeat=\"minuto in lancamentoestoque.minutosInicio\">{{minuto}}min\n</md-option></md-select></div><div layout=\"row\" layout-align=\"start center\"><span style=\"margin-right: 10px\">Até:\n</span><md-datepicker md-open-on-focus ng-change=\"lancamentoestoque.lista()\" ng-model=\"lancamentoestoque.dataFim\" \nmd-placeholder=\"Data fim\"></md-datepicker><md-select ng-model=\"lancamentoestoque.horaFim\" \nng-change=\"lancamentoestoque.lista()\" style=\"margin: 0px 10px 0px 10px\"><md-option value=\"{{ $index }}\" \nclass=\"md-primary\" ng-repeat=\"hora in [].constructor(24) track by $index\">{{$index}}h</md-option></md-select><md-select\n ng-model=\"lancamentoestoque.minutoFim\" ng-change=\"lancamentoestoque.lista()\" style=\"margin: 0px 10px 0px 10px\">\n<md-option value=\"{{ minuto }}\" class=\"md-primary\" ng-repeat=\"minuto in lancamentoestoque.minutosFim\">{{minuto}}min\n</md-option></md-select></div></div><span layout-margin style=\"font-size: 16px\">Operação:</span><md-select flex=\"15\" \nplaceholder=\"Tipo Operação\" ng-model=\"lancamentoestoque.tipoOperacao\" \nng-change=\"lancamentoestoque.onSelectTipoOperacao()\"><md-option \nng-selected=\"tipo.id == lancamentoestoque.tipoOperacao.id\" ng-value=\"tipo\" \nng-repeat=\"tipo in lancamentoestoque.listaTipoOperacao\">{{tipo.nome}}</md-option></md-select></div></div><md-divider>\n</md-divider><div style=\"background: #fff\"><table class=\"results simple clickable\" ms-responsive-table><thead><tr><th>\nData</th><th>Operação</th><th>Produto</th><th>Quantidade</th></tr></thead><tbody><tr class=\"result-item\" \nng-repeat=\"estoque in lancamentoestoque.data.data\"><td>{{estoque.dhInsert}}</td><td>{{estoque.tipoOperacao.nome}}</td>\n<td>{{estoque.regProduto.dsDescricao}}</td><td>{{estoque.nrQuantidade}}</td></tr></tbody></table><md-table-pagination \nmd-limit=\"lancamentoestoque.limit\" md-page=\"lancamentoestoque.page\" \nmd-total=\"{{ lancamentoestoque.data.totalRegistros }}\" md-limit-options=\"[25, 50, 100]\" \nmd-label=\"{{ lancamentoestoque.pageLabels }}\" md-on-paginate=\"lancamentoestoque.pageChanged\"></md-table-pagination>\n</div></servoticket-content><div style=\"height: 80px\"></div><md-button ng-disabled=\"!lancamentoestoque.evento\" \nng-click=\"lancamentoestoque.onNewClick()\" class=\"md-accent md-fab md-fab-bottom-right\">+</md-button>");
$templateCache.put("app/main/pages/eventos/produtos/index.html","<servoticket-header titulo=\"Produtos\" locatario=\"produtos.locatario\" evento=\"produtos.evento\" \non-change-evento=\"produtos.onSelectEvento()\" on-change-locatario=\"produtos.onSelectLocatario()\"></servoticket-header>\n<md-divider></md-divider><servoticket-content><div layout=\"row\" layout-align=\"space-between center\" \nstyle=\"background: #fff\" layout-padding><div layout=\"row\" flex layout-align=\"start center\"><span layout-margin \nstyle=\"font-size:16px\">Filtrar:</span><md-input-container flex=\"40\" style=\"margin:0; margin-bottom: -22px\"><input \naria-label=\"Pesquisa\" ng-disabled=\"!produtos.evento\" ng-model=\"produtos.search\" ng-model-options=\"{ debounce: 450 }\" \nng-change=\"produtos.filter()\"></md-input-container></div></div><md-divider></md-divider><div style=\"background: #fff\">\n<table class=\"results simple clickable\" ms-responsive-table><thead><tr><th>Ordem da Lista na Máquina</th><th>Descrição\n</th><th>Valor</th><th>Controla Estoque</th><th>Imprime Ticket</th><th>Solicita Preço na Venda</th><th>Número de Vias\n</th><th>Excluir</th></tr></thead><tbody><tr class=\"result-item\" ng-repeat=\"produto in produtos.data.data\" \nng-click=\"produtos.onRowClick(produto)\"><td>{{produto.idCodigoVenda}}</td><td>{{produto.regProduto.dsDescricao}}</td>\n<td>{{produto.vlPreco | currency: \'R$ \'}}</td><td>{{produto.fgEstoque ? \'Sim\' : \'Não\'}}</td><td>\n{{produto.fgImprimeTicket ? \'Sim\' : \'Não\'}}</td><td>{{produto.fgSolicitaPreco ? \'Sim\' : \'Não\'}}</td><td>\n{{produto.nrViasTicket}}</td><td><span ng-click=\"produtos.delete(produto, $event);\"><i class=\"icon icon-delete s23\">\n</i></span></td></tr></tbody></table><md-table-pagination md-limit=\"produtos.limit\" md-page=\"produtos.page\" \nmd-total=\"{{ produtos.data.totalRegistros }}\" md-limit-options=\"[25, 50, 100]\" md-label=\"{{ produtos.pageLabels }}\" \nmd-on-paginate=\"produtos.pageChanged\"></md-table-pagination></div></servoticket-content><div style=\"height: 80px\">\n</div><md-button ng-disabled=\"!produtos.evento\" ng-click=\"produtos.onNewClick()\" \nclass=\"md-accent md-fab md-fab-bottom-right\">+</md-button>");
$templateCache.put("app/main/pages/eventos/usuarios/index.html","<h1>{{vm.whoami}}</h1>");
$templateCache.put("app/main/pages/relatorios/cargaprepago/index.html","<div><servoticket-header titulo=\"Cargas de pré-pago\" locatario=\"relatorio.locatario\" evento=\"relatorio.evento\" \non-change-evento=\"relatorio.onSelectEvento()\" on-change-locatario=\"relatorio.onSelectLocatario()\"></servoticket-header>\n<md-divider></md-divider><servoticket-content><div style=\"background: #fff; padding: 20px;position:relative\"><div \nlayout=\"row\"><div layout=\"column\"><div layout=\"row\" layout-align=\"start center\"><span align=\"right\" \nstyle=\"width: 47px;margin-right: 10px\">Período:</span><md-select ng-model=\"relatorio.periodo\" \nng-change=\"relatorio.carregarDadosMovimentacao()\" style=\"margin-bottom: 10px; margin-top: 5px\"><md-option \nvalue=\"{{$index}}\" class=\"md-primary\" ng-repeat=\"periodo in relatorio.periodoItens\">{{periodo}}</md-option></md-select>\n</div></div><div layout=\"column\" ng-show=\"relatorio.periodo == 3\" layout-align=\"start center\" \nstyle=\"margin-left: 15px\"><div layout=\"row\" layout-align=\"start center\"><span style=\"margin-right: 10px\">De:</span>\n<md-datepicker md-open-on-focus ng-change=\"relatorio.carregarDadosMovimentacao()\" ng-model=\"relatorio.dataInicio\" \nmd-placeholder=\"Data início\"></md-datepicker><md-select ng-model=\"relatorio.horaInicio\" \nng-change=\"relatorio.carregarDadosMovimentacao()\" style=\"margin: 0px 10px 0px 10px\"><md-option value=\"{{ $index }}\" \nclass=\"md-primary\" ng-repeat=\"hora in [].constructor(24) track by $index\">{{$index}}h</md-option></md-select><md-select\n ng-model=\"relatorio.minutoInicio\" ng-change=\"relatorio.carregarDadosMovimentacao()\" style=\"margin: 0px 10px 0px 10px\">\n<md-option value=\"{{ minuto }}\" class=\"md-primary\" ng-repeat=\"minuto in relatorio.minutosInicio\">{{minuto}}min\n</md-option></md-select></div><div layout=\"row\" layout-align=\"start center\"><span style=\"margin-right: 10px\">Até:\n</span><md-datepicker md-open-on-focus ng-change=\"relatorio.carregarDadosMovimentacao()\" ng-model=\"relatorio.dataFim\" \nmd-placeholder=\"Data fim\"></md-datepicker><md-select ng-model=\"relatorio.horaFim\" \nng-change=\"relatorio.carregarDadosMovimentacao()\" style=\"margin: 0px 10px 0px 10px\"><md-option value=\"{{ $index }}\" \nclass=\"md-primary\" ng-repeat=\"hora in [].constructor(24) track by $index\">{{$index}}h</md-option></md-select><md-select\n ng-model=\"relatorio.minutoFim\" ng-change=\"relatorio.carregarDadosMovimentacao()\" style=\"margin: 0px 10px 0px 10px\">\n<md-option value=\"{{ minuto }}\" class=\"md-primary\" ng-repeat=\"minuto in relatorio.minutosFim\">{{minuto}}min</md-option>\n</md-select></div></div></div><br><div layout=\"column\" layout-lg=\"row\" layout-align-lg=\"space-between center\" \nlayout-align=\" center\" style=\"margin-right: 200px\"><div layout=\"row\" layout-align-lg=\"space-between center\" \nlayout-align=\"start center\"><span align=\"right\" style=\"width: 47px;margin-right: 10px;margin-top: 5px\">POS:</span>\n<md-input-container style=\"min-width: 250px;margin:0\" md-no-float><input ng-model=\"relatorio.pos\" placeholder=\"POS\" \nng-change=\"relatorio.carregarDadosMovimentacao()\" ng-model-options=\"{ debounce: 500 }\"></md-input-container></div><div \nlayout=\"row\" layout-align-lg=\"space-between center\" layout-align=\"start center\"><span align=\"right\" \nstyle=\"width: 47px;margin-right: 10px;margin-top: 5px\">Cartão:</span><md-input-container \nstyle=\"min-width: 250px;margin:0\" md-no-float><input ng-model=\"relatorio.mifare\" placeholder=\"ID ou SN Mifare\" \nng-change=\"relatorio.carregarDadosMovimentacao()\" ng-model-options=\"{ debounce: 500 }\"></md-input-container></div><div \nlayout=\"row\" layout-align-lg=\"space-between center\" layout-align=\"start center\"><span align=\"right\" \nstyle=\"width: 47px;margin-right: 10px;margin-top: 5px\">Carga:</span><md-input-container \nstyle=\"min-width: 250px;margin:0\" md-no-float><input ng-model=\"relatorio.carga\" placeholder=\"ID Carga\" \nng-change=\"relatorio.carregarDadosMovimentacao()\" ng-model-options=\"{ debounce: 500 }\"></md-input-container></div>\n<md-fab-speed-dial md-direction=\"down\" md-open=\"fabOpen\" class=\"md-scale md-mini\" \nng-class=\"{ \'md-hover-full\': hover }\" ng-mouseenter=\"fabOpen = !!relatorio.data.length && !relatorio.exporting\" \nng-mouseleave=\"fabOpen = false\" \nstyle=\"position: absolute;right:5px;bottom: {{relatorio.data.length && !relatorio.exporting ? \'-200px\' : \'5px\'}}\">\n<md-fab-trigger><md-button class=\"md-fab md-warn\" ng-disabled=\"!relatorio.data.length || relatorio.exporting\">\n<md-tooltip md-direction=\"left\" md-visible=\"tooltipVisible\">Menu</md-tooltip><md-icon md-font-icon=\"icon-unfold-more\">\n</md-icon></md-button></md-fab-trigger><md-fab-actions ng-hide=\"!relatorio.data.length || relatorio.exporting\">\n<md-button class=\"md-fab md-raised md-mini\" ng-click=\"relatorio.exportarAnaliticoPdf()\"><md-tooltip \nmd-direction=\"left\" md-visible=\"tooltipVisible\" md-autohide=\"false\">Exportar pdf analítico</md-tooltip><md-icon \nmd-font-icon=\"icon-file-pdf-box\"></md-icon></md-button><md-button class=\"md-fab md-raised md-mini\" \nng-click=\"relatorio.exportarAnaliticoExcel()\"><md-tooltip md-direction=\"left\" md-visible=\"tooltipVisible\" \nmd-autohide=\"false\">Exportar excel analítico</md-tooltip><md-icon md-font-icon=\"icon-file-excel-box\"></md-icon>\n</md-button><md-button class=\"md-fab md-raised md-mini\" ng-click=\"relatorio.exportarSinteticoPdf()\"><md-tooltip \nmd-direction=\"left\" md-visible=\"tooltipVisible\" md-autohide=\"false\">Exportar pdf sintético</md-tooltip><md-icon \nmd-font-icon=\"icon-file-pdf\"></md-icon></md-button><md-button class=\"md-fab md-raised md-mini\" \nng-click=\"relatorio.exportarSinteticoExcel()\"><md-tooltip md-direction=\"left\" md-visible=\"tooltipVisible\" \nmd-autohide=\"false\">Exportar excel sintético</md-tooltip><md-icon md-font-icon=\"icon-file-excel\"></md-icon></md-button>\n</md-fab-actions></md-fab-speed-dial></div></div></servoticket-content><servoticket-content ng-show=\"relatorio.data\">\n<div style=\"padding: 20px 20px 10px 10px\"><canvas id=\"barChart\" style=\"width: 100%; height: 300px\" height=\"300\">\n</canvas></div></servoticket-content><servoticket-content ng-show=\"relatorio.data\"><div style=\"background: #fff\"><table\n class=\"results simple\" ms-responsive-table><thead><tr><th ng-click=\"relatorio.changeOrder(\'dsMovimento\')\">Operação\n<md-icon ng-show=\"relatorio.order == \'dsMovimento\' && relatorio.reverse\" md-font-icon=\"icon-chevron-up\"></md-icon>\n<md-icon ng-show=\"relatorio.order == \'dsMovimento\' && !relatorio.reverse\" md-font-icon=\"icon-chevron-down\"></md-icon>\n<md-icon ng-show=\"relatorio.order != \'dsMovimento\'\" md-font-icon=\"icon-unfold-more\"></md-icon></th><th \nng-click=\"relatorio.changeOrder(\'quantidade\')\">Quantidade<md-icon \nng-show=\"relatorio.order == \'quantidade\' && relatorio.reverse\" md-font-icon=\"icon-chevron-up\"></md-icon><md-icon \nng-show=\"relatorio.order == \'quantidade\' && !relatorio.reverse\" md-font-icon=\"icon-chevron-down\"></md-icon><md-icon \nng-show=\"relatorio.order != \'quantidade\'\" md-font-icon=\"icon-unfold-more\"></md-icon></th><th \nng-click=\"relatorio.changeOrder(\'vlMovimento\')\">Total<md-icon \nng-show=\"relatorio.order == \'vlMovimento\' && relatorio.reverse\" md-font-icon=\"icon-chevron-up\"></md-icon><md-icon \nng-show=\"relatorio.order == \'vlMovimento\' && !relatorio.reverse\" md-font-icon=\"icon-chevron-down\"></md-icon><md-icon \nng-show=\"relatorio.order != \'vlMovimento\'\" md-font-icon=\"icon-unfold-more\"></md-icon></th></tr></thead><tbody><tr \nclass=\"result-item\" ng-class=\"{fechamento: (item.dsMovimento == \'FECHAMENTO\')}\" \nng-repeat=\"item in relatorio.data | orderBy: relatorio.order:relatorio.reverse\"><td>{{item.dsMovimento}}</td><td>\n{{item.quantidade}}</td><td>{{::relatorio.formatarValor(item.vlMovimento)}}</td></tr></tbody></table></div>\n</servoticket-content></div><style>\ntable.results th:hover {\r\n        cursor:pointer;\r\n    }\r\n\r\n    md-input-container .md-errors-spacer {\r\n        min-height: 0 !important;\r\n    }\r\n    \r\n    .fechamento {\r\n        color: rgb(244, 67, 54);\r\n    }\n</style>");
$templateCache.put("app/main/pages/relatorios/consumoprepago/index.html","<div><servoticket-header titulo=\"Consumo Pré-pago Produtos\" locatario=\"relatorio.locatario\" evento=\"relatorio.evento\" \non-change-evento=\"relatorio.onSelectEvento()\" on-change-locatario=\"relatorio.onSelectLocatario()\"></servoticket-header>\n<md-divider></md-divider><servoticket-content><div style=\"background: #fff; padding: 20px;position:relative\"><div \nlayout=\"row\"><div layout=\"column\"><div layout=\"row\" layout-align=\"start center\"><span align=\"right\" \nstyle=\"width: 47px;margin-right: 10px\">Período:</span><md-select ng-model=\"relatorio.periodo\" \nng-change=\"relatorio.carregarDadosMovimentacao()\" style=\"margin-bottom: 10px; margin-top: 5px\"><md-option \nvalue=\"{{$index}}\" class=\"md-primary\" ng-repeat=\"periodo in relatorio.periodoItens\">{{periodo}}</md-option></md-select>\n</div></div><div layout=\"column\" ng-show=\"relatorio.periodo == 3\" layout-align=\"start center\" \nstyle=\"margin-left: 15px\"><div layout=\"row\" layout-align=\"start center\"><span style=\"margin-right: 10px\">De:</span>\n<md-datepicker md-open-on-focus ng-change=\"relatorio.carregarDadosMovimentacao()\" ng-model=\"relatorio.dataInicio\" \nmd-placeholder=\"Data início\"></md-datepicker><md-select ng-model=\"relatorio.horaInicio\" \nng-change=\"relatorio.carregarDadosMovimentacao()\" style=\"margin: 0px 10px 0px 10px\"><md-option value=\"{{ $index }}\" \nclass=\"md-primary\" ng-repeat=\"hora in [].constructor(24) track by $index\">{{$index}}h</md-option></md-select><md-select\n ng-model=\"relatorio.minutoInicio\" ng-change=\"relatorio.carregarDadosMovimentacao()\" style=\"margin: 0px 10px 0px 10px\">\n<md-option value=\"{{ minuto }}\" class=\"md-primary\" ng-repeat=\"minuto in relatorio.minutosInicio\">{{minuto}}min\n</md-option></md-select></div><div layout=\"row\" layout-align=\"start center\"><span style=\"margin-right: 10px\">Até:\n</span><md-datepicker md-open-on-focus ng-change=\"relatorio.carregarDadosMovimentacao()\" ng-model=\"relatorio.dataFim\" \nmd-placeholder=\"Data fim\"></md-datepicker><md-select ng-model=\"relatorio.horaFim\" \nng-change=\"relatorio.carregarDadosMovimentacao()\" style=\"margin: 0px 10px 0px 10px\"><md-option value=\"{{ $index }}\" \nclass=\"md-primary\" ng-repeat=\"hora in [].constructor(24) track by $index\">{{$index}}h</md-option></md-select><md-select\n ng-model=\"relatorio.minutoFim\" ng-change=\"relatorio.carregarDadosMovimentacao()\" style=\"margin: 0px 10px 0px 10px\">\n<md-option value=\"{{ minuto }}\" class=\"md-primary\" ng-repeat=\"minuto in relatorio.minutosFim\">{{minuto}}min</md-option>\n</md-select></div></div></div><br><div layout=\"column\" layout-lg=\"row\" layout-align-lg=\"space-between center\" \nlayout-align=\" center\" style=\"margin-right: 200px\"><div layout=\"row\" layout-align-lg=\"space-between center\" \nlayout-align=\"start center\"><span align=\"right\" style=\"width: 47px;margin-right: 10px;margin-top: 5px\">POS:</span>\n<md-input-container style=\"min-width: 250px;margin:0\" md-no-float><input ng-model=\"relatorio.pos\" placeholder=\"POS\" \nng-change=\"relatorio.carregarDadosMovimentacao()\" ng-model-options=\"{ debounce: 500 }\"></md-input-container></div><div \nlayout=\"row\" layout-align-lg=\"space-between center\" layout-align=\"start center\"><span align=\"right\" \nstyle=\"width: 47px;margin-right: 10px;margin-top: 5px\">Cartão:</span><md-input-container \nstyle=\"min-width: 250px;margin:0\" md-no-float><input ng-model=\"relatorio.mifare\" placeholder=\"ID ou SN Mifare\" \nng-change=\"relatorio.carregarDadosMovimentacao()\" ng-model-options=\"{ debounce: 500 }\"></md-input-container></div><div \nlayout=\"row\" layout-align-lg=\"space-between center\" layout-align=\"start center\"><span align=\"right\" \nstyle=\"width: 47px;margin-right: 10px;margin-top: 5px\">Carga:</span><md-input-container \nstyle=\"min-width: 250px;margin:0\" md-no-float><input ng-model=\"relatorio.carga\" placeholder=\"ID Carga\" \nng-change=\"relatorio.carregarDadosMovimentacao()\" ng-model-options=\"{ debounce: 500 }\"></md-input-container></div>\n<md-fab-speed-dial md-direction=\"down\" md-open=\"fabOpen\" class=\"md-scale md-mini\" \nng-class=\"{ \'md-hover-full\': hover }\" ng-mouseenter=\"fabOpen = !!relatorio.data.length && !relatorio.exporting\" \nng-mouseleave=\"fabOpen = false\" \nstyle=\"position: absolute;right:5px;bottom: {{relatorio.data.length && !relatorio.exporting ? \'-200px\' : \'5px\'}}\">\n<md-fab-trigger><md-button class=\"md-fab md-warn\" ng-disabled=\"!relatorio.data.length || relatorio.exporting\">\n<md-tooltip md-direction=\"left\" md-visible=\"tooltipVisible\">Menu</md-tooltip><md-icon md-font-icon=\"icon-unfold-more\">\n</md-icon></md-button></md-fab-trigger><md-fab-actions ng-hide=\"!relatorio.data.length || relatorio.exporting\">\n<md-button class=\"md-fab md-raised md-mini\" ng-click=\"relatorio.exportarAnaliticoPdf()\"><md-tooltip \nmd-direction=\"left\" md-visible=\"tooltipVisible\" md-autohide=\"false\">Exportar pdf analítico</md-tooltip><md-icon \nmd-font-icon=\"icon-file-pdf-box\"></md-icon></md-button><md-button class=\"md-fab md-raised md-mini\" \nng-click=\"relatorio.exportarAnaliticoExcel()\"><md-tooltip md-direction=\"left\" md-visible=\"tooltipVisible\" \nmd-autohide=\"false\">Exportar excel analítico</md-tooltip><md-icon md-font-icon=\"icon-file-excel-box\"></md-icon>\n</md-button><md-button class=\"md-fab md-raised md-mini\" ng-click=\"relatorio.exportarSinteticoPdf()\"><md-tooltip \nmd-direction=\"left\" md-visible=\"tooltipVisible\" md-autohide=\"false\">Exportar pdf sintético</md-tooltip><md-icon \nmd-font-icon=\"icon-file-pdf\"></md-icon></md-button><md-button class=\"md-fab md-raised md-mini\" \nng-click=\"relatorio.exportarSinteticoExcel()\"><md-tooltip md-direction=\"left\" md-visible=\"tooltipVisible\" \nmd-autohide=\"false\">Exportar excel sintético</md-tooltip><md-icon md-font-icon=\"icon-file-excel\"></md-icon></md-button>\n</md-fab-actions></md-fab-speed-dial></div></div></servoticket-content><servoticket-content ng-show=\"relatorio.data\">\n<div style=\"padding: 20px 20px 10px 10px\"><canvas id=\"barChart\" style=\"width: 100%; height: 300px\" height=\"300\">\n</canvas></div></servoticket-content><servoticket-content ng-show=\"relatorio.data\"><div style=\"background: #fff\"><table\n class=\"results simple\" ms-responsive-table><thead><tr><th ng-click=\"relatorio.changeOrder(\'dsDescricaoDisplayPos\')\">\nProduto<md-icon ng-show=\"relatorio.order == \'dsDescricaoDisplayPos\' && relatorio.reverse\" \nmd-font-icon=\"icon-chevron-up\"></md-icon><md-icon \nng-show=\"relatorio.order == \'dsDescricaoDisplayPos\' && !relatorio.reverse\" md-font-icon=\"icon-chevron-down\"></md-icon>\n<md-icon ng-show=\"relatorio.order != \'dsDescricaoDisplayPos\'\" md-font-icon=\"icon-unfold-more\"></md-icon></th><th \nng-click=\"relatorio.changeOrder(\'quantidade\')\" style=\"text-align: right\">Quantidade<md-icon \nng-show=\"relatorio.order == \'quantidade\' && relatorio.reverse\" md-font-icon=\"icon-chevron-up\"></md-icon><md-icon \nng-show=\"relatorio.order == \'quantidade\' && !relatorio.reverse\" md-font-icon=\"icon-chevron-down\"></md-icon><md-icon \nng-show=\"relatorio.order != \'quantidade\'\" md-font-icon=\"icon-unfold-more\"></md-icon></th><th \nng-click=\"relatorio.changeOrder(\'percentQuantidade\')\" style=\"text-align: right\">% Quantidade<md-icon \nng-show=\"relatorio.order == \'percentQuantidade\' && relatorio.reverse\" md-font-icon=\"icon-chevron-up\"></md-icon><md-icon\n ng-show=\"relatorio.order == \'percentQuantidade\' && !relatorio.reverse\" md-font-icon=\"icon-chevron-down\"></md-icon>\n<md-icon ng-show=\"relatorio.order != \'percentQuantidade\'\" md-font-icon=\"icon-unfold-more\"></md-icon></th><th \nng-click=\"relatorio.changeOrder(\'valor\')\" style=\"text-align: right\">Total<md-icon \nng-show=\"relatorio.order == \'valor\' && relatorio.reverse\" md-font-icon=\"icon-chevron-up\"></md-icon><md-icon \nng-show=\"relatorio.order == \'valor\' && !relatorio.reverse\" md-font-icon=\"icon-chevron-down\"></md-icon><md-icon \nng-show=\"relatorio.order != \'valor\'\" md-font-icon=\"icon-unfold-more\"></md-icon></th><th \nng-click=\"relatorio.changeOrder(\'percentValor\')\" style=\"text-align: right\">% Total<md-icon \nng-show=\"relatorio.order == \'percentValor\' && relatorio.reverse\" md-font-icon=\"icon-chevron-up\"></md-icon><md-icon \nng-show=\"relatorio.order == \'percentValor\' && !relatorio.reverse\" md-font-icon=\"icon-chevron-down\"></md-icon><md-icon \nng-show=\"relatorio.order != \'percentValor\'\" md-font-icon=\"icon-unfold-more\"></md-icon></th></tr></thead><tbody><tr \nclass=\"result-item\" ng-repeat=\"item in relatorio.data | orderBy: relatorio.order:relatorio.reverse\"><td>\n{{item.dsDescricaoDisplayPos}}</td><td style=\"text-align: right\">{{item.quantidade}}</td><td style=\"text-align: right\">\n{{item.percentQuantidade}}%</td><td style=\"text-align: right\">R$ {{::relatorio.formatarValor(item.valor)}}</td><td \nstyle=\"text-align: right\">{{item.percentValor}}%</td></tr><tr class=\"result-item\" style=\"font-weight: bold\"><td>TOTAL\n</td><td style=\"text-align: right\">{{relatorio.total.quantidade}}</td><td style=\"text-align: right\">\n{{relatorio.total.percentQuantidade}}%</td><td style=\"text-align: right\">\nR$ {{relatorio.formatarValor(relatorio.total.valor)}}</td><td style=\"text-align: right\">\n{{relatorio.total.percentValor}}%</td></tr></tbody></table></div></servoticket-content></div><style>\ntable.results th:hover {\r\n        cursor:pointer;\r\n    }\r\n\r\n    md-input-container .md-errors-spacer {\r\n        min-height: 0 !important;\r\n    }\n</style>");
$templateCache.put("app/main/pages/relatorios/movimentacaofinanceira/index.html","<div><servoticket-header titulo=\"Vendas por F. Pagamento\" locatario=\"relatorio.locatario\" evento=\"relatorio.evento\" \non-change-evento=\"relatorio.onSelectEvento()\" on-change-locatario=\"relatorio.onSelectLocatario()\"></servoticket-header>\n<md-divider></md-divider><servoticket-content><div style=\"background: #fff; padding: 20px;position:relative\"><div \nlayout=\"row\"><div layout=\"column\"><div layout=\"row\" layout-align=\"start center\"><span align=\"right\" \nstyle=\"width: 47px;margin-right: 10px\">Período:</span><md-select ng-model=\"relatorio.periodo\" \nng-change=\"relatorio.carregarDadosMovimentacao()\" style=\"margin-bottom: 10px; margin-top: 5px\"><md-option \nvalue=\"{{$index}}\" class=\"md-primary\" ng-repeat=\"periodo in relatorio.periodoItens\">{{periodo}}</md-option></md-select>\n</div></div><div layout=\"column\" ng-show=\"relatorio.periodo == 3\" layout-align=\"start center\" \nstyle=\"margin-left: 15px\"><div layout=\"row\" layout-align=\"start center\"><span style=\"margin-right: 10px\">De:</span>\n<md-datepicker md-open-on-focus ng-change=\"relatorio.carregarDadosMovimentacao()\" ng-model=\"relatorio.dataInicio\" \nmd-placeholder=\"Data início\"></md-datepicker><md-select ng-model=\"relatorio.horaInicio\" \nng-change=\"relatorio.carregarDadosMovimentacao()\" style=\"margin: 0px 10px 0px 10px\"><md-option value=\"{{ $index }}\" \nclass=\"md-primary\" ng-repeat=\"hora in [].constructor(24) track by $index\">{{$index}}h</md-option></md-select><md-select\n ng-model=\"relatorio.minutoInicio\" ng-change=\"relatorio.carregarDadosMovimentacao()\" style=\"margin: 0px 10px 0px 10px\">\n<md-option value=\"{{ minuto }}\" class=\"md-primary\" ng-repeat=\"minuto in relatorio.minutosInicio\">{{minuto}}min\n</md-option></md-select></div><div layout=\"row\" layout-align=\"start center\"><span style=\"margin-right: 10px\">Até:\n</span><md-datepicker md-open-on-focus ng-change=\"relatorio.carregarDadosMovimentacao()\" ng-model=\"relatorio.dataFim\" \nmd-placeholder=\"Data fim\"></md-datepicker><md-select ng-model=\"relatorio.horaFim\" \nng-change=\"relatorio.carregarDadosMovimentacao()\" style=\"margin: 0px 10px 0px 10px\"><md-option value=\"{{ $index }}\" \nclass=\"md-primary\" ng-repeat=\"hora in [].constructor(24) track by $index\">{{$index}}h</md-option></md-select><md-select\n ng-model=\"relatorio.minutoFim\" ng-change=\"relatorio.carregarDadosMovimentacao()\" style=\"margin: 0px 10px 0px 10px\">\n<md-option value=\"{{ minuto }}\" class=\"md-primary\" ng-repeat=\"minuto in relatorio.minutosFim\">{{minuto}}min</md-option>\n</md-select></div></div></div><br><div layout=\"row\"><div layout=\"column\"><div layout=\"row\" layout-align=\"start center\">\n<span align=\"right\" style=\"width: 47px;margin-right: 10px;margin-top: 5px\">POS:</span><md-input-container \nstyle=\"min-width: 250px;margin:0\" md-no-float><input ng-model=\"relatorio.pos\" placeholder=\"POS\" \nng-change=\"relatorio.carregarDadosMovimentacao()\" ng-model-options=\"{ debounce: 500 }\"></md-input-container></div>\n</div><div layout=\"column\"><div layout=\"row\" layout-align=\"start center\"><span align=\"right\" \nstyle=\"width: 100px;margin-left: 10px;margin-right: 10px; margin-top: 5px\">ID Movimento:</span><md-input-container \nstyle=\"min-width: 250px;margin:0\" md-no-float><input ng-model=\"relatorio.idAbertura\" \nplaceholder=\"Id Movimento Abertura\" ng-change=\"relatorio.carregarDadosMovimentacao()\" \nng-model-options=\"{ debounce: 500 }\"></md-input-container></div></div></div><md-fab-speed-dial md-direction=\"down\" \nmd-open=\"fabOpen\" class=\"md-scale md-mini\" ng-class=\"{ \'md-hover-full\': hover }\" \nng-mouseenter=\"fabOpen = !!relatorio.data.totalVendas.length && !relatorio.exporting\" ng-mouseleave=\"fabOpen = false\" \nstyle=\"position: absolute;right:5px;bottom: {{relatorio.data.totalVendas.length && !relatorio.exporting ? \'-200px\' : \'5px\'}}\">\n<md-fab-trigger><md-button class=\"md-fab md-warn\" \nng-disabled=\"!relatorio.data.totalVendas.length || relatorio.exporting\"><md-tooltip md-direction=\"left\" \nmd-visible=\"tooltipVisible\">Menu</md-tooltip><md-icon md-font-icon=\"icon-unfold-more\"></md-icon></md-button>\n</md-fab-trigger><md-fab-actions ng-hide=\"!relatorio.data.totalVendas.length || relatorio.exporting\"><md-button \nclass=\"md-fab md-raised md-mini\" ng-click=\"relatorio.exportarAnaliticoPdf()\"><md-tooltip md-direction=\"left\" \nmd-visible=\"tooltipVisible\" md-autohide=\"false\">Exportar pdf analítico</md-tooltip><md-icon \nmd-font-icon=\"icon-file-pdf-box\"></md-icon></md-button><md-button class=\"md-fab md-raised md-mini\" \nng-click=\"relatorio.exportarAnaliticoExcel()\"><md-tooltip md-direction=\"left\" md-visible=\"tooltipVisible\" \nmd-autohide=\"false\">Exportar excel analítico</md-tooltip><md-icon md-font-icon=\"icon-file-excel-box\"></md-icon>\n</md-button><md-button class=\"md-fab md-raised md-mini\" ng-click=\"relatorio.exportarSinteticoPdf()\"><md-tooltip \nmd-direction=\"left\" md-visible=\"tooltipVisible\" md-autohide=\"false\">Exportar pdf sintético</md-tooltip><md-icon \nmd-font-icon=\"icon-file-pdf\"></md-icon></md-button><md-button class=\"md-fab md-raised md-mini\" \nng-click=\"relatorio.exportarSinteticoExcel()\"><md-tooltip md-direction=\"left\" md-visible=\"tooltipVisible\" \nmd-autohide=\"false\">Exportar excel sintético</md-tooltip><md-icon md-font-icon=\"icon-file-excel\"></md-icon></md-button>\n</md-fab-actions></md-fab-speed-dial></div></servoticket-content></div><servoticket-content ng-show=\"relatorio.data\">\n<div style=\"padding: 20px 20px 10px 10px\"><canvas id=\"barChart\" style=\"width: 100%; height: 300px\" height=\"300\">\n</canvas></div></servoticket-content><servoticket-content ng-show=\"relatorio.data\"><div \nstyle=\"padding: 20px 20px 10px 10px\"><canvas id=\"pieChart\" style=\"width: 100%; height: 300px\" height=\"300\"></canvas>\n</div></servoticket-content><servoticket-content ng-show=\"relatorio.data\"><div style=\"background: #fff\"><table \nclass=\"results simple\" ms-responsive-table><thead><tr><th ng-click=\"relatorio.changeOrder(\'dsFormaPagRec\')\">\nForma de Pagamento<md-icon ng-show=\"relatorio.order == \'dsFormaPagRec\' && relatorio.reverse\" \nmd-font-icon=\"icon-chevron-up\"></md-icon><md-icon ng-show=\"relatorio.order == \'dsFormaPagRec\' && !relatorio.reverse\" \nmd-font-icon=\"icon-chevron-down\"></md-icon><md-icon ng-show=\"relatorio.order != \'dsFormaPagRec\'\" \nmd-font-icon=\"icon-unfold-more\"></md-icon></th><th ng-click=\"relatorio.changeOrder(\'total\')\">Total<md-icon \nng-show=\"relatorio.order == \'total\' && relatorio.reverse\" md-font-icon=\"icon-chevron-up\"></md-icon><md-icon \nng-show=\"relatorio.order == \'total\' && !relatorio.reverse\" md-font-icon=\"icon-chevron-down\"></md-icon><md-icon \nng-show=\"relatorio.order != \'total\'\" md-font-icon=\"icon-unfold-more\"></md-icon></th><th \nng-click=\"relatorio.changeOrder(\'porcentagemTotal\')\">% sobre as vendas<md-icon \nng-show=\"relatorio.order == \'porcentagemTotal\' && relatorio.reverse\" md-font-icon=\"icon-chevron-up\"></md-icon><md-icon \nng-show=\"relatorio.order == \'porcentagemTotal\' && !relatorio.reverse\" md-font-icon=\"icon-chevron-down\"></md-icon>\n<md-icon ng-show=\"relatorio.order != \'porcentagemTotal\'\" md-font-icon=\"icon-unfold-more\"></md-icon></th></tr></thead>\n<tbody><tr class=\"result-item\" \nng-repeat=\"item in relatorio.data.totalVendasFormaPagamento | orderBy: relatorio.order:relatorio.reverse\"><td>\n{{item.dsFormaPagRec}}</td><td>{{::relatorio.formatarValor(item.total)}}</td><td>{{item.porcentagemTotal.toFixed(2)}} %\n</td></tr><tr ng-show=\"relatorio.data.totalVendasFormaPagamento.length\"><td><b>TOTAL</b></td><td><b>\n{{relatorio.formatarValor(relatorio.totalValor)}}</b></td><td><b>100.00 %</b></td></tr></tbody></table></div>\n</servoticket-content><style>\ntable.results th:hover {\r\n        cursor:pointer;\r\n    }\r\n\r\n    md-input-container .md-errors-spacer {\r\n        min-height: 0 !important;\r\n    }\n</style>");
$templateCache.put("app/main/pages/relatorios/saldoestoque/index.html","<div><servoticket-header titulo=\"Saldo de estoque\" locatario=\"relatorio.locatario\" evento=\"relatorio.evento\" \non-change-evento=\"relatorio.onSelectEvento()\" on-change-locatario=\"relatorio.onSelectLocatario()\"></servoticket-header>\n<mat-divider></mat-divider><div layout=\"row\" layout-align=\"space-between center\" \nstyle=\"background: #fff; margin-top: 20px\"><div layout=\"row\" layout-align=\"space-between center\" layout-padding \nstyle=\"flex: 50%\"><div layout=\"row\" flex layout-align=\"start center\"><span layout-margin style=\"font-size:16px\">\nProduto:</span><md-input-container flex=\"40\" style=\"margin:0; margin-bottom: -22px\"><label>Descrição do produto</label>\n<input aria-label=\"Descrição do produto\" ng-disabled=\"!relatorio.evento\" ng-model=\"relatorio.search\" \nng-model-options=\"{ debounce: 450 }\" ng-change=\"relatorio.filter()\"></md-input-container></div></div><md-fab-speed-dial\n md-direction=\"down\" md-open=\"fabOpen\" class=\"md-scale md-mini\" ng-class=\"{ \'md-hover-full\': hover }\" \nng-mouseenter=\"fabOpen = !!relatorio.data.length && !relatorio.exporting\" ng-mouseleave=\"fabOpen = false\" \nstyle=\"position: relative;right:5px; top: 20px\"><md-fab-trigger><md-button class=\"md-fab md-warn\" \nng-disabled=\"!relatorio.data.length || relatorio.exporting\"><md-tooltip md-direction=\"left\" \nmd-visible=\"tooltipVisible\">Menu</md-tooltip><md-icon md-font-icon=\"icon-unfold-more\"></md-icon></md-button>\n</md-fab-trigger><md-fab-actions ng-hide=\"!relatorio.data.length || relatorio.exporting\"><md-button \nclass=\"md-fab md-raised md-mini\" ng-click=\"relatorio.exportarSinteticoPdf()\"><md-tooltip md-direction=\"left\" \nmd-visible=\"tooltipVisible\" md-autohide=\"false\">Exportar pdf</md-tooltip><md-icon md-font-icon=\"icon-file-pdf\">\n</md-icon></md-button><md-button class=\"md-fab md-raised md-mini\" ng-click=\"relatorio.exportarSinteticoExcel()\">\n<md-tooltip md-direction=\"left\" md-visible=\"tooltipVisible\" md-autohide=\"false\">Exportar excel</md-tooltip><md-icon \nmd-font-icon=\"icon-file-excel\"></md-icon></md-button></md-fab-actions></md-fab-speed-dial></div><servoticket-content \nng-show=\"relatorio.data\"><div style=\"padding: 20px 20px 10px 10px\"><canvas id=\"barChart\" \nstyle=\"width: 100%; height: 300px\" height=\"300\"></canvas></div></servoticket-content><servoticket-content \nng-show=\"relatorio.data\"><div style=\"background: #fff\"><table class=\"results simple\" ms-responsive-table><thead><tr>\n<th>Produto</th><th>Quantidade Entrada</th><th>Quantidade Saída</th><th>Saldo Atual</th></tr></thead><tbody><tr \nclass=\"result-item\" ng-repeat=\"item in relatorio.data\"><td>{{item.dsDescricao}}</td><td>{{item.qtdEntrada}}</td><td>\n{{item.qtdSaida}}</td><td>{{item.qtdSaldo}}</td></tr></tbody></table></div></servoticket-content></div>");
$templateCache.put("app/main/pages/relatorios/vendasprodutos/index.html","<div><servoticket-header titulo=\"Resumo de Vendas\" locatario=\"relatorio.locatario\" evento=\"relatorio.evento\" \non-change-evento=\"relatorio.onSelectEvento()\" on-change-locatario=\"relatorio.onSelectLocatario()\"></servoticket-header>\n<md-divider></md-divider><servoticket-content><div style=\"background: #fff; padding: 20px;position:relative\"><div \nlayout=\"row\"><div layout=\"column\"><div layout=\"row\" layout-align=\"start center\"><span align=\"right\" \nstyle=\"width: 47px;margin-right: 10px\">Período:</span><md-select ng-model=\"relatorio.periodo\" \nng-change=\"relatorio.carregarDadosVenda()\" style=\"margin-bottom: 10px; margin-top: 5px\"><md-option value=\"{{$index}}\" \nclass=\"md-primary\" ng-repeat=\"periodo in relatorio.periodoItens\">{{periodo}}</md-option></md-select></div></div><div \nlayout=\"column\" ng-show=\"relatorio.periodo == 3\" layout-align=\"start center\" style=\"margin-left: 15px\"><div \nlayout=\"row\" layout-align=\"start center\"><span style=\"margin-right: 10px\">De:</span><md-datepicker md-open-on-focus \nng-change=\"relatorio.carregarDadosVenda()\" ng-model=\"relatorio.dataInicio\" md-placeholder=\"Data início\">\n</md-datepicker><md-select ng-model=\"relatorio.horaInicio\" ng-change=\"relatorio.carregarDadosVenda()\" \nstyle=\"margin: 0px 10px 0px 10px\"><md-option value=\"{{ $index }}\" class=\"md-primary\" \nng-repeat=\"hora in [].constructor(24) track by $index\">{{$index}}h</md-option></md-select><md-select \nng-model=\"relatorio.minutoInicio\" ng-change=\"relatorio.carregarDadosVenda()\" style=\"margin: 0px 10px 0px 10px\">\n<md-option value=\"{{ minuto }}\" class=\"md-primary\" ng-repeat=\"minuto in relatorio.minutosInicio\">{{minuto}}min\n</md-option></md-select></div><div layout=\"row\" layout-align=\"start center\"><span style=\"margin-right: 10px\">Até:\n</span><md-datepicker md-open-on-focus ng-change=\"relatorio.carregarDadosVenda()\" ng-model=\"relatorio.dataFim\" \nmd-placeholder=\"Data fim\"></md-datepicker><md-select ng-model=\"relatorio.horaFim\" \nng-change=\"relatorio.carregarDadosVenda()\" style=\"margin: 0px 10px 0px 10px\"><md-option value=\"{{ $index }}\" \nclass=\"md-primary\" ng-repeat=\"hora in [].constructor(24) track by $index\">{{$index}}h</md-option></md-select><md-select\n ng-model=\"relatorio.minutoFim\" ng-change=\"relatorio.carregarDadosVenda()\" style=\"margin: 0px 10px 0px 10px\"><md-option\n value=\"{{ minuto }}\" class=\"md-primary\" ng-repeat=\"minuto in relatorio.minutosFim\">{{minuto}}min</md-option>\n</md-select></div></div></div><br><div layout=\"row\"><div layout=\"column\"><div layout=\"row\" layout-align=\"start center\">\n<span align=\"right\" style=\"width: 47px;margin-right: 10px;margin-top: 5px\">POS:</span><md-input-container \nstyle=\"min-width: 250px;margin:0\" md-no-float><input ng-model=\"relatorio.pos\" placeholder=\"POS\" \nng-change=\"relatorio.carregarDadosVenda()\" ng-model-options=\"{ debounce: 500 }\"></md-input-container></div></div><div \nlayout=\"column\"><div layout=\"row\" layout-align=\"start center\"><span align=\"right\" \nstyle=\"width: 100px;margin-left: 10px;margin-right: 10px; margin-top: 5px\">ID Movimento:</span><md-input-container \nstyle=\"min-width: 250px;margin:0\" md-no-float><input ng-model=\"relatorio.idAbertura\" \nplaceholder=\"Id Movimento Abertura\" ng-change=\"relatorio.carregarDadosVenda()\" ng-model-options=\"{ debounce: 500 }\">\n</md-input-container></div></div></div><br><div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"space-between center\"><md-switch ng-true-value=\"1\" ng-false-value=\"0\" \nng-model=\"relatorio.somenteCortesia\" ng-change=\"relatorio.carregarDadosVenda()\">Exibir somente cortesia</md-switch>\n</div><md-fab-speed-dial md-direction=\"down\" md-open=\"fabOpen\" class=\"md-scale md-mini\" \nng-class=\"{ \'md-hover-full\': hover }\" ng-mouseenter=\"fabOpen = !!relatorio.data.length && !relatorio.exporting\" \nng-mouseleave=\"fabOpen = false\" \nstyle=\"position: absolute;right:5px;bottom: {{relatorio.data.length && !relatorio.exporting ? \'-200px\' : \'5px\'}}\">\n<md-fab-trigger><md-button class=\"md-fab md-warn\" ng-disabled=\"!relatorio.data.length || relatorio.exporting\">\n<md-tooltip md-direction=\"left\" md-visible=\"tooltipVisible\">Menu</md-tooltip><md-icon md-font-icon=\"icon-unfold-more\">\n</md-icon></md-button></md-fab-trigger><md-fab-actions ng-hide=\"!relatorio.data.length || relatorio.exporting\">\n<md-button class=\"md-fab md-raised md-mini\" ng-click=\"relatorio.exportarAnaliticoPdf()\"><md-tooltip \nmd-direction=\"left\" md-visible=\"tooltipVisible\" md-autohide=\"false\">Exportar pdf analítico</md-tooltip><md-icon \nmd-font-icon=\"icon-file-pdf-box\"></md-icon></md-button><md-button class=\"md-fab md-raised md-mini\" \nng-click=\"relatorio.exportarAnaliticoExcel()\"><md-tooltip md-direction=\"left\" md-visible=\"tooltipVisible\" \nmd-autohide=\"false\">Exportar excel analítico</md-tooltip><md-icon md-font-icon=\"icon-file-excel-box\"></md-icon>\n</md-button><md-button class=\"md-fab md-raised md-mini\" ng-click=\"relatorio.exportarSinteticoPdf()\"><md-tooltip \nmd-direction=\"left\" md-visible=\"tooltipVisible\" md-autohide=\"false\">Exportar pdf sintético</md-tooltip><md-icon \nmd-font-icon=\"icon-file-pdf\"></md-icon></md-button><md-button class=\"md-fab md-raised md-mini\" \nng-click=\"relatorio.exportarSinteticoExcel()\"><md-tooltip md-direction=\"left\" md-visible=\"tooltipVisible\" \nmd-autohide=\"false\">Exportar excel sintético</md-tooltip><md-icon md-font-icon=\"icon-file-excel\"></md-icon></md-button>\n</md-fab-actions></md-fab-speed-dial></div></div></servoticket-content><servoticket-content ng-show=\"relatorio.data\">\n<div style=\"padding: 20px 20px 10px 10px\"><canvas id=\"myChart\" style=\"width: 100%; height: 300px\" height=\"300\">\n</canvas></div></servoticket-content><servoticket-content ng-show=\"relatorio.data\"><div style=\"background: #fff\"><table\n class=\"results simple\" ms-responsive-table><thead><tr><th ng-click=\"relatorio.changeOrder(\'produto\')\">Produto<md-icon \nng-show=\"relatorio.order == \'produto\' && relatorio.reverse\" md-font-icon=\"icon-chevron-up\"></md-icon><md-icon \nng-show=\"relatorio.order == \'produto\' && !relatorio.reverse\" md-font-icon=\"icon-chevron-down\"></md-icon><md-icon \nng-show=\"relatorio.order != \'produto\'\" md-font-icon=\"icon-unfold-more\"></md-icon></th><th \nng-click=\"relatorio.changeOrder(\'quantidade\')\">Quantidade<md-icon \nng-show=\"relatorio.order == \'quantidade\' && relatorio.reverse\" md-font-icon=\"icon-chevron-up\"></md-icon><md-icon \nng-show=\"relatorio.order == \'quantidade\' && !relatorio.reverse\" md-font-icon=\"icon-chevron-down\"></md-icon><md-icon \nng-show=\"relatorio.order != \'quantidade\'\" md-font-icon=\"icon-unfold-more\"></md-icon></th><th \nng-click=\"relatorio.changeOrder(\'porcentagemQuantidade\')\">% Quantidade<md-icon \nng-show=\"relatorio.order == \'porcentagemQuantidade\' && relatorio.reverse\" md-font-icon=\"icon-chevron-up\"></md-icon>\n<md-icon ng-show=\"relatorio.order == \'porcentagemQuantidade\' && !relatorio.reverse\" md-font-icon=\"icon-chevron-down\">\n</md-icon><md-icon ng-show=\"relatorio.order != \'porcentagemQuantidade\'\" md-font-icon=\"icon-unfold-more\"></md-icon></th>\n<th ng-click=\"relatorio.changeOrder(\'total\')\">Total<md-icon ng-show=\"relatorio.order == \'total\' && relatorio.reverse\" \nmd-font-icon=\"icon-chevron-up\"></md-icon><md-icon ng-show=\"relatorio.order == \'total\' && !relatorio.reverse\" \nmd-font-icon=\"icon-chevron-down\"></md-icon><md-icon ng-show=\"relatorio.order != \'total\'\" \nmd-font-icon=\"icon-unfold-more\"></md-icon></th><th ng-click=\"relatorio.changeOrder(\'porcentagemValor\')\">% Total<md-icon\n ng-show=\"relatorio.order == \'porcentagemValor\' && relatorio.reverse\" md-font-icon=\"icon-chevron-up\"></md-icon><md-icon\n ng-show=\"relatorio.order == \'porcentagemValor\' && !relatorio.reverse\" md-font-icon=\"icon-chevron-down\"></md-icon>\n<md-icon ng-show=\"relatorio.order != \'porcentagemValor\'\" md-font-icon=\"icon-unfold-more\"></md-icon></th></tr></thead>\n<tbody><tr class=\"result-item\" ng-repeat=\"item in relatorio.data | orderBy: relatorio.order:relatorio.reverse\"><td>\n{{item.produto}}</td><td>{{relatorio.formatarValor(item.quantidade, true)}}</td><td>\n{{item.porcentagemQuantidade.toFixed(2)}} %</td><td>{{item.total | monetario}}</td><td>\n{{item.porcentagemValor.toFixed(2)}} %</td></tr><tr ng-show=\"relatorio.data.length\"><td><b>TOTAL</b></td><td><b>\n{{relatorio.formatarValor(relatorio.totalQuantidade, true)}}</b></td><td><b>100%</b></td><td><b>\n{{relatorio.formatarValor(relatorio.totalValor)}}</b></td><td><b>100%</b></td></tr></tbody></table></div>\n</servoticket-content></div><style>\ntable.results th:hover {\r\n        cursor:pointer;\r\n    }\r\n\r\n    md-input-container .md-errors-spacer {\r\n        min-height: 0 !important;\r\n    }\n</style>");
$templateCache.put("app/main/pages/servoticket/eventos/index.html","<h1>{{vm.whoami}}</h1>");
$templateCache.put("app/main/pages/servoticket/locatarios/index.html","<h1>{{vm.whoami}}</h1>");
$templateCache.put("app/main/pages/servoticket/pos/index.html","<h1>{{vm.whoami}}</h1>");
$templateCache.put("app/main/pages/servoticket/usuarios/index.html","<h1>{{vm.whoami}}</h1>");
$templateCache.put("app/main/pages/sistema/ajuda/index.html","<servoticket-content layout=\"column\" layout-padding><div layout=\"column\" layout-align=\"start start\" flex \nstyle=\"padding: 30px 15px\"><span layout-margin style=\"font-size:18px\">Caracteres aceitos</span><div layout=\"column\" \nstyle=\"margin-left: 20px; margin-top: 15px\"><span style=\"margin-bottom: 10px\">- Letras sem acentos;</span> <span \nstyle=\"margin-bottom: 10px\">- Números;</span> <span style=\"margin-bottom: 10px\">- Espaços;</span> <span \nstyle=\"margin-bottom: 10px\">- Caracteres: @ ! # $ % & * ( ) ? ; : , / \" + = . - _</span></div></div><md-divider>\n</md-divider></servoticket-content>");
$templateCache.put("app/core/directives/ms-card/templates/template-1/template-1.html","<div class=\"template-1\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-2/template-2.html","<div class=\"template-2\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"text p-16\" ng-if=\"card.text\">{{card.text}}\n</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-10/template-10.html","<div class=\"template-10 p-16\"><div class=\"pb-16\" layout=\"row\" layout-align=\"space-between center\"><div class=\"info\">\n<div class=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle h2\" \nng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"media ml-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div><div \nclass=\"text\">{{card.text}}</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-3/template-3.html","<div class=\"template-3 p-16 teal-bg white-fg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" \nlayout-align=\"space-between\"><div class=\"info\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}</div><div \nclass=\"subtitle h3 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"cta\"><md-button \nclass=\"m-0\">{{card.cta}}</md-button></div></div><div class=\"media pl-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-4/template-4.html","<div class=\"template-4\"><div class=\"info white-fg ph-16 pv-24\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"text\" ng-if=\"card.text\">{{card.text}}</div></div><div class=\"media\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-5/template-5.html","<div class=\"template-5 p-16\" layout=\"row\" layout-align=\"space-between start\"><div class=\"info\"><div \nclass=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"event h2\" ng-if=\"card.event\">\n{{card.event}}</div></div><div class=\"media ml-16\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-6/template-6.html","<div class=\"template-6\"><div class=\"content pv-24 ph-16\"><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div><div class=\"title h2\" ng-if=\"card.title\">{{card.title}}</div><div class=\"text pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-8/template-8.html","<div class=\"template-8\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"buttons pt-16\"><md-button class=\"m-0\">{{card.button1}}</md-button><md-button class=\"m-0 md-accent\">\n{{card.button2}}</md-button></div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-9/template-9.html","<div class=\"template-9\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"text ph-16 pb-16\" ng-if=\"card.text\">{{card.text}}</div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div><div class=\"buttons m-8\"><md-button class=\"md-icon-button mr-16\" \naria-label=\"Favorite\"><md-icon md-font-icon=\"icon-heart-outline\" class=\"s24\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" aria-label=\"Share\"><md-icon md-font-icon=\"icon-share\" class=\"s24\"></md-icon></md-button></div>\n</div>");
$templateCache.put("app/core/directives/ms-card/templates/template-7/template-7.html","<div class=\"template-7\" layout=\"row\" layout-align=\"space-between\"><div class=\"info\" layout=\"column\" \nlayout-align=\"space-between\" layout-fill flex><div class=\"p-16\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"subtitle h4 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div><div class=\"text h4 pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div><div><md-divider></md-divider><div class=\"p-8\" layout=\"row\"><md-icon \nmd-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\">\n</md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" \nclass=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon></div></div></div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/horizontal/horizontal.html","<div class=\"ms-stepper-horizontal\"><div class=\"ms-stepper-navigation-wrapper\"><div class=\"ms-stepper-navigation\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(step.stepNumber), \'valid\': MsStepper.isStepValid(step.stepNumber), \'disabled\': MsStepper.isStepDisabled(step.stepNumber), \'optional\': MsStepper.isStepOptional(step.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(step.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(step.stepNumber)\" \nng-repeat=\"step in MsStepper.steps\" layout=\"row\" layout-align=\"start center\"><div class=\"step md-accent-bg\" \nlayout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(step.stepNumber) || MsStepper.isStepOptional(step.stepNumber)\">{{step.stepNumber}} \n</span><span ng-if=\"MsStepper.isStepValid(step.stepNumber) && !MsStepper.isStepOptional(step.stepNumber)\"><i \nclass=\"icon icon-check s18\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div class=\"title\">\n{{step.stepTitle}}</div><div class=\"subtitle\" ng-if=\"MsStepper.isStepOptional(step.stepNumber)\">Optional</div></div>\n</md-button></div></div><div class=\"ms-stepper-steps\" ng-transclude></div><div class=\"ms-stepper-controls\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" \nng-click=\"MsStepper.gotoPreviousStep()\">Back</md-button><div class=\"ms-stepper-dots\"><span \nng-repeat=\"step in MsStepper.steps\" ng-class=\"{\'selected md-accent-bg\':MsStepper.currentStepNumber === $index + 1}\">\n</span></div><md-button class=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div></div>");
$templateCache.put("app/main/pages/cadastros/evento/edicao/index.html","<servoticket-content layout=\"column\" layout-padding><form name=\"formEvento\" ng-submit=\"ctrl.salvar($event)\" novalidate \nlayout-padding><div layout=\"row\"><md-input-container flex><label>Locatário</label><input disabled=\"disabled\" \nng-model=\"ctrl.locatario\"></md-input-container></div><div layout=\"row\"><div layout=\"column\" flex><md-input-container>\n<label>Nome do Evento</label><input name=\"dsEvento\" maxlength=\"100\" required ng-model=\"ctrl.evento.dsEvento\" \nservoticket-texto></md-input-container></div><span style=\"width: 30px\"></span><div layout=\"column\" flex>\n<md-input-container><label>Local do Evento</label><input name=\"dsLocal\" maxlength=\"100\" ng-model=\"ctrl.evento.dsLocal\">\n</md-input-container></div></div><div layout=\"row\" layout-gt-md=\"row\"><div layout=\"row\" layout-gt-md=\"row\" flex=\"50\">\n<div layout=\"column\" flex><md-input-container style=\"min-width: 220px\"><label>Data de Início</label><md-datepicker \nmd-open-on-focus ng-model=\"ctrl.dtInicioEvento\" name=\"dtInicioEvento\" required md-placeholder=\"Data início\">\n</md-datepicker></md-input-container></div><div layout=\"column\" flex><md-input-container style=\"min-width: 220px\">\n<label>Data de Término</label><md-datepicker md-open-on-focus ng-model=\"ctrl.dtFinalEvento\" name=\"dtFinalEvento\" \nrequired md-placeholder=\"Data término\"></md-datepicker></md-input-container></div></div><span style=\"width: 30px\">\n</span></div><md-divider></md-divider><div layout=\"row\" layout-align=\"start start\"><div layout=\"column\" flex=\"50\"><span\n layout-margin style=\"font-size:16px; margin-top: 15px; margin-bottom: 25px\">POS do Evento</span><div \nstyle=\"max-height: 350px; overflow-y: scroll\" flex><table class=\"results simple\" ms-responsive-table><thead><tr><th>ID\n</th><th>Número de Série</th><th>Modelo</th><th>Excluir</th></tr></thead><tbody><tr class=\"result-item\" \nng-repeat=\"pos in ctrl.evento.regPos\"><td>{{pos.id}}</td><td>{{pos.dsNumeroSerie}}</td><td>{{pos.dsModelo}}</td><td>\n<span ng-click=\"ctrl.removePos(pos);\"><i class=\"icon icon-delete s23\"></i></span></td></tr></tbody></table></div><div \nlayout=\"row\" layout-align=\"end start\" style=\"margin-top: 12px\"><md-button class=\"md-raised md-primary md-accent\" \nstyle=\"padding-left: 25px; padding-right: 25px\" ng-click=\"ctrl.addPos($event);\">Incluir POS</md-button></div></div>\n</div><md-button type=\"submit\" ng-disabled=\"ctrl.saving\" class=\"md-accent md-fab md-fab-bottom-right\" \nstyle=\"padding: 0\">+</md-button></form></servoticket-content>");
$templateCache.put("app/main/pages/cadastros/evento/listagem/index.html","<servoticket-content layout=\"column\" layout-padding><div layout=\"row\" layout-align=\"start center\" flex><span \nlayout-margin style=\"font-size:16px; margin-right: 10px\">Locatário:</span><md-select flex=\"60\" placeholder=\"Locatário\" \nng-model=\"ctrl.locatario\" ng-change=\"ctrl.onSelectLocatario()\"><md-option \nng-selected=\"locatario.id == ctrl.locatario.id\" ng-value=\"locatario\" ng-repeat=\"locatario in ctrl.locatarios\">\n{{locatario.regPessoa.id}} - {{locatario.regPessoa.dsNome}} - {{locatario.regPessoa.dsCidade}} - {{locatario.regPessoa.sgEstado}}\n</md-option></md-select></div><md-divider></md-divider><div style=\"background: #fff\"><table \nclass=\"results simple clickable\" ms-responsive-table><thead><tr><th>ID</th><th>Nome</th><th>Data Início</th><th>\nData Término</th><th>Local</th></tr></thead><tbody><tr class=\"result-item\" ng-repeat=\"evento in ctrl.eventos\" \nng-click=\"ctrl.editar(evento);\"><td>{{evento.id}}</td><td>{{evento.dsEvento}}</td><td>\n{{evento.dtInicioEvento | date:\'dd/MM/yyyy\'}}</td><td>{{evento.dtFinalEvento | date:\'dd/MM/yyyy\'}}</td><td>\n{{evento.dsLocal}}</td></tr></tbody></table></div><md-button ng-disabled=\"!ctrl.locatario\" ng-click=\"ctrl.novo()\" \nclass=\"md-accent md-fab md-fab-bottom-right\">+</md-button></servoticket-content>");
$templateCache.put("app/main/pages/eventos/grupoprodutos/cadastro/index.html","<servoticket-content layout=\"column\" layout-padding><form name=\"ctrl.formGrupoProduto\" novalidate \nng-submit=\"ctrl.salvar($event)\" layout-padding><div layout=\"row\"><md-input-container flex><label>Locatário</label>\n<input disabled=\"disabled\" ng-model=\"ctrl.locatario\"></md-input-container></div><div layout=\"row\"><div layout=\"column\" \nflex><md-input-container><label>Nome do Grupo</label><input name=\"dsNomeGrupo\" maxlength=\"100\" required \nng-model=\"ctrl.grupo.dsNomeGrupo\"></md-input-container></div></div><md-button type=\"submit\" \nng-disabled=\"!ctrl.locatario || ctrl.saving\" class=\"md-accent md-fab md-fab-bottom-right\" style=\"padding: 0\">+\n</md-button></form></servoticket-content>");
$templateCache.put("app/main/pages/eventos/lancamentoestoque/cadastro/index.html","<servoticket-header titulo=\"Cadastro de Estoque\" locatario=\"lancamentos.locatario\" evento=\"lancamentos.evento\" \non-change-evento=\"lancamentos.onSelectEvento()\" on-change-locatario=\"lancamentos.onChangeLocatario()\">\n</servoticket-header><md-divider></md-divider><servoticket-content><span layout-margin style=\"font-size:20px\">\nSelecione o produto</span><div layout=\"row\" layout-align=\"space-between center\" style=\"background: #fff\" \nlayout-padding><div layout=\"row\" flex layout-align=\"start center\"><span layout-margin style=\"font-size:16px\">Produto:\n</span><md-input-container flex=\"40\" style=\"margin:0; margin-bottom: -22px\"><input aria-label=\"Descrição do produto\" \nng-disabled=\"!lancamentos.evento\" ng-model=\"lancamentos.search\" ng-model-options=\"{ debounce: 450 }\" \nng-change=\"lancamentos.filter()\"></md-input-container></div></div><md-divider></md-divider><div \nstyle=\"background: #fff\"><table class=\"results simple clickable\" ms-responsive-table><thead><tr><th>\nOrdem da Lista na Máquina</th><th>Produto</th><th>Valor</th><th>Imprime Ticket</th></tr></thead><tbody><tr \nclass=\"result-item\" ng-repeat=\"produto in lancamentos.produtos.data\" ng-click=\"lancamentos.onRowClick(produto)\"><td>\n{{produto.idCodigoVenda}}</td><td>{{produto.regProduto.dsDescricao}}</td><td>{{produto.vlPreco | currency: \'R$ \'}}</td>\n<td>{{produto.fgImprimeTicket ? \'Sim\' : \'Não\'}}</td></tr></tbody></table><md-table-pagination \nmd-limit=\"lancamentos.limit\" md-page=\"lancamentos.page\" md-total=\"{{ lancamentos.produtos.totalRegistros }}\" \nmd-limit-options=\"[4, 25, 50, 100]\" md-label=\"{{ lancamentos.pageLabels }}\" md-on-paginate=\"lancamentos.pageChanged\">\n</md-table-pagination></div></servoticket-content><servoticket-content><div style=\"padding: 0 0 20px 0\"><span \nlayout-margin style=\"font-size:20px\">Lançamento de estoque</span></div><md-divider></md-divider><div \nstyle=\"background: #fff; padding-bottom: 20px\"><table class=\"results simple clickable\" ms-responsive-table><thead><tr>\n<th>Operação</th><th>Produto</th><th>Quantidade</th><th>Excluir</th></tr></thead><tbody><tr class=\"result-item\" \nng-repeat=\"estoque in lancamentos.listaLancamentos\"><td>{{estoque.tipoOperacao.nome}}</td><td>\n{{estoque.regProduto.dsDescricao}}</td><td>{{estoque.nrQuantidade}}</td><td><span \nng-click=\"lancamentos.delete(estoque)\"><i class=\"icon icon-delete s23\"></i></span></td></tr></tbody></table></div>\n</servoticket-content><md-button ng-disabled=\"lancamentos.listaLancamentos.length == 0\" \nng-click=\"lancamentos.salvar()\" class=\"md-accent md-fab md-fab-bottom-right\">+</md-button>");
$templateCache.put("app/main/pages/eventos/produtos/cadastro/index.html","<servoticket-header titulo=\"Cadastro de Produtos\" locatario=\"produtos.locatario\" evento=\"produtos.evento\" \non-change-evento=\"produtos.onSelectEvento()\" on-change-locatario=\"produtos.onChangeLocatario()\"></servoticket-header>\n<md-divider></md-divider><servoticket-content layout=\"column\"><form name=\"produtos.formProduto\" novalidate \nng-submit=\"produtos.salvar($event)\" layout-padding><div layout=\"row\"><md-input-container flex=\"40\"><label>\nDescrição do Produto ({{produtos.produto.regProduto.dsDescricao.length || 0}} / 50)</label><input \nng-disabled=\"!produtos.evento\" maxlength=\"50\" ng-model=\"produtos.produto.regProduto.dsDescricao\" required>\n</md-input-container><md-input-container flex=\"40\"><label>\nPreço ({{produtos.produto.vlPreco.length || 0}} / 9) ex. 1234.56</label><input ng-disabled=\"!produtos.evento\" \nmaxlength=\"9\" ng-model=\"produtos.produto.vlPreco\" required></md-input-container></div><div layout=\"row\">\n<md-input-container flex=\"40\"><label>\nDescrição Resumida/Impressão Máquina ({{produtos.produto.dsDescricaoDisplayPos.length || 0}} / 15)</label><input \nng-disabled=\"!produtos.evento\" maxlength=\"15\" ng-model=\"produtos.produto.dsDescricaoDisplayPos\" servoticket-texto>\n</md-input-container><md-input-container flex=\"40\"><label>Ordem da Lista na Máquina</label><input id=\"idCodigoVenda\" \nng-disabled=\"!produtos.evento\" ng-model=\"produtos.produto.idCodigoVenda\"></md-input-container></div><div layout=\"row\">\n<md-input-container flex=\"40\"><label>\nDescrição Impressão Linha 1 ({{produtos.produto.dsDescricaoImpressaoLinhaUm.length || 0}} / 100)</label><input \nng-disabled=\"!produtos.evento\" maxlength=\"100\" ng-model=\"produtos.produto.dsDescricaoImpressaoLinhaUm\" \nservoticket-texto></md-input-container><md-input-container flex=\"40\"><label>\nDescrição Impressão Linha 2 ({{produtos.produto.dsDescricaoImpressaoLinhaDois.length || 0}} / 100)</label><input \nng-disabled=\"!produtos.evento\" maxlength=\"100\" ng-model=\"produtos.produto.dsDescricaoImpressaoLinhaDois\" \nservoticket-texto></md-input-container></div><div layout=\"row\"><md-input-container flex=\"20\"><label>Tipo de Impressão\n</label><md-select ng-disabled=\"!produtos.evento\" ng-model=\"produtos.produto.tpImpressaoTicket\"><md-option value=\"0\">\nAmbos</md-option><md-option value=\"1\">Somente Descrição</md-option><md-option value=\"2\">Somente Valor</md-option>\n</md-select></md-input-container><md-input-container flex=\"20\"><label>Número de vias de impressão</label><input \nng-disabled=\"!produtos.evento\" type=\"number\" ng-model=\"produtos.produto.nrViasTicket\"></md-input-container>\n<md-input-container flex=\"40\"><label>Grupo do Produto</label><md-select \nng-required=\"produtos.evento.fgGerarContabil === 1\" ng-model=\"produtos.grupo\" ng-disabled=\"!produtos.locatario\" \nng-change=\"produtos.onSelectGrupo()\"><md-option ng-selected=\"grupo.id == produtos.grupo.id\" ng-value=\"grupo\" \nng-repeat=\"grupo in produtos.grupos\">{{grupo.dsNomeGrupo}}</md-option></md-select></md-input-container></div><div \nlayout=\"row\"><md-switch ng-true-value=\"1\" ng-false-value=\"0\" ng-disabled=\"!produtos.evento\" \nng-model=\"produtos.produto.fgAtivo\" aria-label=\"Ativo\">Ativo</md-switch><md-switch ng-true-value=\"1\" \nng-false-value=\"0\" ng-disabled=\"!produtos.evento\" ng-model=\"produtos.produto.fgImprimeTicket\" \naria-label=\"Imprime Ticket na Venda\">Imprime Ticket na Venda</md-switch><md-switch ng-true-value=\"1\" \nng-false-value=\"0\" ng-disabled=\"!produtos.evento\" ng-model=\"produtos.produto.fgSolicitaPreco\" \naria-label=\"Solicita preço na venda\">Solicita preço na venda</md-switch><md-switch ng-true-value=\"1\" \nng-false-value=\"0\" ng-disabled=\"!produtos.evento\" ng-model=\"produtos.produto.fgEstoque\" aria-label=\"Controla estoque\">\nControla estoque</md-switch></div><md-button ng-disabled=\"!produtos.evento || produtos.saving\" type=\"submit\" \nng-disabled=\"!produtos.evento\" class=\"md-accent md-fab md-fab-bottom-right\" style=\"padding: 0\">+</md-button></form>\n</servoticket-content>");
$templateCache.put("app/main/pages/sistema/arquivoupload/detalhes/index.html","<div><div layout=\"column\" style=\"background: #fff\"><div layout=\"row\" layout-align=\"space-between center\" \nlayout-padding><h1>Logs de processamento</h1></div></div><md-divider></md-divider><servoticket-content layout-padding>\n<div class=\"item-detalhes\"><label>Data:</label><strong>{{ controller.data.dhSincronismo | date:\'dd/MM/yyyy HH:mm\'}}\n</strong></div><div class=\"item-detalhes\"><label>Número de Série:</label><strong>\n{{ controller.data.regPos.dsNumeroSerie }}</strong></div><div class=\"item-detalhes\"><label>Operação:</label><strong>\n{{ controller.data.dsOperacao }}</strong></div><div class=\"item-detalhes\"><label>Arquivo:</label><strong>\n{{ controller.data.dsNomeArquivo }}</strong></div><div class=\"item-detalhes\"><label>Status:</label><strong><span \nng-if=\"controller.data.fgStatus === 0\">Pendente</span> <span ng-if=\"controller.data.fgStatus === 1\">Pendente com erros\n</span> <span ng-if=\"controller.data.fgStatus === 2\">Processando</span> <span ng-if=\"controller.data.fgStatus === 3\">\nConcluído</span></strong></div></servoticket-content><servoticket-content><div style=\"background: #fff\"><table \nclass=\"results simple\" ms-responsive-table><thead><tr><th ng-click=\"controller.changeOrder(\'dhStatus\')\">Data<md-icon \nng-show=\"controller.order == \'dhStatus\' && !controller.reverse\" md-font-icon=\"icon-chevron-up\"></md-icon><md-icon \nng-show=\"controller.order == \'dhStatus\' && controller.reverse\" md-font-icon=\"icon-chevron-down\"></md-icon><md-icon \nng-show=\"controller.order != \'dhStatus\'\" md-font-icon=\"icon-unfold-more\"></md-icon></th><th \nng-click=\"controller.changeOrder(\'fgStatus\')\">Status<md-icon \nng-show=\"controller.order == \'fgStatus\' && !controller.reverse\" md-font-icon=\"icon-chevron-up\"></md-icon><md-icon \nng-show=\"controller.order == \'fgStatus\' && controller.reverse\" md-font-icon=\"icon-chevron-down\"></md-icon><md-icon \nng-show=\"controller.order != \'fgStatus\'\" md-font-icon=\"icon-unfold-more\"></md-icon></th><th \nng-click=\"controller.changeOrder(\'dsDetalhe\')\">Mensagem<md-icon \nng-show=\"controller.order == \'dsDetalhe\' && !controller.reverse\" md-font-icon=\"icon-chevron-up\"></md-icon><md-icon \nng-show=\"controller.order == \'dsDetalhe\' && controller.reverse\" md-font-icon=\"icon-chevron-down\"></md-icon><md-icon \nng-show=\"controller.order != \'dsDetalhe\'\" md-font-icon=\"icon-unfold-more\"></md-icon></th></tr></thead><tbody><tr \nclass=\"result-item\" ng-repeat=\"item in controller.detalhes | orderBy: controller.order:controller.reverse\"><td>\n{{item.dhStatus | date:\'dd/MM/yyyy HH:mm\'}}</td><td><span ng-if=\"item.fgStatus === 0\">OK</span> <span \nng-if=\"item.fgStatus === 1\">Erro</span> <span ng-if=\"item.fgStatus === 2\">Enviado</span></td><td>{{item.dsDetalhe}}\n</td></tr></tbody></table></div></servoticket-content></div><style>\nmd-input-container .md-errors-spacer {\r\n        min-height: 0 !important;\r\n    }\r\n\r\n    .item-detalhes {\r\n        margin: 6px;\r\n    }\n</style>");
$templateCache.put("app/main/pages/sistema/arquivoupload/listagem/index.html","<div><div layout=\"column\" style=\"background: #fff\"><div layout=\"row\" layout-align=\"space-between center\" \nlayout-padding><h1>Arquivos enviados</h1></div></div><md-divider></md-divider><servoticket-content><div \nstyle=\"background: #fff; padding: 20px;position:relative\"><div layout=\"row\"><div layout=\"column\"><div layout=\"row\" \nlayout-align=\"start center\"><span align=\"right\" style=\"width: 47px;margin-right: 10px\">Período:</span><md-select \nng-model=\"controller.periodo\" ng-change=\"controller.carregarArquivosUpload()\" \nstyle=\"margin-bottom: 10px; margin-top: 5px\"><md-option value=\"{{$index}}\" class=\"md-primary\" \nng-repeat=\"periodo in controller.periodoItens\">{{periodo}}</md-option></md-select></div></div><div layout=\"column\" \nng-show=\"controller.periodo == 3\" layout-align=\"start center\" style=\"margin-left: 15px\"><div layout=\"row\" \nlayout-align=\"start center\"><span style=\"margin-right: 10px\">De:</span><md-datepicker md-open-on-focus \nng-change=\"controller.carregarArquivosUpload()\" ng-model=\"controller.dataInicio\" md-placeholder=\"Data início\">\n</md-datepicker><md-select ng-model=\"controller.horaInicio\" ng-change=\"controller.carregarArquivosUpload()\" \nstyle=\"margin: 0px 10px 0px 10px\"><md-option value=\"{{ $index }}\" class=\"md-primary\" \nng-repeat=\"hora in [].constructor(24) track by $index\">{{$index}}h</md-option></md-select><md-select \nng-model=\"controller.minutoInicio\" ng-change=\"controller.carregarArquivosUpload()\" style=\"margin: 0px 10px 0px 10px\">\n<md-option value=\"{{ minuto }}\" class=\"md-primary\" ng-repeat=\"minuto in controller.minutosInicio\">{{minuto}}min\n</md-option></md-select></div><div layout=\"row\" layout-align=\"start center\"><span style=\"margin-right: 10px\">Até:\n</span><md-datepicker md-open-on-focus ng-change=\"controller.carregarArquivosUpload()\" ng-model=\"controller.dataFim\" \nmd-placeholder=\"Data fim\"></md-datepicker><md-select ng-model=\"controller.horaFim\" \nng-change=\"controller.carregarArquivosUpload()\" style=\"margin: 0px 10px 0px 10px\"><md-option value=\"{{ $index }}\" \nclass=\"md-primary\" ng-repeat=\"hora in [].constructor(24) track by $index\">{{$index}}h</md-option></md-select><md-select\n ng-model=\"controller.minutoFim\" ng-change=\"controller.carregarArquivosUpload()\" style=\"margin: 0px 10px 0px 10px\">\n<md-option value=\"{{ minuto }}\" class=\"md-primary\" ng-repeat=\"minuto in controller.minutosFim\">{{minuto}}min\n</md-option></md-select></div></div></div><br><div layout=\"column\" layout-lg=\"row\" \nlayout-align-lg=\"space-between center\" layout-align=\" center\" style=\"margin-right: 200px\"><div layout=\"row\" \nlayout-align-lg=\"space-between center\" layout-align=\"start center\"><span align=\"right\" \nstyle=\"width: 47px;margin-right: 10px;margin-top: 5px\">POS:</span><md-input-container \nstyle=\"min-width: 250px;margin:0\" md-no-float><input ng-model=\"controller.pos\" placeholder=\"POS\" \nng-change=\"controller.carregarArquivosUpload()\" ng-model-options=\"{ debounce: 500 }\"></md-input-container></div></div>\n</div></servoticket-content><servoticket-content><div style=\"background: #fff\"><table class=\"results simple clickable\" \nms-responsive-table><thead><tr><th ng-click=\"controller.changeOrder(\'dhSincronismo\')\">Data<md-icon \nng-show=\"controller.order == \'dhSincronismo\' && !controller.reverse\" md-font-icon=\"icon-chevron-up\"></md-icon><md-icon \nng-show=\"controller.order == \'dhSincronismo\' && controller.reverse\" md-font-icon=\"icon-chevron-down\"></md-icon><md-icon\n ng-show=\"controller.order != \'dhSincronismo\'\" md-font-icon=\"icon-unfold-more\"></md-icon></th><th \nng-click=\"controller.changeOrder(\'regPos.dsNumeroSerie\')\">Número de Série<md-icon \nng-show=\"controller.order == \'regPos.dsNumeroSerie\' && !controller.reverse\" md-font-icon=\"icon-chevron-up\"></md-icon>\n<md-icon ng-show=\"controller.order == \'regPos.dsNumeroSerie\' && controller.reverse\" md-font-icon=\"icon-chevron-down\">\n</md-icon><md-icon ng-show=\"controller.order != \'regPos.dsNumeroSerie\'\" md-font-icon=\"icon-unfold-more\"></md-icon></th>\n<th ng-click=\"controller.changeOrder(\'dsOperacao\')\">Operação<md-icon \nng-show=\"controller.order == \'dsOperacao\' && !controller.reverse\" md-font-icon=\"icon-chevron-up\"></md-icon><md-icon \nng-show=\"controller.order == \'dsOperacao\' && controller.reverse\" md-font-icon=\"icon-chevron-down\"></md-icon><md-icon \nng-show=\"controller.order != \'dsOperacao\'\" md-font-icon=\"icon-unfold-more\"></md-icon></th><th \nng-click=\"controller.changeOrder(\'dsNomeArquivo\')\">Arquivo<md-icon \nng-show=\"controller.order == \'dsNomeArquivo\' && !controller.reverse\" md-font-icon=\"icon-chevron-up\"></md-icon><md-icon \nng-show=\"controller.order == \'dsNomeArquivo\' && controller.reverse\" md-font-icon=\"icon-chevron-down\"></md-icon><md-icon\n ng-show=\"controller.order != \'dsNomeArquivo\'\" md-font-icon=\"icon-unfold-more\"></md-icon></th><th \nng-click=\"controller.changeOrder(\'fgStatus\')\">Status<md-icon \nng-show=\"controller.order == \'fgStatus\' && !controller.reverse\" md-font-icon=\"icon-chevron-up\"></md-icon><md-icon \nng-show=\"controller.order == \'fgStatus\' && controller.reverse\" md-font-icon=\"icon-chevron-down\"></md-icon><md-icon \nng-show=\"controller.order != \'fgStatus\'\" md-font-icon=\"icon-unfold-more\"></md-icon></th></tr></thead><tbody><tr \nclass=\"result-item\" ng-repeat=\"item in controller.data | orderBy: controller.order:controller.reverse\" \nng-click=\"controller.detalharItem(item);\"><td>{{item.dhSincronismo | date:\'dd/MM/yyyy HH:mm\'}}</td><td>\n{{item.regPos.dsNumeroSerie}}</td><td>{{item.dsOperacao}}</td><td>{{item.dsNomeArquivo}}</td><td><span \nng-if=\"item.fgStatus === 0\">Pendente</span> <span ng-if=\"item.fgStatus === 1\">Pendente com erros</span> <span \nng-if=\"item.fgStatus === 2\">Processando</span> <span ng-if=\"item.fgStatus === 3\">Concluído</span></td></tr></tbody>\n</table></div></servoticket-content></div><style>\nmd-input-container .md-errors-spacer {\r\n        min-height: 0 !important;\r\n    }\r\n    \r\n    table.results th:hover {\r\n        cursor:pointer;\r\n    }\n</style>");
$templateCache.put("app/main/pages/cadastros/evento/edicao/pos/index.html","<md-dialog style=\"background-color: #fff\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Selecionar POS</h2></div>\n</md-toolbar><div layout=\"row\" class=\"md-dialog-content\"><md-input-container flex style=\"margin-right: 12px\"><label>\nDigite número de série e tecle Enter</label><input ng-model=\"modal.filtro\" ng-keyup=\"modal.keyUp($event);\">\n</md-input-container><md-switch ng-model=\"modal.exibirTodos\" ng-change=\"modal.exibirTodosChanged();\">Exibir todos\n</md-switch></div><md-divider ng-style=\"{\'margin-top\': (modal.pos.length > 3) ? \'60px\' : \'0px\'}\"></md-divider>\n<md-dialog-content style=\"padding: 0; margin-top: 10px\"><div class=\"md-dialog-content\"><table \nclass=\"results simple clickable\" ms-responsive-table><thead><tr><th><md-switch ng-model=\"modal.marcarTodos\" \nng-change=\"modal.selecionarTodos();\"></md-switch></th><th>ID</th><th>Número de Série</th><th>Modelo</th></tr></thead>\n<tbody><tr class=\"result-item\" ng-repeat=\"pos in modal.pos\" ng-click=\"pos.selected = !pos.selected;\"><td><md-switch \nng-model=\"pos.selected\" ng-change=\"pos.selected = !pos.selected;\"></md-switch></td><td>{{pos.id}}</td><td>\n{{pos.dsNumeroSerie}}</td><td>{{pos.dsModelo}}</td></tr></tbody></table></div></md-dialog-content><md-dialog-actions \nstyle=\"margin-top: 12px; margin-bottom: 12px\"><div layout=\"row\" flex layout-align=\"end center\"><md-button \nclass=\"md-fab\" ng-click=\"modal.cancelar();\"><md-tooltip>Cancelar</md-tooltip><md-icon md-font-icon=\"icon-arrow-left\">\n</md-icon></md-button><md-button class=\"md-fab\" ng-click=\"modal.salvar();\" md-colors=\"{background: \'green\'}\">\n<md-tooltip>Salvar</md-tooltip><md-icon md-font-icon=\"icon-check\"></md-icon></md-button></div></md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/main/pages/eventos/lancamentoestoque/cadastro/modal/index.html","<md-dialog style=\"background-color: #fff; width: 50%\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>\nLançamento estoque produto</h2></div></md-toolbar><md-dialog-content style=\"padding: 0; margin-top: 10px\"><span \nlayout-margin style=\"font-size:16px\">Produto: {{ produto.regProduto.dsDescricao }}</span><div \nstyle=\"display: flex; align-items: center\"><span layout-margin style=\"font-size: 16px\">Operação:</span><md-select flex \nplaceholder=\"Tipo Operação\" ng-model=\"tipoOperacao\"><md-option ng-selected=\"tipo.id == tipoOperacao.id\" \nng-value=\"tipo\" ng-repeat=\"tipo in tipoOperacaoList\">{{tipo.nome}}</md-option></md-select></div><div \nstyle=\"display: flex; align-items: center\"><span layout-margin style=\"font-size:16px\">Quantidade:</span>\n<md-input-container><input type=\"number\" ng-model=\"quantidade\" placeholder=\"Quantidade\"></md-input-container></div>\n</md-dialog-content><md-dialog-actions style=\"margin-top: 12px; margin-bottom: 12px\"><div layout=\"row\" flex \nlayout-align=\"end center\"><md-button class=\"md-fab\" ng-click=\"fecharModal();\"><md-tooltip>Cancelar</md-tooltip><md-icon\n md-font-icon=\"icon-arrow-left\"></md-icon></md-button><md-button class=\"md-fab\" ng-click=\"confirmarModal()\" \nstyle=\"background-color: green\" ng-disabled=\"!habilitaConfirma()\"><md-tooltip>Salvar</md-tooltip><md-icon \nmd-font-icon=\"icon-check\"></md-icon></md-button></div></md-dialog-actions></md-dialog>");}]);